import * as React from "react"
import styled from "styled-components"

const Svg = styled.svg`

width: 100%;
height: fit-content;
`
function SvgComponent(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={577}

      viewBox="0 0 577 382"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2C2D"
        d="M53.96 172.008l1.049-1.065c1.286-.789 2.583-1.54 4.184-1.389 20.196.022 40.388-.007 60.581.02 2.309.003 4.638-.22 6.914.376 2.578 1.084 1.255 2.54.292 3.851-2.68 3.647-5.986 6.56-10.192 8.371-15.285.585-30.574.098-45.86.285-2.127.026-4.342-.44-6.319.794-1.576 1.666-1.147 3.756-1.148 5.705-.024 51.388-.025 102.776.001 154.164.001 1.943-.46 4.042 1.204 5.641 1.858 1.045 3.89.793 5.873.796 10.322.019 20.644-.01 30.966.022 1.982.006 4.011-.231 5.896.699 1.604 1.245.564 2.232-.311 3.239-.56.366-1.17.608-1.824.738-15.776.942-31.566.337-47.353.328-1.503-.001-2.981-.322-4.195-1.347-1.244-1.561-1.138-3.432-1.138-5.249-.021-56.716-.062-113.432.012-170.146 0-.501.079-.995.131-1.486-.181-1.616.294-3.048 1.237-4.347z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B0B0B0"
        d="M23.017 425.949c-3.861-4.037-1.674-7.557.946-11.038 3.331 1.271 6.801 1.388 10.315 1.386 33.309-.023 66.617-.022 99.926-.003 2.985.002 6.013-.249 8.882.934 2.113 1.495 4.493 2.035 7.05 2.03 42.345-.086 84.69.334 127.035-.243 37.219.61 74.438.08 111.656.278 2.959.017 6.011-.444 8.791 1.104 1.877 3.116-.699 3.886-2.67 4.639-1.791.684-3.797.478-5.72.428-7.971.32-16.059-1.155-23.882 1.519-2.295.478-4.584.621-6.846-.179-4.548-2.694-9.533-.891-14.303-1.369-5.79-.005-11.574-.004-17.36.014a5706.73 5706.73 0 00-24.826.003c-11.765-.028-23.529-.004-35.289-.005-4.977.181-9.99-.542-14.94.533-2.345.105-4.67-.188-7.005-.374-20.996-.388-41.99-.073-62.982-.146-1.915-.207-3.743.67-5.66.47-2.615-.684-5.288-.477-7.94-.478-46.711-.012-93.422-.009-140.125-.003-1.702-.078-3.374.25-5.053.5z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#898989"
        d="M367.986 369.038l1.119 1.916c-.1 1.02-.346 1.95-1.447 2.357-.785.031-1.494-.214-2.178-.569-6.229-.05-12.64-1.977-18.471 1.921-.527.353-1.277.097-1.914-.073-5.721-3.706-11.92-2.032-18.006-1.596-1.7 1.408-3.502 2.201-5.641.928-6.256-2.027-12.482-3.078-18.578.54-1.542.733-2.979.286-4.397-.378-6.142-.785-12.279-1.546-18.337.53a4.411 4.411 0 01-2.983.061c-6.003-2.683-12.292-.453-18.415-1.051-1.535.783-3.052 1.673-4.869.886-6.132-3.209-12.327-3.243-18.574-.354a3.433 3.433 0 01-1.275.587c-1.521.255-2.645-.769-3.945-1.225-5.714.358-11.479-.844-17.15.617a5.54 5.54 0 01-1.331.596c-1.901.544-3.326-.836-5.001-1.221-5.714.276-11.518-1.154-17.122.979a4.489 4.489 0 01-3.17.202 4.903 4.903 0 01-1.381-.765c-5.58-2.553-11.285-1.763-17-.625-1.82 1.238-3.668 2.208-5.777.593-5.506-2.739-11.211-1.406-16.876-.821-1.326.695-2.494 1.844-4.194 1.484-.751-.201-1.423-.563-2.043-1.024-6.108-1.657-12.162-2.409-17.978 1.033a3.882 3.882 0 01-2.294.126c-5.601-4.11-11.96-1.766-17.993-2.095-.835.305-1.445.913-2.024 1.558-.399.479-.842.916-1.312 1.325a10.092 10.092 0 00-2.034 2.297c-1.204 1.435-2.411 2.913-3.977.368a3.937 3.937 0 01-.017-1.254c.158-.954.688-1.854.427-2.864-4.862-1.334-9.726-.755-14.579-.242-.748.455-1.316 1.112-1.911 1.739-1.355 1.181-1.97 3.013-3.523 4.023-1.246.435-2.344.314-3.167-.841-.494-1.171-.173-2.307.145-3.441.125-.431.3-.845.504-1.244-.203-.547 1.85-1.146-.085-1.639-4.451.166-8.887-.352-13.289.361-.911.332-1.831.629-2.794.78-.5.025-.978-.068-1.437-.268-.996-.869-1.774-1.786-.635-3.095l1.9-2.313c.446-.842 1.006-1.579 1.873-2.036 10.147-2.417 20.348-1.859 30.568-.509 1.907 1.308 4.082 1.265 6.253 1.247 77.22-.617 154.44-.093 231.66-.275 10.953-.025 21.711-3.149 32.754-2.031 3.296.334 6.661-.028 9.901.939 2.091.541 1.074 2.712 2.02 3.856z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A2A2A2"
        d="M381.979 391.064c2.401 3.429 4.859 6.825 6.12 10.895-1.38 2.934-4.121 2.445-6.534 2.446-35.651.008-71.303.141-106.953-.038a15.878 15.878 0 01-1.96-.191c-1.771-.456-3.549-.747-5.402-.746-38.704.021-77.409-.007-116.113.03-.665.001-1.327.063-1.981.184-1.254.388-2.539.591-3.842.7-35.365.207-70.73.096-106.095.015-2.764-.007-6.933.969-6.234-4.396.84-3.784 3.483-6.616 5.238-9.917 2.047.137 2.273 1.684 2.509 3.226-.023.49-.124.971-.282 1.434-1.225 2.606-.076 3.823 2.488 3.818 5.095-.008 10.225.616 15.271-.643 1.778-.69 3.385.194 5.055.52 4.408.323 8.818.071 13.225.144 2.848.047 5.146-.778 6.312-3.627.248-.483.58-.895.99-1.247 1.005-.582 2.026-.625 3.058-.097.403.329.665.755.786 1.262.177 1.534-.402 3.729 2.134 3.651 5.373-.165 10.877 1.322 16.076-1.153.725-.567 1.384-1.229 2.255-1.586 1.819.046 2.027 2.469 3.818 2.557 6.32.466 12.634.149 18.944.146 2.065-.002 4.032-.385 4.717-2.809.095-.507.24-.996.409-1.481.678-1.672 1.13-3.486 2.8-4.546.752-.299 1.488-.281 2.2.127.897 1.402.309 2.843.117 4.272-.289 1.851-1.509 4.057 1.791 4.517 36.715.119 73.407-.109 110.075-.22 1.42-.17 3.079-.132 2.021-2.422a4.906 4.906 0 01-.453-1.219c-.092-1.17.127-2.286.51-3.382 2.661-3.483 2.695.208 3.678 1.336.163.434.278.886.364 1.34.303 1.422-.06 3.124 1.688 3.932 6.861 1.438 13.781.406 20.662.611 2.405.071 3.105-1.402 2.98-3.533a2.337 2.337 0 01.706-1.391c1.311-.756 2.615-.725 3.913.006.409.349.73.773.97 1.253.335.746.465 1.634 1.075 2.218 2.881 2.756 16.035 1.944 18.908-1.154 1.283-2.16 3.412-2.231 5.565-2.313 3.575-.134 7.169.287 10.726-.348 1.085-.33 2.188-.354 3.3-.188 2.231.717 4.771.508 6.706 2.151a7.56 7.56 0 011.088 1.028c5.476 4.161 11.748 1.945 17.699 2.114 1.828.052 1.808-2.108 2.626-3.273 2.033-2.044 4.646-1.391 7.07-1.479 4.47-.162 8.949.19 13.407-.225 1.524-.336 2.347-1.842 3.799-2.309z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DBDBDB"
        d="M33.992 430.968l-8.088-3.173c.61-2.335 2.604-1.938 4.279-2.175 4.043-.165 7.943 1.492 12.02.951 2.977.086 5.966-.189 8.925.349 3.582 1.148 7.274.636 10.911.611 5.494-.037 10.956.146 16.389 1.011 17.097.668 34.16 1.896 51.275 2.322 6.944.174 13.932.441 20.899.704 36.265 1.368 72.549 1.249 108.821.883 23.09-.232 46.19-1.034 69.257-2.1 9.903-.458 19.895-.745 29.736-2.339 4.411-1.052 9.013.3 13.402-1.058 2.304-.495 4.646-.315 6.973-.38 6.445.021 12.731-1.892 19.2-1.589-2.722 5.8-8.716 5.281-13.554 6.967-.729.254-1.621.044-2.437.048-13.445 2.134-26.995 2.99-40.585 3.472-48.398 1.716-96.813 2.372-145.233 1.883-25.284-.256-50.575-.594-75.853-1.376-15.111-.468-30.235-.824-45.322-1.684-12.073-.688-24.223-1.036-36.155-3.414-1.629-.324-3.254-.777-4.86.087z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7E7E7"
        d="M33.992 430.968c5.86-2.376 11.828-.121 17.525.404 7.412.684 14.895.844 22.277 1.296 10.067.616 20.205 1.09 30.312 1.473 17.106.649 34.231.262 51.308.995 43.402 1.864 86.809.716 130.205.577 12.908-.041 25.908-.007 38.821-.813 14.229-.89 28.477-1.223 42.695-2.07 4.947-.294 9.893-.81 14.866-.828-8.446 2.769-17.132 3.984-26.002 4.001-4.933 1.379-10.077-.428-15.007.995l-12.992.003c-7.373 1.078-14.79.182-22.178.508-1.945.086-3.959-.51-5.83.489l-31.995.008c-1.051.711-2.246.474-3.389.475-24.406.012-48.812.012-73.218 0-1.143-.001-2.337.236-3.389-.475l-33.995-.008c-6.87-1.151-13.793-.171-20.681-.525-2.442-.125-4.939.542-7.325-.467l-15.995-.008c-4.863-1.106-9.797-.195-14.687-.521-1.775-.118-3.619.462-5.321-.477l-8.993-.003c-5.262-1.464-10.736.434-16.004-.997-10.55.301-20.667-2.729-31.008-4.032z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ABABAB"
        d="M142.982 418.007c-37.889-.002-75.777.01-113.666-.043-2.214-.003-5.42 1.188-5.353-3.052.418-2.009 1.229-3.776 3.024-4.942 35.811.708 71.626.118 107.438.329 2.979.019 6.013-.353 8.893.823 1.65.904 1.895 2.422 1.782 4.096-.219 1.296-.802 2.322-2.118 2.789z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AFAFAF"
        d="M398.031 421.012c-38.075-.004-76.15-.006-114.225-.017-2.31-.001-4.679.325-6.801-.994-1.223-1.548-1.179-3.048.165-4.503 2.248-1.428 4.79-1.205 7.264-1.208 35.401-.039 70.801.003 106.203-.037 1.838-.002 3.655.05 5.406.684 1.273 1.88 3.32 3.407 2.781 6.111-.286.461-.549.426-.793-.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A8A8A8"
        d="M144 412c-37.218 0-74.436.019-111.653-.056-1.879-.003-4.548 1.278-5.359-1.974.485-1.978 1.144-3.85 2.998-5.007 2.777.73 5.616.593 8.442.593 32.462.006 64.925-.001 97.387.011 2.494.001 4.996-.141 7.479.212.621.128 1.19.382 1.707.748 1.368 1.579 1.43 3.297.529 5.114-.405.556-.916.676-1.53.359zM390.977 406.04l2.971 5.027c-.248 2.29-2.161 2.189-3.703 2.471-1.635.297-3.313.191-4.975.191-33.725.004-67.448.011-101.172-.01-2.481-.001-4.998.186-7.385-.789-1.663-.883-2.248-2.406-2.464-4.15.027-1.05.304-1.977 1.296-2.534 2.05-.926 4.238-.673 6.381-.674 34.202-.021 68.405-.009 102.608-.025a40.029 40.029 0 016.443.493z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BF403E"
        d="M47.021 138.028l-2.122-3.029c-1.148-.787-1.659-1.889-1.616-3.267 3.345-5.002 7.967-8.268 13.681-10.05 4.757.545 6.803-2.081 7.507-6.358.264-1.602.516-3.215 1.044-4.767.353-1.744.775-3.455 2.144-4.737 1.979-1.022 3.309.104 4.593 1.381.824-.005.322 2.549 1.946.968.344-1.392 1.323-2.188 2.496-2.812 1.47-.568 2.867-1.304 4.315-1.927 5.239-.229-1.191-2.795.734-3.686 1.248-2.478 3.609-3.342 6.006-4.163 2.703-.752 5.151-.93 5.897 2.655-.196 1.811-1.764 2.472-3.011 3.505.866-.107 1.246-.767 1.773-1.217 1.973-1.215 1.54-3.014 1.161-4.8.066-.479.295-.858.682-1.146.651-.287 1.321-.309 2.002-.146 1.744.459 3.45 1.941 5.271.18.858-.68 1.501-1.554 2.189-2.391 3.444-2.785 6.662-5.944 11.257-6.836 1.609.238 1.347 1.79 1.931 2.749l-.052-.045c.713.506.747 1.192.523 1.949-7.462 6.689-15.973 11.913-24.341 17.335-13.128 8.507-26.492 16.652-39.266 25.7-1.774 1.256-3.436 2.63-4.828 4.313-.536.52-1.109.938-1.916.642z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D64F4D"
        d="M242.13 69.966l-.297 3.037c-2.544 1.574-5.218.577-7.773.211-15.156-2.172-30.348-4.081-45.491-6.339-2.465-.367-4.954-.764-7.403.157-1.74.37-3.455.371-5.115-.36-3.729-3.168-8.511-2.167-12.78-3.197-3.309-.798-7.063-.231-9.616-3.259-.01-3.901 2.577-5.395 5.822-6.283 26.738 3.308 53.366 7.42 80.07 10.982 2.291.95 2.478 2.98 2.583 5.051z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DC5451"
        d="M240.169 65.948c-9.79.212-19.271-2.245-28.897-3.419-13.217-1.611-26.385-3.635-39.564-5.543-4.39-.635-8.752-1.457-13.127-2.194.646-2.209 2.401-2.733 4.396-2.895l1.026-.12c4.334-2.485 8.65-.764 12.969.059l1.062.025c3.75-.734 7.377-.11 10.964.979l1.036.022c3.433-.737 6.742-.169 10 .941l1.999.061c3.421-.744 6.718-.168 9.964.942l2.036.058c3.422-.742 6.719-.174 9.964.948l2.034.057c6.834-.249 13.199 4.289 14.138 10.079z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ACACAC"
        d="M276.025 412.009c37.404-.003 74.809.006 112.213-.042 1.912-.002 4.021.719 5.709-.899 1.229 1.003 1.828 2.346 2.096 3.869-1.622 1.766-3.754 1.029-5.661 1.031-37.784.046-75.567.038-113.352.041-.904-.433-1.354-1.211-1.618-2.13-.096-.721.036-1.369.613-1.87z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9A9A9A"
        d="M398.031 421.012c.265.006.529.018.793.036.48 1.474-.111 2.72-.833 3.938-6.161 2.313-12.626 2.638-19.099 2.903-6.295-1.112-12.566.336-18.865.271-4.461-.047-8.967.272-13.455.275-86.717.057-173.435.098-260.152-.042-12.293-.02-24.598-.119-36.885-.853-2.454-.146-4.983-.462-7.424.335-4.107.791-8.015-.979-12.063-.941-.299-.722-.094-1.246.616-1.572 2.29-.619 4.632-.347 6.95-.348 46.408-.013 92.816-.023 139.225-.004 1.333-.665 2.691-1.221 4.232-1.002 1.892 1.518 4.137.963 6.242.969 19.585.057 39.171-.007 58.756.048 1.667-1.495 3.347-.149 5.021-.021 1.071.373 2.144-.079 3.22.008 4.04-.02 8.076-.005 12.116-.01l17.683-.001h26.774l21.885.001h12.235c4.321.454 8.786-1.019 12.993.966l7.014.01c6.637-1.612 13.463-.621 20.156-1.462 1.285-.161 2.656.342 3.85-.509 3.192-.435 7.142 1.411 9.015-2.995z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D14B49"
        d="M181.006 65.848c4.215-2.234 8.425-.339 12.553.219 16.11 2.174 32.186 4.603 48.274 6.937l.071 6.973c-.441.326-.934.46-1.478.408-7.502-1.457-15.059-2.508-22.699-2.852-2.145-.672-3.048-4.248-6.174-2.636-.828.348-1.665.653-2.579.646-1.776-.129-3.44-.713-5.107-1.266-2.232-.521-3.833 2.133-6.139 1.241-2.609-1.428-5.254-1.33-7.928-.199-2.906-3.178-5.908-6.271-8.794-9.471z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#568DBC"
        d="M395.071 281c-7.742 7.93-14.95 16.441-24.117 22.833-2.019 1.408-2.21 3.046-2.204 5.08.049 18.244.078 36.489.113 54.733-.528.556-1.008.517-1.441-.113-1.526-2.962-.986-6.144-.959-9.268.13-14.91.248-29.82-.085-44.688-2.854-1.714-5.065 1.695-7.774.966-.468-.174-.775-.506-.949-.97-.064-2.426 1.521-3.979 3.033-5.507 8.306-8.396 16.669-16.733 25.045-25.06 1.408-1.399 2.801-2.908 5.06-2.837 2.099.373 3.489 1.67 4.506 3.456.139.493.052.95-.228 1.375z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5A5A5"
        d="M32.984 399.962c.46 3.768 3.373 3.018 5.749 3.02 33.596.027 67.192.018 100.788.018h6.486c1.027 1.675 1.614 3.239-1.002 4.001h-.007c-2.107-1.416-4.503-.985-6.802-.986-33.639-.024-67.279.011-100.918-.072-2.343-.006-5.657 1.272-6.245-2.883.18-1.33.577-2.521 1.951-3.098z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#76ABD8"
        d="M368.16 176.237c.238-.132.492-.181.761-.148l-.001 95.575c3.256-1.315 4.588-4.278 7.086-5.728.678-.48 1.348-.565 2.01.026.275.124.561.16.857.108.618.365 1.423.546 1.475 1.479-1.243 3.878-4.652 5.981-7.297 8.659-4.082 4.133-7.812 8.685-12.809 11.832-3.555 2.239-7.287 4.027-11.586 4.278-1.521.038-3.035.032-4.379-.841-1.25-2.419.994-2.377 2.139-2.716 3.027-.897 5.793-2.271 8.424-3.963.385-.267.79-.502 1.196-.73.585-.374 1.166-.755 1.71-1.191 3.074-3.3 7.148-5.755 8.632-10.383.442-26.274.054-52.529.18-78.784.021-4.154-.049-8.31.035-12.464.036-1.798-.158-3.717 1.567-5.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5A5A5"
        d="M274.018 403c35.762 0 71.522.001 107.283-.001 2.317 0 4.679.268 6.797-1.04l2.004 3.012c-1.029 1.119-2.41 1.01-3.726 1.008-36.938-.062-73.878.209-110.818-.128-1.453-.443-2.441-1.137-1.54-2.851z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A6A6A6"
        d="M31.033 403.06c1.413 2.736 3.995 1.911 6.199 1.914 33.867.038 67.734.016 101.602.051 2.211.002 4.791-.789 6.164 1.977-36.553 0-73.105.019-109.658-.056-1.88-.004-4.55 1.273-5.355-1.981.132-.756.13-1.584 1.048-1.905zM275 405l115.102-.029.875 1.069c-1.678 1.646-3.791.925-5.703.927-36.75.046-73.502.036-110.252.038-.547-.663-.648-1.33-.022-2.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M53.941 367.046l-.983.803c-1.532-3.032-1.999-6.231-1.996-9.634.051-58.896.036-117.792.041-176.688 0-3.472-.27-7.043 2.958-9.519l-.887 3.011c-.162 57.633-.048 115.265-.053 172.896 0 5.148.094 10.313 1.141 15.393.262 1.264.494 2.53-.221 3.738zM43.908 132.178l.991 2.821c-8.183-8.123-13.711-17.439-11.692-29.453.669-3.984 3.899-7.033 7.272-9.164 14.149-8.938 28.324-17.85 42.721-26.38 10.154-6.017 22.824-4.615 28.62 7.616 1.668 3.519 5.442 6.021 5.083 10.518-.662-.699-1.324-1.398-1.985-2.099-1.826-.66-3.066-1.932-3.855-3.676-.604-2.098-2.143-3.664-3.178-5.518-.819-1.766-2.242-3.03-3.614-4.338-1.241-1.319-2.73-2.188-4.519-2.519-1.078-.277-2.16-.531-3.274-.614-1.142-.067-2.283-.031-3.425-.014-2.462-.244-4.57.73-6.579 1.96-14.48 8.862-28.918 17.792-43.379 26.686-3.773 2.321-6.708 5.465-7.633 10.038a53.86 53.86 0 00-.113 2.084c.007.915-.021 1.829-.016 2.741a10.607 10.607 0 001.422 5.709c1.292 2.346 2.681 4.634 4.079 6.916 1.343 2.082 2.886 4.074 3.074 6.686zM282.799 117.005c-9.633-6.472-11.488-17.498-6.04-27.697 2.181-4.084 3.538-8.621 6.063-12.559 5.266-8.21 14.59-11.229 23.441-7.02 17.142 8.152 34.125 16.636 51.158 25.015 2.116 1.042 4.018 2.393 4.57 4.936l-.329.61c-1.011.416-1.788-.022-2.509-.678-1.469-1.778-3.375-2.946-5.455-3.867-1.958-1.087-3.985-2.039-6.014-2.99-1.99-1.092-4.041-2.057-6.104-3.001-2.526-1.64-5.566-2.146-8.141-3.68-1.904-1.687-4.422-2.135-6.615-3.237-1.977-1.084-4.004-2.068-6.049-3.018-1.94-1.134-4.154-1.703-6.066-2.896-1.298-.87-2.696-1.557-4.108-2.22-2.013-1.067-4.039-2.1-6.19-2.869-9.559-2.646-15.66-.253-20.033 8.604-2.969 6.015-7.272 11.508-7.987 18.506-.109 2.766.082 5.481 1.318 8.023.976 1.963 2.12 3.802 3.848 5.211 1.004.881 2.268 1.514 2.774 2.874.01 1.058-.441 1.758-1.532 1.953z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CDCBCB"
        d="M361.992 99.68c4.378 1.577 4.15 6.124 6.014 9.323.848 3.244.801 6.426-.432 9.6-2.627 6.769-6.268 13.043-9.498 19.515-1.226 2.455-3.875 3.478-6.103 4.866l.021-.012c-4.521 2.252-9.248 1.762-13.99 1.035-.775-.098-1.529-.236-1.935-1.029.29-.377.656-.656 1.085-.857 2.621-1.316 6.015 1.039 8.316-1.772 10.146-5.782 12.898-16.59 17.672-26.014.197-.403.436-.787.689-1.153 1.211-1.777 1.118-3.57.047-5.371-.744-1.131-1.452-2.278-1.9-3.565-.34-1.327-1.077-2.651-.089-4.007a.651.651 0 01.103-.559z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CCCBCB"
        d="M120.004 90.947l1.087 4.1c.583 3.324.789 6.644-.122 9.949l.011-.022c-.717 1.315-.889 2.904-2.013 4.017l.014-.019a16.207 16.207 0 01-5.012 5.008l.02-.014c-1.518 1.263-3.48 1.785-5.017 3.016l.019-.014c-2.653 1.692-5.344 3.322-7.986 5.032-.022 4.814-.053 9.628-.064 14.442-.016 6.462-.134 6.533-5.882 3.37-.17-1.265.826-1.77 1.57-2.438 1.977-4.049.566-8.354.942-12.52.176-1.943-.073-3.914.208-5.858 1.733-4.951 6.608-6.232 10.481-8.377 4.666-2.584 7.647-6.038 8.962-11.083.177-.4.399-.783.635-1.15.788-1.091.995-2.225.225-3.431a6.56 6.56 0 01-.576-1.175c-.194-.677-.161-1.335.137-1.976.608-.779 1.323-1.265 2.361-.857z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAC7C7"
        d="M47.021 138.028l1.034-.857c1.462-.852 1.906.265 2.321 1.264.385.928.693-.28 1.024.011 1.31-.77 1.656 2.027 3.085.816.86-.37 1.759-.474 2.68-.469 2.741.661 5.124-.16 7.468-1.572 5.053-3.045 10.092-6.12 15.326-8.862 2.856-.423 4.982 1.394 7.376 2.396 2.28 1.255 4.646 2.414 5.912 4.897.269 1.104-.16 1.832-1.208 2.222-3.045-.548-5.632-2.05-8.064-3.873-2.072-1.202-3.402.527-4.857 1.358-4.291 2.451-8.281 5.473-12.746 7.56-4.29 2.005-8.893 2.002-13.362.099-2.762-.747-5.482-1.541-5.989-4.99z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAC8C8"
        d="M203.027 112.016c-2.218 4.848-5.935 8.689-8.826 13.087-1.094 1.664-2.293 1.783-3.227-.28-2.252-4.978-5.298-9.582-6.986-14.826-.882-1.771-2.499-1.822-4.212-2.042-5.762-.738-11.608-.655-17.32-1.68-1.877-.336-3.895-.922-5.446-2.308l.02.014c-1.087-1.342-4.209-1.486-2.6-4.418 5.807 1.6 11.501 3.7 17.602 4.001 2.897-.081 5.833.525 8.678-.485a5.464 5.464 0 011.324-.616c1.719-.324 2.733.698 3.655 1.904 1.37 1.893 1.822 4.261 3.191 6.158.193.266.375.539.526.827 4.217 8.012 4.217 8.012 9.798.613.644-.731 1.401-1.261 2.412-1.323.77.149 1.231.618 1.411 1.374z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8C6C6"
        d="M203.027 112.016l-1.152-1.405c-.321-1.351.203-2.494.867-3.609 2.199-3.379 5.149-3.978 8.7-2.349 2.2 1.407 4.497 1.078 6.814.351 1.195-.292 2.415-.337 3.631-.404 3.038-.102 6.176.505 8.963-1.306 1.59-.883 3.191-1.749 4.591-2.928 1.51-1.113 1.85-3.047 3.052-4.378a2.47 2.47 0 011.262-.546c.482.037.895.229 1.249.556-.263 5.188-4.31 8.119-7.051 11.83-6.186 5.116-13.383 3.335-20.374 3.004-2.896-.138-5.814-1.344-8.689.122l-1.863 1.062z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C34341"
        d="M241.127 87.011l-.304 1.024c-.492 1.196.364 2.877-1.309 3.652-8.402.493-16.496-1.744-24.726-2.803a2.664 2.664 0 01-1.211-1.115 2.83 2.83 0 01-.013-1.643c.882-1.47 2.277-2.389 3.616-3.375 1.487-.89 3.149-1.233 4.788-.865 6.253 1.404 12.937.538 18.876 3.581.44.452.533.967.283 1.544z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5DFD6"
        d="M394.906 280.252a6415.53 6415.53 0 00-4.102-3.191 8.838 8.838 0 01-.883-1.551c-.649-6.172-.967-12.346.067-18.514.991-1.678 2.3-3.037 4.017-3.983 1.563.637 2.285 1.95 2.338 3.487.245 7.063.313 14.131-.045 21.193-.049.976-.683 1.837-1.392 2.559z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAC6C6"
        d="M302.012 146.026l-1.152-1.094c-.501-.911-.345-1.88-.255-2.844 3.946-4.224 9.355-6.383 13.856-9.827 3.979-2.351 6.846-1.028 8.97 2.731.003.494-.155.93-.493 1.295-2.549-.32-4.74.442-6.762 2.014-3.096 2.407-6.554 4.285-9.838 6.414-1.207.783-2.401 2.539-4.326 1.311z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E0D8CC"
        d="M394.906 280.252c.031-7.479.042-14.957.109-22.435.015-1.696-.156-3.312-1.01-4.805 2.469-3.778 3.602-.706 5.007.976.345 8.061 1.808 16.167-.978 24.102-.697 1.267-1.662 2.261-2.964 2.911a1.127 1.127 0 01-.164-.749z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M188.002 438.005h79.995c-1.312 1.487-3.078.974-4.674.976-23.549.028-47.098.028-70.646 0-1.597-.002-3.363.511-4.675-.976z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAC7C7"
        d="M172.03 104.984c-6.311-.629-12.512-1.654-18.085-4.968-1.832.595-2.04-1.213-2.943-1.99-1.737-2.028-2.779-4.262-2.067-7.012-.374-.91.177-1.245.91-1.466 1.698.053 2.107 1.517 2.865 2.6.923 1.405 1.888 2.78 3.142 3.926a16.243 16.243 0 012.178 2.302c.905 1.185 1.916 2.15 3.595 1.808 1.134-.126 2.162.177 3.133.727 1.874 1.209 3.787.619 5.701.114 1.723-.201 3.471-.489 4.658 1.265.072 2.158-2.009 1.852-3.087 2.694z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DCD3C4"
        d="M398.035 278.09c-.012-6.477-.053-12.952-.014-19.429.01-1.599-.512-3.368.991-4.673 1.306.697 2.331 1.67 2.979 3.018.716 6.083 1.692 12.18-.959 18.084-.695 1.304-1.733 2.264-2.997 3z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAE6E0"
        d="M389.989 256.996c2.044 6.368.676 12.888.86 19.338-2.854-.359-4.213-2.271-4.994-4.794-.297-3.521-.832-7.047.123-10.555.993-1.675 2.309-3.026 4.011-3.989z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D8CCBB"
        d="M401.032 275.09c.481-6.02-1.179-12.152.959-18.084 1.666.997 3.038 2.29 4.009 3.986.757 3.478.935 6.899-.965 10.123-1.031 1.629-2.386 2.935-4.003 3.975z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M162.977 51.897l-4.396 2.895c-2.282 1.066-3.807 2.838-4.78 5.124.593 3.573-1.889 6.731-1.372 10.293a48.956 48.956 0 01-.078 3.812c-.141 2.54-1.01 4.985-.966 7.549.042 1.01-.004 2.018-.072 3.025-.044 1.014-.187 2.007-.652 2.925-.275.439-.682.666-1.194.71-2.079-1.291-.053-3.736-1.463-5.216 1.975-5.543.458-11.441 1.892-17.113 1.634-6.472 4.524-11.599 10.889-14.297.839-.356 1.551-.488 2.192.293z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#969595"
        d="M40.111 393.19l-1.889-3.146c2.815-3.859 4.22-8.637 7.806-11.995 1.232-.038 2.073.459 2.356 1.722-.017.866-.35 1.641-.709 2.407-.534 1.08-1.178 2.1-1.813 3.123-.499.825-.824 1.73-1.164 2.629-.286.718-.63 1.407-.981 2.095-.35.701-.714 1.394-1.137 2.057a3.818 3.818 0 01-1.318 1.218c-.402.148-.784.101-1.151-.11z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M351.974 142.983c9.248-9.485 15.51-20.379 16.032-33.98 2.176 4.277 1.018 8.438-.781 12.381-2.486 5.453-5.283 10.766-8.003 16.11-1.515 2.975-3.82 4.998-7.248 5.489zM53.008 143.017c9.137 2.548 16.12-2.12 23.244-6.704 2.222-1.429 4.295-4.47 7.721-2.313-5.431 1.733-9.765 5.441-14.647 8.162-5.336 2.974-10.677 4.396-16.318.855z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECECEA"
        d="M385.979 260.985c1.851 3.688.792 7.603.893 11.427-.975.398-1.771.029-2.514-.576-1.461-1.613-3.651-2.582-4.355-4.875l-1.129-.891c3.343-.332 4.411-3.844 7.105-5.085z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M157.01 103.967c7.03 2.648 14.501 2.151 21.779 3.013 2.237.265 4.851-.393 5.199 3.017-4.777-1.483-9.675-1.873-14.661-2.084-4.364-.186-8.933-.402-12.317-3.946zM204.89 110.953c.993-1.961 2.54-1.241 4.243-1.221 8.316.099 16.879 2.894 24.82-1.903-2.378 3.614-6.184 3.807-9.937 4.178-6.432.635-12.719-1.294-19.126-1.054z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D2C9C9"
        d="M282.799 117.005l1.147-1.756c1.764-1.311 3.126.22 4.65.64 3.039 1.824 6.674 2.664 9.119 5.483.292 1.039 1.423 2.296-.687 2.729-5.019-1.81-9.699-4.302-14.229-7.096z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C9C9C9"
        d="M322.977 136.062l.021-1.069c-.268-.235-.376-.486-.323-.756.053-.277.119-.416.195-.418 2.844-.436 4.576 2.454 7.287 2.424 1.797.914 3.612 1.801 5.391 2.766.811.5 1.521 1.098 1.928 1.988.199.734.092 1.399-.452 1.964-.317.013-.636.019-.954.018-4.731-1.165-8.666-4.069-13.057-5.981-.361-.194-.485-.397-.377-.609.11-.219.223-.327.341-.327z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M240.169 65.948c-2.51-6.449-7.927-8.82-14.138-10.079 7.622-2.297 17.505 6.357 16.099 14.097l-1.961-4.018zM297.03 124.101c1.084-.745.124-1.47-.022-2.203a1.76 1.76 0 011.533-.277c2.11 1.343 2.113 3.667 2.686 5.73.564 3.229-.197 6.569.836 9.764.313 1.752.23 3.425-1 4.857-.066.987-.133 1.976-.201 2.962-3.366-5.295-.854-11.568-2.844-17.099-.435-1.207-.664-2.487-.988-3.734zM322.977 136.062c-.01.313.002.624.035.935-6.555-.107-10.234 5.376-15.42 7.928-1.758.864-3.234 3.199-5.58 1.103 5.267-2.341 9.957-5.65 14.656-8.91 2.054-1.428 3.97-2.095 6.309-1.056z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D0C5B4"
        d="M405.035 271.115c.387-3.368-1.066-6.911.965-10.123 5.599 4.587 5.599 4.587-.965 10.123z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8C8C8C"
        d="M367.992 373.018c.047-.862.275-1.627 1.113-2.063 2.553 1.694 3.764 4.332 4.918 7.009.551 1.227.015 2.194-.742 3.11-.988.511-1.766.053-2.516-.543a5.771 5.771 0 01-.819-1.073c-.687-1.379-1.526-2.674-2.317-4a3.35 3.35 0 01-.275-1.304c.076-.456.291-.834.638-1.136z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8D8D8D"
        d="M47.987 379.877l-1.96-1.827c.76-3.215 2.553-5.77 5.031-7.889l.954 2.872c.574.839.072 1.561-.237 2.306-.46.911-.786 1.88-1.16 2.83-.348.783-.763 1.518-1.486 2.025-.441.116-.826.02-1.142-.317z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M126.002 437.005c7.779 0 15.558-.024 23.336.021 1.596.009 3.355-.502 4.669.972-7.78.001-15.561.027-23.34-.018-1.594-.009-3.356.51-4.665-.975zM299.992 437.997c3.042-1.973 6.426-.827 9.637-.935 6.117-.205 12.246-.062 18.371-.063-2.686 2.007-5.762.857-8.639.941-6.451.188-12.912.058-19.369.057z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#989898"
        d="M381.979 391.064c-.008 1.414-.709 2.382-1.939 3.007-.214-.05-.428-.101-.643-.149a3.77 3.77 0 01-1.026-.825c-.767-1.095-1.591-2.156-2.113-3.407a4.995 4.995 0 01-.118-2.781c.318-.964.855-1.721 1.902-1.988 2.142 1.515 2.671 4.065 3.937 6.143z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#959595"
        d="M378.041 384.92l-1.088 2.189a1.24 1.24 0 01-1.228.158c-.794-.466-1.315-1.177-1.771-1.951-.537-.968-1.069-1.94-1.352-3.025-.061-.461.055-.87.365-1.221l1.055-3.107c1.599 2.17 3.446 4.195 4.019 6.957z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M90 436c6.656.607 13.434-1.25 20.008.997-6.655-.612-13.435 1.27-20.008-.997zM176.972 51.836c-4.325.418-8.64-1.354-12.969-.059 2.96-2.573 9.463-2.544 12.969.059zM382.999 258.99c2.468-3.427 5.666-6.086 9.003-8.619-2.07 3.44-4.799 6.245-7.98 8.628-.344.431-.686.428-1.023-.009zM188.998 52.84l-10.964-.979c3.757-.816 7.591-2.497 10.964.979zM200.035 53.804l-10-.941c3.13-1.692 6.488-.646 9.74-.717.698-.016.476 1.035.26 1.658zM65 435c5.324.524 10.781-1.094 16.007.997-5.323-.528-10.782 1.112-16.007-.997zM338.004 144.007c4.705.211 9.387.108 13.99-1.035-4.441 3.332-9.199 2.412-13.99 1.035zM211.998 54.807l-9.964-.942c3.432-.859 6.941-2.527 9.964.942zM223.998 55.813l-9.964-.948c3.433-.856 6.944-2.534 9.964.948zM340.992 436.997c4.879-2.183 10.02-.434 15.007-.995-4.879 2.196-10.02.431-15.007.995z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8EEF3"
        d="M382.999 258.99l1.022.009-6.006 6.964-2.01-.026c1.983-2.668 4.272-5.025 6.994-6.947z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7B7B6"
        d="M30.054 426.125c-.026.27-.028.54-.006.81-1.386.263-2.955-.349-4.144.862l-2.887-1.848c.584-1.282 1.569-1.948 2.989-1.947.951 1.467 3.195.469 4.048 2.123z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E0C8C8"
        d="M241.127 87.011l-.328-.997c-1.287-2.017-1.57-3.973.354-5.793.249-.086.5-.168.752-.245 1.767 2.569 1.814 4.948-.778 7.035z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M101.004 122c2.134-2.516 4.741-4.28 7.986-5.031-2.118 2.539-4.709 4.329-7.986 5.031zM151.001 98.026l2.944 1.99 3.084 3.965c-3.197-.781-5.15-2.824-6.028-5.955zM241.004 95.997l-1.296-.042c-.676-.905-.728-1.905-.453-2.956.961-1.175.977-2.803 1.896-4 1.27 2.36 1.469 4.698-.147 6.998zM120.97 104.996l.121-9.949c1.368 3.334 1.543 6.652-.121 9.949z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C6C6C6"
        d="M92.037 137.873l.959-1.723c1.939-.988 3.104.198 4.23 1.501.185.466.146.908-.149 1.321l-2.021.841c-1.005-.647-2.012-1.293-3.019-1.94z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E2E2E2"
        d="M148.004 83.014c1.869 1.174.193 3.669 1.837 4.928.678.608.759 1.287.237 2.035l-1.143 1.038c-1.842-2.49-.556-5.342-.931-8.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M113.969 113.979a16.877 16.877 0 015.012-5.008c-.525 2.816-2.193 4.488-5.012 5.008zM120.004 90.947l-1.775 1.045c-1.086-.237-1.642-.818-1.292-1.988l-.088-1.913c2.058-.158 2.39 1.589 3.155 2.856z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M108.972 116.981c1.096-1.965 2.967-2.639 5.018-3.016-1.04 2.059-2.933 2.698-5.018 3.016zM368.1 363.68c.258.055.513.044.764-.032l-.877 5.391c-1.338-.664-.786-1.896-.883-2.934-.762-1.258.027-1.878.996-2.425z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CA4745"
        d="M241.151 88.999c-.428 1.355.009 2.942-1.103 4.114-.591-.66-.659-1.356-.146-2.094.123-1.052-.06-2.197.921-2.984l.328.964z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M118.967 108.99c.197-1.576.763-2.969 2.014-4.017.115 1.733-.16 3.27-2.014 4.017z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B1B25"
        d="M368.1 363.68l-.996 2.426c-3.24 1.638-6.407-.347-9.676-.193-88.875 4.165-177.809 1.086-266.713 1.946-1.936.019-4.822 1.655-5.817-1.843 7.814-.896 13.182-5.713 18.128-11.245.769-.859 2.065-1.007 2.948-1.77.333-.004.665-.006.998-.006 3.433-2.47 6.801.476 9.716-.466-.696-.507-2.204.226-3.522-.117-1.172-.305-1.793-.836-.721-1.98 6.848-1.641 13.759-.778 20.657-.547 1.275.403 2.573.61 3.917.66 40.86 1.51 81.743 1.323 122.604.717 9.7-.144 19.577.292 29.268-1.375 7.283-.122 14.603-1.332 21.818.678 1.029 3.193-2.076 1.118-2.137 1.211 16.348-.449 33.342-.095 50.326-.22 2.102-.016 4.401.494 5.826-1.779 1.312-10.97.203-21.96.582-32.923.119-3.448-.613-7.046 1.614-10.165 2.073 1.086.961 2.997.973 4.459.142 17.51.158 35.021.207 52.532z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C3C44"
        d="M105.974 353.001c-3.669 3.849-7.252 7.784-11.034 11.518-2.893 2.855-6.692.961-10.042 1.497-10.318.388-20.694-.985-30.958 1.03l-.874-2.072c.77-3.95-1.364-8.131.947-11.959l51.961-.014z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#92908A"
        d="M132.984 351.093l-20.958.027c-1.329.979-2.667.989-4.017.044l-44.909-.196c-.962-1.164-.573-2.554-.572-3.846.01-54.759-.076-109.519.027-164.278.12-.768.567-1.128 1.341-1.085.535.41.924.931 1.172 1.557.938 2.746.633 5.599.634 8.412.021 48.749.015 97.498.015 146.247 0 .665-.002 1.331.001 1.996.04 8.163.04 8.174 8.344 8.296 1.333.02 2.656.147 3.986.207 2.822-.336 5.655-.212 8.483-.209 44.615.043 89.231-.102 133.846.053 1.908.46 3.847-.077 5.762.146 6.011.228 12.022-.474 18.036-.02 11.623.268 23.243.068 34.864-.044 20.813-.202 41.626-.156 62.435-.074 16.311-.108 13.628 2.061 13.885-13.46.129-7.806-.08-15.613.032-23.423.306-1.413.974-2.227 2.546-1.52l-.008.146c1.557 1.54 1.732 3.538 1.749 5.544.079 10.126.099 20.253-.012 30.378-.021 1.829-.159 3.666-1.38 5.195-.977.785-2.15.783-3.308.786-13.57.039-27.141.041-40.712.002-1.17-.003-2.32-.094-3.295-.858l-21.957-.027c-.766.404-1.597.386-2.431.399-41.582.714-83.17.708-124.751.343-9.596-.083-19.256.327-28.848-.738z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5D5D5D"
        d="M64.118 182.201l-1.03-.095c-.333-.229-.445-.46-.337-.692.108-.233.217-.351.328-.351l54.93-.125c2.74-1.702 5.775-1.627 8.824-1.476 2.383.177 4.769-.232 7.153.008 2.67.308 5.343-.271 8.013-.002 2.97.287 5.94-.281 8.91-.017 2.662.295 5.327-.235 7.989.004 2.631.304 5.264-.05 7.896-.007 1.982.224 3.975.087 5.96.123 5.487.172 10.817-.335 16.097-2.205 6.254-2.216 13.128-1.559 19.461-3.6 1.35.702 2.665-.199 4.019-.13 12.039 1.462 23.594 5.779 35.843 5.933 2.305-.028 4.608.088 6.911-.102 2.718-.204 5.435.321 8.155-.03 2.035.57 5.369-1.141 5.371 3.029-2.457 1.499-5.191.949-7.812.95-60.795.036-121.589.022-182.383.033-4.756-.522-9.706 1.155-14.298-1.248z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1E1E1D"
        d="M54.014 353.015c-.512 3.971 1 8.102-.947 11.959-.94-2.221-.749-4.569-.749-6.89-.005-58.729-.007-117.457.004-176.186 0-2.313-.271-4.672.752-6.88 1.594 1.7.894 3.808.896 5.726.042 57.424.039 114.847.044 172.271z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#424345"
        d="M63.078 181.063l.009 1.042c-.061 9.324-.172 18.647-.176 27.972-.019 44.802-.011 89.604 0 134.405 0 2.162.123 4.324.189 6.485-1.843-1.37-1.091-3.365-1.092-5.086-.041-53.236-.04-106.473-.002-159.708.001-1.73-.719-3.713 1.072-5.11z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#202120"
        d="M58.008 170.034c.193-.272.432-.32.716-.145 1.261-.613 2.612-.367 3.924-.367 27.394-.015 54.787-.021 82.18.016 1.425.001 3.012-.561 4.254.707-.123 1.778-1.594 1.774-2.797 2.129-3.11.02-6.219.424-9.339.162-2.997-.412-6.306.982-8.945-1.524-21.434-.004-42.867.012-64.301-.044-1.908-.006-4.021.721-5.692-.934z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#313233"
        d="M128.001 171.012l9.004.004c.594 2.471-1.259 3.712-2.809 4.713-2.499 1.613-4.7 3.608-7.2 5.197l-8.988.014 9.993-9.928z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#141518"
        d="M108.01 351.164l4.017-.044c1.612 1.673 3.854.323 5.679 1.875h-10.733l1.037-1.831z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A1A1A1"
        d="M276.016 413.995c.782.448.963 1.198 1.014 2.014l-.023 3.992c-1.314 1.486-3.082.978-4.682.979-41.188.024-82.375.027-123.563 0-2.363-.002-5.28.78-5.78-2.973l1.017-2.006c1.773-2.977 4.773-2.673 7.553-2.69 13.795-.087 27.59-.007 41.385-.044 26.259-.07 52.519.184 78.778-.136 1.502-.018 3.006-.118 4.301.864z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F4F4"
        d="M30.054 426.125c-1.418-.575-3.922.916-4.049-2.123 48.012.017 96.024.031 144.036.059 2.303.001 4.672-.359 6.799.95-1.808 1.763-4.076.954-6.12.956-44.729.052-89.457.038-134.185.045-2.16 0-4.32.074-6.481.113z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D6D6D6"
        d="M246.069 425.025c-1.3 1.519-3.072.96-4.655.963-18.544.037-37.088.059-55.631-.037-1.66-.009-4.24 1.307-4.712-1.942 19.771.005 39.542-.01 59.313.046 1.912.005 4.024-.697 5.685.97z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DBDBDA"
        d="M310.9 425.896l-27.001-.028c-5.688-.9-11.422-.056-17.124-.447-.609-.229-.88-.669-.813-1.316l36.024-.056c2.14.973 4.405.188 6.588.484.921.124 2.456-.617 2.326 1.363z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C9C9C8"
        d="M310.9 425.896c-2.631-2.254-6.297.481-8.913-1.849l25.01-.027c1.681 1.569 4.731-1.127 5.942 1.908l-22.039-.032z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AFAFAF"
        d="M389.016 424.007c-7.857 2.419-15.949 1.984-24.006 1.972 5.893-3.271 12.318-1.573 18.518-1.961 1.822-.115 3.658-.014 5.488-.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BFBFBF"
        d="M332.939 425.928c-1.556-1.96-4.406.114-5.942-1.908l17.995-.012c.596.648.599 1.295-.01 1.938l-12.043-.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7B7B7"
        d="M344.982 425.946l.01-1.939c3.811-.002 7.621.035 11.431-.026 1.524-.024 2.254.368 1.573 1.987l-13.014-.022z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAEAEA"
        d="M265.963 424.104c.026.294.042.589.049.885-.232.146-.464.291-.695.438-4.072.337-8.181-.394-12.237.42-.815.077-1.642.182-1.991-.842 4.858-1.972 9.915-.628 14.874-.901z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C5B5B"
        d="M367.813 373.845l.264 1.055c-1.938 2.233-4.584 1.426-6.969 1.54-6.893.331-13.844-.547-20.672 1.023-.668.523-1.398.904-2.26.968-3.613-1.463-7.318-2.456-11.281-2.029-3.118.094-6.242-.041-9.355.283-1.348.146-2.641-.262-3.969-.361-1.105-.181-2.155-.469-2.824-1.482-.076-.609.14-1.085.645-1.434 3.527-1.744 7.21-.435 10.82-.549 1.857 2.009 2.646.147 3.633-1.002 3.871 1.249 7.826.645 11.76.531 2.635-.076 5.291-.27 7.509 1.603 5.544-4.277 12.032-2.797 18.245-2.971 1.283-.035 2.654-.205 3.594 1.034-3.916 1.75-8.063.986-11.746 1.047 3.906 1.061 8.375-1.382 12.606.744z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#292923"
        d="M71.845 378.99c.473-1.773.851-3.615 3.01-4.172 4.949-2.218 10.112-1.215 15.198-.884 1.545.101 2.891 1.06 2.002 3.096l-.012-.002c-1.046 3.799-4.206 3.229-7.009 3.401-1.026.09-2.044.309-3.084.236-1.299-.063-2.586-.303-3.897-.265-2.136-.182-4.466.49-6.208-1.41z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#23201F"
        d="M49.842 377.931c.29-1.003-.074-2.284 1.218-2.859 4.196-1.777 15.157-1.832 18.963-.096.444 1.261-.63 2.04-.968 3.053-.729 1.497-1.996 2.173-3.592 2.263-4.141.232-8.287.254-12.423-.005-1.458-.092-3.082-.288-3.198-2.356z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#292923"
        d="M94.823 376.895c.24-1.146.918-1.849 2.082-2.062 5.37-2.158 10.914-1.213 16.423-.925 2.527.954 2.153 2.634 1.125 4.482-2.338 2.65-5.515 1.813-8.441 2.026-1.786 0-3.571.005-5.359.005-2.276-.626-6.079 1.266-5.83-3.526z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F3F3C"
        d="M322.211 372.858c-3.505 2.422-7.524.424-11.209 1.304-2.719 1.654-5.406 1.851-8.049-.167-.325-.863-1.172-2.111.47-2.25 6.304-.533 12.696-2.048 18.788 1.113z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#403F3C"
        d="M143.994 371.993c5.684-1.638 11.467-.712 17.212-.614.828.014 1.46.708 1.692 1.596-1.273 2.886-3.927 2.231-6.246 2.442-4.155-.375-8.437.878-12.481-.957-.778-.77-.768-1.598-.177-2.467z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#434340"
        d="M234.917 373.99c-.229-.869-1.066-2.02.555-2.288 5.691-.944 11.403-.993 17.092.036 1.123.203 1.455 1.206 1.552 2.249-3.059 1.745-6.479 1.032-9.74 1.435-3.167-.401-6.607 1.022-9.459-1.432z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3D3C3B"
        d="M345.112 373.99c-5.029-.808-10.05.296-15.076.069-1.742-.079-3.784.418-4.19-2.203 5.344-1.406 10.771-.559 16.161-.511 1.542.014 2.841.859 3.105 2.645z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C3C38"
        d="M166.992 371.993c6.372-.886 12.77-2.316 18.938.932-1.342 2.921-4.03 2.361-6.451 2.5-3.082-.018-6.178.196-9.239-.135-1.786-.193-4.312-.102-3.248-3.297z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#373732"
        d="M120.966 373.998c.145-.474.138-1.138.458-1.392 2.857-2.272 15.616-1.939 18.879.433-.325 1.946-1.867 1.925-3.316 2.063-3.643.141-7.284.446-10.935.293-1.796-.076-3.704.207-5.086-1.397z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7C7B7B"
        d="M113.89 377.938c-.049-1.012 1.147-1.955.166-3.018a1.367 1.367 0 01-.574-.919c-2.96-1.419-6.084-.274-9.103-.637-1.884-.226-3.99.388-5.406-1.506 5.652-1.92 11.461-.52 17.191-.789 1.963-.092 1.642 2.314 2.943 3.02.263.404.313.838.183 1.3-.584 1.283-1.299 2.479-2.344 3.455-1.27.553-2.768 1.848-3.056-.906z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#272720"
        d="M98.973 371.858c5.163-.001 10.325-.025 15.487.021.878.008 2.364-.234 2.099 1.242-.21 1.168-1.586.871-2.56.872-5.302.546-10.604 1.004-15.905-.005l.879-2.13z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#242120"
        d="M75.839 372.94c5.884-2.464 12.002-.776 18.012-.967.67-.021.679.259-.766 2.154-4.783.371-9.576.459-14.367.32-1.08-.03-2.892.818-2.879-1.507z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2A25"
        d="M280.09 373.996c.175-.596.341-1.709.527-1.713 6.187-.111 12.435-1.593 18.533.659.097 1.98-1.466 1.954-2.743 2.28-2.136.074-4.279-.328-6.416.104-3.321-.299-6.878 1.158-9.901-1.33z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#242121"
        d="M367.813 373.845h-18.151l-.063-1.792h17.353l1.041.965c-.04.28-.1.555-.18.827z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F2F2A"
        d="M189.088 373.998c-.017-2.167 1.524-2.245 3.063-2.228 5.28.06 10.56.153 15.84.233 1.048 2.076-.33 2.652-1.895 2.678-1.95.031-3.804.634-5.737.684-3.765-.402-7.778 1.252-11.271-1.367z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2F2E2A"
        d="M258.005 372.003c5.124-.774 10.269.814 15.416-.195 1.548-.304 3.415-.206 3.577 2.192-1.397 1.411-3.293.589-4.896 1.11-1.342.248-2.694.275-4.053.303-2.438-.012-4.894.225-7.292-.173-1.647-.272-3.875-.44-2.752-3.237z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#30302B"
        d="M212.053 372.971c.484-1.099 1.521-1.321 2.464-1.163 5.481.916 10.98-.404 16.457.206 1.059 2.679-.931 2.962-2.651 3.119-1.901.174-3.833.031-5.747.236-3.557-.583-7.776 1.725-10.523-2.398z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#555454"
        d="M49.842 377.931c6.395 1.912 12.801 1.526 19.213.098.674 1.064 1.759.936 2.79.962l7.284.188c.096.719-.177 1.246-.816 1.587-9.234 1.809-18.503.82-27.763.281-.652-.038-1.176-.581-1.609-1.104l.901-2.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E5D5D"
        d="M258.005 372.003c.54 3.054 2.974 1.818 4.694 1.977 2.1.194 4.226.105 6.341.138.253.55.14 1.01-.334 1.382-3.395 1.722-7.051.542-10.567.941-2.192.25-4.666-.343-6.138 2.041a3.152 3.152 0 01-1.095.825c-1.852.124-1.865-2.155-3.331-2.544-.965-.38-1.966-.694-2.691-1.501-.214-.405-.183-.784.13-1.129l9.101-.146c1.865.451 2.798-.923 3.89-1.984z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A3738"
        d="M54.827 371.885c5.449-1.124 10.896-1.145 16.342.014-1.747 1.864-4.41 1.387-6.443 2.521-1.801-.184-3.565.877-5.382.165-1.373-1.118-3.466-1.038-4.517-2.7z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#656464"
        d="M201.026 374.123c1.879-2.161 5.521 1.473 6.965-2.119 1.124.988 2.002 2.491 3.898 1.853.264.239.391.508.381.804-.01.311-.049.466-.113.466-2.016 1.371-4.894 1.515-6 4.199-.877.569-1.806.622-2.775.284-1.567-.955-1.839-2.719-2.613-4.174-.146-.482-.058-.92.257-1.313z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5D5B5B"
        d="M166.992 371.993c.253 2.475 2.156 2.009 3.72 2.037 3.112.056 6.225.043 9.338.058.253.569.132 1.042-.359 1.422-3.419 1.656-7.079.758-10.632.952-1.964.107-3.925.11-5.81.73a5.376 5.376 0 01-1.426.304c-1.21-.028-2.052-.989-3.172-1.263-.643-.215-1.241-.509-1.743-.976-.252-.418-.219-.813.098-1.186 1.986-.25 4.119.287 5.893-1.098 2.018 2.407 2.862-.097 4.093-.98z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#585656"
        d="M75.839 372.94c4.041 2.158 8.326.86 12.501.783 1.626-.03 3.223-.538 4.744.404-.093 1.057-.015 2.174-1.03 2.902-.321-2.451-2.22-1.992-3.805-2.022-4.464-.085-8.929-.129-13.394-.189l.984-1.878zM58.907 373.866l6.233-.01c1.711-.761 3.416-1.398 4.975.309a5.15 5.15 0 01-.091.811c-6.321.031-12.643.063-18.963.096l.951-2.038c.272-.049.545-.091.82-.123 2.022.342 4.223-.459 6.075.955z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#555353"
        d="M94.823 376.895c1.042 3.652 4.163 1.448 6.231 2.212.218.684.018 1.206-.599 1.571-4.672 1.723-9.458.599-14.193.483-1.066-.026-2.333-.525-2.146-2.139 2.761-.195 5.831.841 7.928-1.994 1.11 3.769 1.871.292 2.779-.133z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C5A5A"
        d="M118.932 374.889c.051-.269.109-.536.175-.801.62-.029 1.24-.06 1.859-.09l16.034.023c.288.682.119 1.22-.505 1.618-5.914 1.195-11.819 2.088-17.563-.75z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5D5C5C"
        d="M272.964 373.823l4.034.177 3.092-.004 10.945.114c.232.671.042 1.187-.568 1.551-5.76 1.196-11.513 1.588-17.242-.199-.528-.475-.615-1.022-.261-1.639z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#706F6F"
        d="M180.056 374.867a7.79 7.79 0 01-.006-.779c1.973-.327 4.16.432 5.881-1.163l.074 1.017c.342.368.452.795.335 1.284-.76 1.473-1.126 3.183-2.535 4.275-1.336.517-2.473.284-3.361-.891-.717-1.186-.653-2.455-.388-3.743z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A5858"
        d="M98.095 373.988l15.905.005c.024.31.042.618.055.928l-17.149-.088 1.189-.845z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#646363"
        d="M223.033 374.109c1.576-.433 3.127-.574 4.782-.244 1.432.285 3.075.405 3.159-1.852 1.066.624 1.499 2.173 3.05 2.087.232.483.179.921-.202 1.309-1.485 1.01-3.215.839-4.868 1.016-1.672.07-1.779 1.744-2.663 2.62a1.654 1.654 0 01-1.266.215c-1.239-1.045-1.529-2.637-2.287-3.963-.134-.452-.045-.852.295-1.188z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7F7F7F"
        d="M136.835 375.145l.165-1.123c1.216.06 2.46.216 3.301-.983l.707 1.001c.231.249.346.522.346.818 0 .308-.029.461-.079.464-.786 1.442-1.084 3.182-2.539 4.229-1.033.414-2.009.34-2.92-.332-1.061-1.71-.672-3.056 1.019-4.074z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C5A5A"
        d="M295.997 374.006c1.139-.096 2.396.163 3.153-1.063 1.102.952 2.408 1.161 3.803 1.053l8.049.166-.001.72c-4.728 2.555-9.608 2.047-14.534.739-.608-.406-.764-.945-.47-1.615z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5D5B5B"
        d="M185.947 374.884c.028-.313.047-.627.058-.941l3.083.056c3.979.041 7.958.082 11.938.125-.006.253-.006.506 0 .759-5.026 2.558-10.052 2.477-15.079.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#232020"
        d="M70.115 374.165c-1.659-.103-3.318-.204-4.976-.308 1.324-2.767 3.994-1.384 6.03-1.958 1.328 1.536-.259 1.716-1.054 2.266z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#242121"
        d="M58.907 373.866c-2.061-.089-4.294.918-6.075-.956.429-.802 1.16-1.016 1.996-1.024 1.422.531 3.692-.683 4.079 1.98z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#595858"
        d="M223.033 374.109c-.009.261-.009.522.002.783-3.687 2.518-7.377 2.509-11.068.01-.025-.348-.05-.695-.077-1.045.021-.302.075-.598.163-.886 3.491 2.009 7.344.524 10.98 1.138z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C5A5A"
        d="M233.977 374.908c.012-.271.028-.54.047-.809.296-.049.594-.086.894-.109l10.097.142c-.007.26-.009.518-.007.776-3.677 2.484-7.354 2.483-11.031 0zM140.92 374.885c.051-.279.081-.562.087-.846 1.612.218 1.957-1.413 2.986-2.046l-.002 2.036c.337.519.264.971-.219 1.357-1.065.485-2.044.48-2.852-.501z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9A9A9A"
        d="M275 405l.021 2.004-.015 1.996c-2.494 2.332-5.628 1.684-8.544 1.688-34.901.052-69.803.029-104.705.035-5.618.001-11.263-.328-16.76 1.276l.009-4.999c1.423-1.061.856-2.62 1.002-4.001l1.998-.998c1.719.958 3.589.484 5.381.485 38.088.031 76.176.017 114.263.048 1.794.001 3.661-.462 5.387.468.327-.007.654-.008.981-.003.016.82.2 1.558.982 2.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#464644"
        d="M255.78 399.889c-37.389.014-74.778.029-112.167.027-1.153 0-2.307-.196-3.46-.301 1.132-2.563 3.534-2.075 5.574-2.184 5.145-.273 10.294.125 15.435.111 8.236-.423 16.456.542 23.49.788-1.614.331-4.436-.106-7.182-.64-1.686-.327-3.819-1.041-1.697-3.509a80.873 80.873 0 0123.281.249c12.361 1.921 24.78 1.844 37.124-.119 4.632-.736 9.229-1.071 13.885-.925 1.813.057 3.694.047 5.082 1.559.268.013.535.037.8.075.724 1.65 1.063 3.287-.165 4.869z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B4A49"
        d="M255.146 394.946c-15.89-.313-31.611 3.448-47.54 2.036-10.853-.961-21.651-2.743-32.608-1.979-2.474 2.331-5.585 1.492-8.474 1.653-3.456.192-6.91-.453-10.372-.111-3.493.274-6.991.145-10.483.021-1.811-.064-3.717-.134-4.857-1.954 1.459-2.938 4.256-1.887 6.569-2.129 4.386-.458 8.979.93 13.131-1.512 1.885-.864 2.893 1.415 4.584 1.273 4.231.587 8.485.247 12.726.367 2.148.061 3.85-.521 4.805-2.588.531-.505 1.164-.66 1.87-.546.826.27 1.196.966 1.547 1.655.169.286.421.387.755.234.787-1.183 1.61-2.284 3.127-2.539 4.195-.469 8.167-.462 11.805 2.402 2.219 1.748 5.382 2.528 8.026 2.16 7.456-1.037 14.852-.54 22.28-.226.705.03 1.124-.62 1.503-1.184.786-2.06 2.259-3.279 4.462-3.285 5.402-.015 10.824-.663 16.201.42 1.403.5 1.103 1.997 1.73 2.954-.262.962-.525 1.92-.787 2.878z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#434341"
        d="M285.139 394.94c2.065 3.234 1.873 5.266-2.657 4.975-7.831-.504-15.742 1.09-23.514-.905-.609-1.555-.899-3.088.318-4.518 8.641-1.258 17.276-2.043 25.853.448z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3C3B38"
        d="M136.837 395.04c.84 3.926-1.119 4.943-4.668 4.875-7.299-.139-14.603-.042-21.904-.042-1.467-2.256-.991-4.13 1.115-5.689 7.59-1.244 15.224-.489 22.842-.438 1.016.006 1.905.534 2.615 1.294z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#868686"
        d="M273.036 403.003c-39.782-.001-79.565.01-119.347-.035-1.907-.003-4.031.743-5.684-.966 39.948-.004 79.896-.015 119.845.015 1.754.002 3.705-.622 5.186.986z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E2D28"
        d="M58.934 398.984c-6.294 1.682-12.704.473-19.055.743-.988.042-2.077-.256-1.959-1.6.137-1.568-.037-3.423 2.26-3.716 6.36-1.409 12.745-1.066 19.136-.265.845.421 1.26 1.115 1.289 2.049-.116 1.192-1.102 1.866-1.671 2.789z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41403E"
        d="M310.964 397.064c.333 2.68-1.384 2.862-3.374 2.847-4.586-.036-9.178-.146-13.758.03-3.631.14-5.181-1.378-4.835-4.942 6.59-2.721 13.369-1.31 20.104-.922 1.461.471 1.208 2.011 1.863 2.987z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#363632"
        d="M107.002 398.004c-.956 2.135-2.896 1.815-4.665 1.828-4.263.03-8.532-.138-12.787.049-4.654.205-4.641-1.717-2.532-4.873 6.059-2.735 12.362-1.428 18.56-.908 2.003.168 2.357 2.072 1.424 3.904z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#31312C"
        d="M83.981 395.008c-.262 3.705-2.32 4.97-5.915 4.856-5.246-.165-10.503.024-15.756.063-1.272-.785-.82-2.029-.842-3.152.54-1.577 1.636-2.535 3.238-2.942 4.897-.518 9.809-.182 14.715-.234 1.662-.019 3.282.159 4.56 1.409z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#33332E"
        d="M358.024 395.967c.798 2.565.843 4.242-2.84 3.939-4.303-.354-8.657-.134-12.987-.063-2.48.04-4.593-.464-5.82-2.869-.016-2.309 1.434-3.271 3.433-3.228 5.507.12 11.03-.389 16.526.366.853.353 1.328 1.052 1.688 1.855z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41403E"
        d="M161.891 390.981c-1.05 2.38-2.739 3.228-5.44 3.092-5.145-.258-10.311-.074-15.468-.074-.274.398-.553.402-.836.01-.439-1.464.022-2.739.826-3.942-.195-1.227.624-1.452 1.549-1.577 6.35.642 12.813-.933 19.101.975.547.423.636.93.268 1.516z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B3B38"
        d="M141.967 388.99l-.996 1.076-1.939-.056a2.684 2.684 0 01-1.585.435c-2.849-.469-6.73 1.07-7.335-3.772.165-1.343.908-2.218 2.158-2.69 6.188-.41 12.388-1.177 18.524.495 1.088.985 1.152 2.158.626 3.437-2.885 2.676-6.198 1.62-9.453 1.075z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3D3D39"
        d="M140.146 394.009c.279-.005.558-.008.836-.01 4.879 2.205 10.027.428 15.015 1.011 1.531 2.011 6.045-.478 5.969 3.957-7.266.397-14.578-.732-21.814.649-1.925-1.868-1.265-3.737-.006-5.607z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#434341"
        d="M258.158 393.788a2.465 2.465 0 00-.205-.781c-.6-1.136-.678-2.259.081-3.363 6.69-1.663 13.433-1.064 20.18-.453 1.873 1.193 2.123 2.795 1.176 4.692-6.552 1.37-13.184.156-19.766.598-.623.055-1.112-.175-1.466-.693z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A3936"
        d="M138.128 390.019l.904-.008-2.02 3.996c-5.673 1.032-11.397.226-17.093.472-1.534.066-2.495-.604-2.756-2.167-.087-1.458.471-2.55 1.813-3.197 6.467-1.503 12.781.308 19.152.904z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3D3D3A"
        d="M288.767 394.133l-3.501.017c-1.5.692-2.676.068-3.765-.926-.951-1.691-1.318-3.254.946-4.228 6.305-.275 12.617-.751 18.912.285 1.203.726 1.604 1.823 1.478 3.168-.319 1.565-1.362 2.106-2.854 2.036-3.739-.174-7.498.396-11.216-.352z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#32322E"
        d="M332.967 396.81c.86.503 1.879 1.085 1.664 2.173-.188.941-1.29.821-2.092.822-5.441.009-10.887.099-16.322-.074-1.396-.045-4.357.244-2.191-2.886 6.312-.562 12.626-.513 18.941-.035z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262521"
        d="M380.969 396.852c.539.592 1.509 1.168 1.531 1.779.055 1.526-1.358 1.073-2.216 1.087-5.653.09-11.308.108-16.962.15-1.446-.499-2.26-1.303-1.41-2.912l.072-.027c6.326-.72 12.655-.601 18.985-.077z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A3737"
        d="M40.934 392.929l.819-1.205c3.674-1.241 7.315-1.102 11.17-.562 6.69.938 13.489.168 20.241.371 5.526.51 11.205-1.243 16.604 1.129.328 3.146-1.692 1.524-2.951 1.452l-2.562.035c-6.603.768-13.229.122-19.842.347-1.55.091-3.094.882-4.651.044-5.311-.119-10.623.023-15.933-.086-1.112-.022-2.854.71-2.895-1.525z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4F4E4E"
        d="M117.865 391.853c.475 2.616 2.538 2.131 4.286 2.143 4.954.032 9.908.012 14.862.012l-.176 1.033-25.813-.03a1.114 1.114 0 01-.282-.748c.005-.275.033-.412.08-.414.529-.694 1.263-1.068 2.069-1.324a4.71 4.71 0 011.184-.106c.995.186 1.857-.182 2.688-.681a1.212 1.212 0 011.102.115z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D4C4C"
        d="M282.144 392.968l3.12 1.181a5.603 5.603 0 00-.126.792l-26.06.075c-.344-.226-.461-.455-.352-.688.11-.234.222-.352.335-.352l20.056-.009c.816-.918 1.854-1.162 3.027-.999z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#504F4F"
        d="M86.817 394.114c1.119-.222 2.418.087 3.212-1.091.511-.655 1.219-.929 2.013-1.043a6.41 6.41 0 011.578.019 7.634 7.634 0 011.561.35c4.241.955 8.78-.891 12.882 1.366.531.781.6 1.562-.008 2.339l-1.053 1.95c.197-2.835-1.576-3.079-3.787-3.046-5.398.082-10.798.041-16.197.05a5.954 5.954 0 00-.201-.894zM288.767 394.133c3.226-.042 6.452-.101 9.678-.119 1.66-.01 3.327.066 3.673-2.152a1.29 1.29 0 01.962-.274c.531-.024 1-.23 1.441-.539a1.75 1.75 0 011.096-.33 27.047 27.047 0 014.602 3.209c.146.462.008.826-.374 1.107L288.997 395l-.23-.867z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D4C4C"
        d="M356.993 395.003c-5.347-.005-10.694.04-16.04-.043-1.902-.029-3.598.095-4.576 2.015l-.426-.977c-.523-.915-.561-1.771.308-2.517 6.755-1.512 13.519-1.362 20.288-.087.598.412.746.949.446 1.609z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#989898"
        d="M356.993 395.003c.038-.305.091-.606.159-.905.89-1.188 2.211-1.513 3.536-1.438 6.38.354 12.89-1.339 19.13 1.191l.221.221c-5.035 2.085-10.303.391-15.429.957-2.203.243-4.599-.813-6.586.938l-1.031-.964z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4C4B4B"
        d="M40.934 392.929c4.41 2.206 9.119.597 13.668 1.048 1.817.181 3.662.072 5.494.096.249.372.196.695-.16.969-6.579-.447-13.206.632-19.757-.631l-.069-1.221c.277-.08.552-.167.824-.261z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D4C4C"
        d="M63.916 394.063l20.339.086a8.924 8.924 0 01-.273.859c-6.694-.032-13.388-.064-20.083-.098-.285-.194-.377-.384-.278-.571.099-.185.196-.276.295-.276z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#959595"
        d="M332.967 396.81l-18.941.035c6.311-1.432 12.624-1.368 18.941-.035z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#989898"
        d="M380.969 396.852l-18.984.077c6.322-1.594 12.65-1.455 18.984-.077z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#959595"
        d="M309.845 395.034l.219-.993c5.347-2.719 10.836-1.939 16.347-.666.219.227.435.455.65.685-3.773 1.965-7.824.515-11.723.952-1.697.191-3.866-.661-4.374 2.052l-1.119-2.03z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#959595"
        d="M329.908 394.133c-.949-.024-1.898-.05-2.848-.073a21.073 21.073 0 00-.408-.331c-1.572-.878-2.004-2.362-2.131-4.01.073-.462.289-.846.641-1.154.835-.466 1.693-.476 2.568-.127.995.566 1.259 1.623 1.713 2.553.279.521.556 1.046.803 1.585.137.374.16.758.08 1.147l-.418.41z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#878686"
        d="M108.056 396.054l-.021-2.03c.971-.854 1.928-.86 2.869.047.059.311.099.624.12.939-1.057 1.495-1.496 3.088-.761 4.864-2.13-.468-.614-3.043-2.207-3.82z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#868686"
        d="M258.122 390.045l-.168 2.962c-1.07.544-.266-2.955-2.02-.936-.342-.684-.684-1.367-1.025-2.052-.296-.494-.241-.946.165-1.356.963-.581 1.923-.577 2.881.011.397.415.453.872.167 1.371z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9E9E9E"
        d="M62.005 397.006c-.308 1.017-.283 1.998.304 2.921-1.137-.266-1.848-2.066-3.375-.942l.938-2.047c.865-.415.47-2.237 1.824-1.895.987.249.886 1.19.309 1.963z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#959595"
        d="M335.909 394.055c.015.647.028 1.296.042 1.943l-6.043-1.865L330 394c1.984-1.504 3.957-1.807 5.909.055z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#989898"
        d="M361.912 396.956c-.475 1.426.523 2.142 1.408 2.912-1.242.205-2.101-.288-2.536-1.46-.393-1.054.291-1.325 1.128-1.452z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#868686"
        d="M259.062 393.977l.016 1.039-.11 3.994c-1.618-1.53-.902-3.423-.81-5.221.3.066.602.129.904.188zM255.78 399.889l.166-4.867c1.508 1.675 1.832 3.311-.166 4.867z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDBDBC"
        d="M78.033 429.94c-8.939-2.042-18.165.285-27.102-1.779 1.124-1.072 2.529-.629 3.81-.63 25.64-.026 51.288-.462 76.916.082 40.267.854 80.537 1.271 120.799.771 38.103-.472 76.202-.97 114.308-.841 1.765.006 3.665-.639 5.306.622-4.247 1.796-8.699.441-13.037.848-4.393 1.123-8.939.719-13.357.813-16.781.36-33.5 1.86-50.281 2.285-29.943.759-59.886 1.689-89.834 1.303-32.09-.414-64.192-.912-96.243-2.589-9.789-.513-19.584-.806-29.371-1.332a3.407 3.407 0 00-1.914.447z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7F7E7E"
        d="M372.07 428.166c-24.459-.004-48.927-.404-73.371.198-8.951.221-17.932.222-26.883.7-31.909 1.703-63.869 1.639-95.752.643-39.721-1.242-79.43-1.591-119.154-1.717-1.993-.007-3.986.11-5.979.17l-8.82-.283c1.553-1.463 3.487-.853 5.248-.854 108.764-.031 217.529-.03 326.293.001 1.76.001 3.696-.61 5.242.865l-6.824.277z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDBDBD"
        d="M78.033 429.94c7.834-2.061 15.916-1.439 23.673-.618 7.424.786 14.916.99 22.281 1.337 11.753.554 23.538 1.276 35.331 1.376 25.605.219 51.229 1.387 76.806.706 17.785-.474 35.577-.064 53.334-.85 23.189-1.025 46.321-3.366 69.575-2.878-4.32 2.086-9.09 1.177-13.607 1.747-8.525 1.076-17.23.646-25.824 1.304-14.44 1.107-28.923.304-43.34 1.077-33.763 1.811-67.536.857-101.287.549-13.093-.119-26.257.032-39.345-.795-14.902-.94-29.825-1.227-44.722-2.057-4.274-.237-8.565-.811-12.875-.898z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9E9E9E"
        d="M144.996 412c1.122-3.238 3.763-3.027 6.476-3.025 41.178.036 82.356.025 123.533.025 1.139.732.962 1.91 1.02 3.009l-.01 1.986c-2.72.859-5.5 1.035-8.35 1.032-38.952-.041-77.905-.029-116.857-.022-2.313.001-4.684-.322-6.809.996L144 412h.996z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D04C4A"
        d="M105.324 71.846c1.676.973 2.774 2.423 3.478 4.201-1.966 4.326-6.777 5.375-9.782 8.504-1.271.845-3.11.406-4.115 1.844-1.673 2.745 1.685 6.034-.944 8.659l.076-.076c-2.252.81-3.226-.543-4.059-2.306-.958-2.025-2.395-3.025-4.37-1.771 4.33-.198 4.766.67 2.677 5.896-2.396.378-4.261 1.761-6.086 3.219-1.783-.074-2.173-2.103-3.651-2.566-.632.227-1.057.702-1.509 1.153-1.828 1.424-3.698 2.772-5.763 3.821-1.831.341-2.713 1.895-3.894 3.076-.687.719-1.51 1.116-2.514 1.12-1.596-.213-2.703-1.182-3.675-2.363-2.28-4.044 1.145-5.332 3.525-6.855 9.24-5.919 18.407-11.95 27.633-17.891 2.938-1.892 5.708-4.021 8.55-6.049 1.296-.927 2.481-2.369 4.423-1.616z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BB3C3B"
        d="M116.938 90.004l1.292 1.987-.045 1.794c-.046.235-.092.471-.135.707-3.317 4.391-8.363 6.43-12.83 9.174-16.827 10.339-32.59 22.276-49.38 32.663a35.885 35.885 0 01-4.855 2.504c-1.456.289-1.639-1.662-2.93-1.663.626-2.974 3.328-3.912 5.41-5.398 15.802-11.281 32.533-21.146 48.724-31.836 4.947-3.267 9.292-7.426 14.749-9.932z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F5F5"
        d="M61.967 103.795l3.172 2.146c2.507 1.144.663 3.715 1.748 5.325-1.454 1.311-.667 3.102-.979 4.655-1.253 6.246-2.253 7.074-8.718 7.008-2.92-.909-6.396.529-8.918-2.1-1.148-1.22-2.025-2.594-2.415-4.246-.7-4.5.594-7.808 5.403-9.011 1.488-.372 2.686-1.217 3.675-2.368 1.979-2.305 4.296-2.891 7.032-1.409z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C64543"
        d="M48.837 120.011c2.471 1.866 5.767 1.375 8.351 2.919-5.428 1.646-9.464 5.289-13.281 9.248-1.718-1.798-2.936-3.912-3.903-6.184 1.33-4.416 4.245-6.39 8.833-5.983z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C34241"
        d="M112.061 81.987l2.856 4.05-10.796 6.965c-1.273-.574-1.723-1.693-1.961-2.956a5.033 5.033 0 01.1-1.478c2.327-3.587 5.28-6.253 9.801-6.581z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0DEDE"
        d="M88.284 96.797c-.294-.383-.842-.767-.839-1.147.01-1.421 3.295-2.933.164-4.191-2.808-1.128-2.118 2.395-3.565 3.941-1.302-3.087-.169-4.614 1.998-5.52 2.137-.893 4.287-.367 4.775 1.956.437 2.08 1.688 2.574 3.22 3.142 1.274 2.414 1.686 4.706-.932 6.567-.811-.836-.655-1.726-.146-2.635-.402-3.262-2.124-3.603-4.675-2.113z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CA4847"
        d="M70.909 102.211c1.403-2.239 3.502-3.49 5.978-4.206.794.517 1.138 1.305 1.324 2.189.224 2.057.349 4.096-1.204 5.784-.575 1.025-2.083 1.417-1.972 2.907-1.694.793-1.865-.901-2.639-1.611-.845-1.585-2.665-2.885-1.487-5.063z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1E1E1"
        d="M78.064 95.168c2.456.696 3.123 2.919 4.134 4.848 2.6 1.022 2.712 3.222 2.611 5.604-1.564.43-2.067-2.159-3.731-1.364a1.94 1.94 0 01-.673-1.012c-.184-1.799-1.638-2.816-2.569-4.161-.345-1.332-.745-2.665.228-3.915zM70.909 102.211l2.223 4.568c.405 1.224-.168 1.497-1.245 1.28-1.359-.549-1.782-2.891-3.88-2.027-.903.255-1.246-.128-1.15-1.01 1.92-.116-.612-6.65 4.052-2.811z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1E4E4"
        d="M93.96 95.054c.442-1.726-.486-3.188-.826-4.775-.38-1.771-1.365-3.993 1.489-4.886.463.104.764.383.91.837.199 1.287.113 2.692 1.514 3.455.333.319.58.692.759 1.116.351 1.155.347 2.3-.095 3.434-.385.646-.828 1.168-1.687.754-.688.021-1.376.042-2.064.065z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBCECD"
        d="M92.958 98.91l.146 2.634c-2.091 1.939-3.947 1.493-6.604-1.096 2.959.287 4.956.029 6.458-1.538z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD4D4"
        d="M81.003 103.021l.075 1.234c-.678 2.18-2.401 1.889-4.071 1.723l.173-5.877c2.003-.307 1.34 1.835 2.304 2.463.52.117 1.086.083 1.519.457z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEDADA"
        d="M96.024 94.988l1.064-1.169c1.593-.518 3.035-.025 4.449.662.146.165.289.334.432.503-1.979 3.907-3.962 1.908-5.945.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD4D3"
        d="M71.887 108.06l1.245-1.28 1.902 2.107c-.136 1.032 1.743 2.564.35 2.828-2.197.416-3.039-1.718-3.497-3.655z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F5F5"
        d="M102.832 90.063l1.289 2.938c-.287 1.128-.89 1.912-2.151 1.982l.087.033c-1.05-1.029-1.298-2.263-.938-3.655.312-.77.735-1.401 1.713-1.298z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CA504E"
        d="M66.856 105.022l1.15 1.01-1.12 5.232-1.748-5.324 1.718-.918z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F5F5"
        d="M181.006 65.848c4.583 1.626 7.459 4.844 8.826 9.468 2.059 1.851.8 3.884.337 5.878-1.082 3.163-3.267 5.361-6.111 6.988-5.436 2.257-10.811.92-16.19-.282-.661-1.45-.289-3.004-.451-4.504-.776-2.38-1.909-4.68-1.631-7.295.146-1.561.684-2.997 1.367-4.392 2.146-3.16 3.878-6.957 8.842-5.885l5.011.024z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D04C49"
        d="M175.994 65.824c-3.5.975-5.944 3.316-7.997 6.167-5.277-3.347-10.822-4.482-16.8-2.028-.009-3.576.186-7.1 2.604-10.047 5.771 2.011 11.815 2.48 17.827 3.046 2.076.195 4.045.164 4.366 2.862z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAEAEA"
        d="M266.012 424.988c5.952.519 12.007-1.068 17.888.879l-17.917-.024c-.325-.187-.432-.372-.323-.556.108-.183.217-.275.328-.275l.024-.024z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F2F2"
        d="M265.988 425.012c.005.277.003.555-.005.831l-12.903.003c4.201-1.852 8.617-.367 12.908-.834z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CA4745"
        d="M241.152 80.221l-.354 5.793c-6.455-.979-12.91-1.96-19.366-2.938-1.529-.231-2.946.057-4.232.932-1.728-2.522-3.238-5.362-7.06-4.854-1.857-2.468-.25-3.713 1.702-4.839 2.676-.887 3.867 1.097 5.247 2.714 4.882-2.541 9.687.159 14.451.549 3.145.258 7.165-.819 9.612 2.643z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C84644"
        d="M189.127 81.008l.706-5.692c2.655-4.06 5.418-3.121 8.226-.179 4.719 1.617 5.639 4.937 3.264 11.771-3.649-2.824-8.269-3.645-12.196-5.9z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFDBDA"
        d="M201.234 86.911c-.104-.477-.25-.947-.307-1.43-.422-3.598 1.847-7.937-2.869-10.345 2.402.426 3.039-4.147 6.006-2.121 1.691 2.595.076 5.344.385 8.007-.307 2.379.481 5.364-3.215 5.889z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CB4B49"
        d="M203.248 80.975l.816-7.959 4.913 1.895c-.166 3.044.981 6.098-.067 9.128-.65 1.327-1.534 1.597-2.456.325-.927-1.28-1.729-2.642-3.206-3.389z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2E6E6"
        d="M207.912 84.984c-.25-3.422-.35-6.828 1.065-10.073l1.766-1.058c1.046-.471 1.305.032 1.208.977-.95 1.206-2.896 2.143-1.105 4.089.933-.569 1.259.026 1.506.78-.302 1.892-1.065 3.651-1.58 5.487-.361.687-.89 1.148-1.685 1.25-.816-.139-1.348-.51-1.175-1.452z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFD9D9"
        d="M211.952 74.83l-1.208-.977c3.514-1.735 5.933-1.285 6.347 3.176-2.088.141-2.734-3.085-5.139-2.199z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#578FBF"
        d="M357.938 309.924l-1.872.638c-.792 1.931-2.577 1.611-4.123 1.841-.661.036-1.327.002-1.987-.079-1.617-.198-3.58.018-4.243-1.913-.633-1.842.782-3.139 1.925-4.314 6.146-6.323 12.44-12.498 18.666-18.742 4.463-4.478 8.903-8.978 13.43-13.391 1.377-1.342 2.553-3.197 4.94-2.865.733.438 1.466.874 2.198 1.313 1.326 1.309 2.652 2.615 3.979 3.923-.012.243-.027.485-.045.728-.328.05-.77-.021-.965.167-10.986 10.555-22.517 20.58-31.903 32.694z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0B0C0D"
        d="M357.86 350.749c.023-13.56.048-27.12.07-40.68l8.99-3.38.074 45.307c-3.116.114-6.503 2.2-9.134-1.247z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E2E2D"
        d="M148.978 170.964c-1.694-1.586-3.792-.881-5.703-.888-28.183-.098-56.367-.135-84.55-.187 1.775-1.337 3.846-.866 5.801-.866 97.165-.021 194.329-.022 291.494.006 1.771 0 3.688-.55 5.283.794-1.936 2.262-4.598 1.575-6.998 1.585-17.774.067-35.549.043-53.323.028-4.15-.004-8.298.021-12.442.237-3.147-.539-6.321-.016-9.477-.196-7.678.224-15.386-.73-23.038.577-3.685 1.053-7.467.013-11.177.542-5.989.144-11.972-.338-17.963-.148-10.881-.022-21.762-.008-32.642.001-5.352-.176-10.699.258-16.05.166-4.014-.534-8.034.191-12.05-.029-3.673-.437-7.352.281-11.027-.023-2.095-.343-4.465.354-6.138-1.599z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#111212"
        d="M288.023 170.153c22.438-.022 44.877-.038 67.315-.077 1.988-.004 3.976-.165 5.964-.253 4.069.227 5.452 3.329 6.857 6.411-.056 31.087-.094 62.171-.215 93.255-.007 1.867.897 3.999-.908 5.619-2.271-2.325-1.629-5.296-1.635-8.043-.057-27.096-.029-54.192-.037-81.289-.001-2.491.133-5.003-.447-7.45-.757-3.195-2.468-5.495-6.07-5.553-20.42-.328-40.838-.042-61.604-.161.957 3.542 4.943 4.648 5.004 8.123-2.436 2.596-5.464 1.509-8.343 1.353-3.61-1.941-6.651-4.681-9.826-7.225-1.115-.895-2.652-2.031-2.016-3.595.566-1.391 2.334-.612 3.574-.743.805-.085 1.638.057 2.387-.372z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#090A0B"
        d="M302.008 180.955l-10.03-9.953h8.178c19.131 0 38.262-.004 57.393.003 6.553.003 9.285 2.557 9.402 9.282.151 8.647.035 17.3.04 25.95.014 22.957.03 45.914.046 68.871-2.719 3.186-5.346 6.467-8.998 8.686-2.088-2.029-1.445-4.669-1.449-7.086-.053-29.12-.023-58.241-.038-87.361-.003-6.832-.075-6.893-7.026-6.9-13.645-.015-27.29.028-40.935-.033-2.263-.011-4.726.529-6.583-1.459z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F4F4"
        d="M356.304 285.121c-3.277 3.746-8.126 4.16-12.379 5.838-.78.871-1.698.878-2.688.431-1.348-2.312 1.014-3.36 1.682-4.986 1.457-3.085-2.176-5.157-1.619-8.071.304-16.624-.361-33.244.348-49.851a7.063 7.063 0 011.082-3.156c.415-.651.926-1.231 1.472-1.774a80.617 80.617 0 004.556-4.613c1.334-1.313 2.479-2.81 3.984-3.953 3.027-2.007 4.203-.803 4.236 2.421.041 3.989.02 7.979.02 11.969.004 16.624.012 33.248-.011 49.871-.005 1.974.3 4.005-.683 5.874z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5992C4"
        d="M384.673 271.098c-12.175 12.085-24.354 24.163-36.507 36.27-.768.766-2.292 1.574-1.536 2.791 1.034 1.664 3.079.509 4.614.958-1.759 3.524-5.02 2.034-7.745 2.332-3.041.048-6.069-.01-8.871-1.441-3.519-2.464-1.708-4.949.262-7.039 4.534-4.811 9.077-9.628 14.118-13.931 5.148-.454 9.682-2.712 13.293-6.076 6.15-5.729 12.342-11.471 17.701-18 2.02.855 3.606 2.201 4.671 4.136z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D4D4E"
        d="M302.008 180.955c16.982.042 33.967.166 50.949.061 3.652-.022 5.273.603 5.246 4.87-.207 32.635-.145 65.271-.165 97.907l-.728.943c-1.49-1.356-.755-3.129-.763-4.693-.064-12.987-.299-25.982.028-38.962.436-17.294-1.569-34.522-1.023-51.808.047-1.519-.067-2.999-1.021-4.265-1.832-2.047-4.281-1.552-6.565-1.554-23.981-.024-47.962.013-71.943-.051-2.396-.007-5.08.72-6.983-1.621-1.854-1.424-4.025-.544-6.037-.829-4.826-1.8-9.428-4.125-14.191-6.076-1.7-.697-4.098-1.003-3.803-3.816l11.04-.107c.23.046.461.092.693.136 5.193 2.274 10.191 4.905 14.883 8.106 3.96.494 7.922.402 11.891.233 3.253-.035 6.55-.356 9.49 1.523 2.999.002 6 .002 9.002.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C97C9"
        d="M349.008 291.037c-2.77 5.894-8.482 9.151-12.486 13.939-1.432 1.711-3.793 3.007-2.574 5.875-.162.19-.324.38-.484.572-2.634.931-4.881-.121-7.094-1.371-.271-.178-.521-.388-.795-.563-7.605-4.917-7.434-7.222.9-12.106 2.564.09 5.258.567 6.896-2.234 2.207-2.027 4.344-4.181 7.618-4.317l2.936.128c1.694.024 3.388.051 5.083.077z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5C0AE"
        d="M356.93 183.007c.088 12.462.215 24.923.256 37.385.07 21.449.086 42.899.125 64.347-.338.126-.674.255-1.009.383-.071-21.637-.146-43.273-.219-64.91-.006-1.772-.001-3.546-.001-5.371-2.172-.054-2.678 1.828-4.055 2.3-2.148-3.235-2.324-6.398.342-9.457 1.166-.421 2.246-.074 2.543.062-.458-7.882-1.362-16.104.506-24.358.394-.567.898-.692 1.512-.381z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D54E4C"
        d="M61.967 103.795c-3.025-.204-5.626.42-6.752 3.662-.361 1.038-.792 1.687-2.057 1.591-5.936-.446-6.906 3.124-6.312 7.917-2.326-.396-1.688-1.864-1.37-2.824-2.708 2.039-5.319 5.044-9.64 4.934-1.604-1.723-2.06-3.798-1.867-6.072 1.661-1.933 3.879-3.135 5.977-4.475 20.21-12.914 39.943-26.552 60.057-39.611 2.345-.062 3.938 1.242 5.321 2.93-12.827 9.664-26.54 17.989-40.013 26.683-1.628 1.049-5.537 1.464-3.344 5.265z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DF5653"
        d="M34.131 107.982c.659-5.041 3.827-8.307 7.884-10.82 14.36-8.896 28.753-17.736 43.153-26.567 2.394-1.469 4.808-3 7.838-2.62.607 2.188-1.199 2.896-2.463 3.813-17.499 12.718-36.291 23.483-54.064 35.788-.695.482-1.484.741-2.348.406z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DB524F"
        d="M100.003 68.916c-.026 2.08-1.868 2.677-3.152 3.53a13822.05 13822.05 0 01-58.804 38.864c-1.208.794-2.712 1.138-4.078 1.691L33.948 110c3.749-3.881 8.467-6.451 12.925-9.324 14.814-9.545 29.576-19.165 44.104-29.14 1.926-1.322 3.982-2.398 6.02-3.518 1.179-.293 2.105.261 3.006.898z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DB5250"
        d="M96.997 68.02c-.904.945-1.67 2.1-2.733 2.805a19979.076 19979.076 0 01-58.026 38.345c-.66.435-1.521.562-2.289.832l.183-2.019c13.993-10.561 29.345-19.066 43.762-28.98 5.133-3.531 10.588-6.652 15.114-11.027a6.16 6.16 0 013.989.044z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CA4745"
        d="M97.027 90.006c-4.767.593-2.262-2.515-2.222-4.367 1.226-1.003 3.209-.114 4.208-1.686 2.087-4.092 6.696-5.061 9.789-7.906.621 2.235 3.395 3.29 3.259 5.94-3.016 2.408-7.003 3.575-9.115 7.138-1.942.507-4.023.072-5.919.881z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CE4B49"
        d="M35.836 119.074c2.104-1.266 4.454-2.256 6.257-3.86 3.016-2.682 3.94-.907 4.753 1.751l1.992 3.046c-3.582 1.054-6.635 2.887-8.833 5.982-1.744-2.093-3.247-4.331-4.169-6.919z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BB3D3C"
        d="M300.852 137.248c-1.321-3.326-.823-6.812-.9-10.248 11.868-12.449 24.241-24.396 36.378-36.578 1.582-1.588 3.338-2.788 5.695-1.432a14.691 14.691 0 016.064 2.975c-4.004 4.344-8.083 8.608-12.671 12.352a4.018 4.018 0 01-1.292.296c-2.309-.348-4.11.488-5.457 2.37-1.993 2.329-2.101 5.4-3.189 8.085-6.084 5.657-11.815 11.672-17.754 17.477-2.003 1.958-3.914 4.113-6.874 4.703z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0403E"
        d="M342.025 88.99c-2.532-.344-3.928 1.404-5.459 2.937-10.596 10.608-21.189 21.22-31.818 31.796-1.378 1.371-2.477 3.246-4.796 3.277-1.724-1.311-.281-3.818-1.946-5.151-1.409-3.399 1.542-5.009 3.068-7.102 1.24-1.702 2.818-3.204 4.685-4.305 1.97-.998 4.559-.333 6.163-2.307 2.141-7.869 9.057-11.89 14.128-17.356 2.128-2.294 3.808-5.546 7.637-5.702 2.719 1.432 6.018 1.63 8.338 3.913z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AC3231"
        d="M329.871 137.305c-2.605-.155-4.413-2.149-6.748-2.927-.874-.95-.447-1.961.194-2.649 4.011-4.299 7.567-9.105 12.939-11.927 3.598-1.317 3.235-5.928 6.338-7.661 4.753-2.8 7.851-7.404 11.938-10.919 1.491-1.281 2.652-3.644 5.318-2.216.369.923 1.245 1.01 2.038 1.231a4147.7 4147.7 0 001.094 3.771c-.44 1.473-1.351 2.628-2.419 3.698a29542.175 29542.175 0 01-27.422 27.424c-.946.947-1.942 1.808-3.27 2.175z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CF4B49"
        d="M288.015 116.841l-4.068-1.592-2.933-2.292c-1.458-1.875-.571-3.504.742-4.851 10.38-10.639 20.844-21.194 31.544-31.512.484-.466 1.154-.624 1.785-.823 1.835 1.525 4.629 1.104 6.242 3.077-2.063 4.071-6.293 6.406-8.371 10.469-5.891 1.313-5.914 1.348-4.594 7.104a1.652 1.652 0 01-.688 1.152c-.896.503-1.891.561-2.885.661-7.32.745-7.872 1.492-6.39 8.612-3.144 3.659-6.74 6.85-10.384 9.995z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D7504D"
        d="M305.081 70.957c2.292.449 4.31 1.473 6.114 2.937-.051.5-.154 1.024-.494 1.375-10.562 10.924-21.074 21.896-32.357 32.091-.366.33-.853.495-1.337.619-2.125-2.685-2.332-5.772-1.898-8.997 8.566-9.42 17.854-18.124 26.884-27.085.772-.767 1.786-1.531 3.088-.94z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DD5451"
        d="M305.081 70.957c-8.545 7.331-16.012 15.766-24.086 23.579-1.792 1.733-3.523 3.492-5.886 4.445 1.896-9.617 6.063-18.36 12.597-25.422 4.479-4.84 10.945-5.956 17.375-2.602z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D34D4B"
        d="M277.006 107.979c1.766-3.457 5.072-5.484 7.712-8.096 8.793-8.695 17.071-17.92 26.477-25.989 1.51.187 2.796.834 3.891 1.878-9.642 11.094-20.628 20.869-30.798 31.445-1.571 1.634-3.675 2.977-3.273 5.74-2.042-1.092-3.33-2.79-4.009-4.978z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C64443"
        d="M333.687 85.077c-5.887 5.8-11.627 11.761-17.739 17.313-2.166 1.968-1.206 4.726-2.816 6.616-1.73-4.001-3.016-8.19-5.096-12.043l-.05.081c2.25-1.691 5.512-2.118 6.58-5.286 2.678-2.415 5.267-4.919 7.832-7.45 1.368-1.35 2.671-2.989 4.995-2.488 2.283.729 4.578 1.432 6.294 3.257z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B63A39"
        d="M335.025 103.897c4.128-4.226 7.416-9.371 13.064-11.933 2.244.533 4.274 1.503 6.058 2.976-4.028 4.987-9.501 8.624-13.085 14.009-.918 1.357 2.012 3.646-1.055 4.49-2.174-1.028-4.117-.143-6.059.741-1.682-1.169-.605-4.01-2.92-4.799-1.089-.471-2.22-.896-2.33-2.336.717-1.725 2.043-2.616 3.861-2.832.446.08.967.145 1.265.466 2.002 2.153.396-1.158 1.201-.782z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B13635"
        d="M339.999 109.05c3.443-5.979 8.138-10.705 14.148-14.109 2.396.661 4.587 1.61 5.704 4.065-5.121 2.255-7.848 7.209-11.959 10.604-1.587 1.31-2.607 3.502-5.161 3.303-.415-1.64-.907-3.222-2.732-3.863z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CB4846"
        d="M327.393 81.819c-3.24 1.782-5.272 4.892-7.975 7.265-1.33 1.167-2.293 2.879-4.375 2.916-1.488-.459-2.662-1.131-2.039-3.018.505-5.242 4.918-7.274 8.324-10.134 2.236.553 4.26 1.54 6.065 2.971z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A42C2C"
        d="M336.992 141.165c-.648-.449-1.296-.897-1.943-1.347-.458-1.524.484-2.55 1.39-3.477a1480.047 1480.047 0 0123.097-23.108c.823-.807 1.746-1.654 2.959-1.658 1.668-.004 2.509.718 1.521 2.461-4.207 10.163-6.413 21.681-18.114 26.775-2.882 2.346-5.896 1.34-8.91.354z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A82F2F"
        d="M364.015 114.036c-.948-3.414-2.351-1.153-3.347-.153-8.573 8.612-17.088 17.283-25.619 25.936-1.893-.495-3.635-1.298-5.178-2.515 10.455-11.677 21.695-22.573 33.112-33.295l1.859 3.007c.911 2.335 1.129 4.658-.117 6.956l-.36-.022-.35.086z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAC2C2"
        d="M336.992 141.165c2.941-.841 5.985.933 8.908-.354.48 1.194.688 2.216-1.17 2.189-2.569-.036-5.139-.029-7.708-.041l-.03-1.794z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4E4E4"
        d="M364.726 113.972l.117-6.956c1.768 2.349 1.905 4.671-.117 6.956z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B33736"
        d="M80.002 129.004c-4.907 4.117-10.744 6.729-16.153 10.034-2.23 1.362-4.455 1.405-6.838.86-1.351-2.202.579-3.082 1.822-3.897 18.649-12.242 37.213-24.611 55.837-36.89.706-.465 1.495-.722 2.358-.697.5.1.894.36 1.186.777-.352 4.746-2.594 8.23-6.701 10.703-4.249 2.559-8.344 5.372-12.507 8.074-1.315 5.255.085 10.635-.734 15.911-2.639.482-2.294-1.706-2.616-3.095-.406-1.75-.184-3.569-.08-5.35-.283-1.541.934-3.691-.708-4.548-1.578-.823-2.876 1.117-4.254 1.902-3.562 2.031-6.894 4.453-10.612 6.216z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEECEC"
        d="M97.807 133.958c.045-4.042.033-8.085.168-12.123.044-1.323-.778-2.978 1.03-3.866-.003 5.727.021 11.454-.028 17.18-.013 1.531.549 3.46-1.901 3.825l-.041-.886c-.157-1.454-.521-2.947.772-4.13z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F5F5"
        d="M118.972 93.997c1.473 1.662 1.431 3.33.02 5.004-1.379-1.663-1.367-3.331-.02-5.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BB3C3B"
        d="M118.972 93.997l.02 5.004a6.5 6.5 0 00-.779.189l-.295-.235c-.484-.596-.851-1.244-.932-2.025-.013-1.046.394-1.955.937-2.818l.262-.326c.255.097.517.167.787.211z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B73A39"
        d="M117.922 94.111l.048 2.892c-15.652 11.205-32.017 21.339-48.016 32.022-5.369 3.585-10.927 6.905-15.946 11.001-1.388.565-1.798-1.348-3.024-1.193 2.407-3.418 6.381-4.655 9.624-6.908 18.801-13.066 37.958-25.589 57.314-37.814z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B63938"
        d="M54.008 140.026c-.012-1.881 1.626-2.441 2.792-3.216a21391.312 21391.312 0 0159.297-39.228c.524-.346 1.245-.394 1.873-.58l-.053 1.952c-9.342 4.964-17.695 11.458-26.55 17.175-10.124 6.535-20.182 13.175-30.229 19.83-1.582 1.048-3.708 1.632-4.129 3.938-.999.044-2 .086-3.001.129z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AE3433"
        d="M80.002 129.004c3.875-4.898 9.501-7.661 14.846-9.966 3.493-1.507 1.231 3.272 2.123 4.991-2.14 4.113-6.6 5.284-9.96 7.85l-7.009-2.875z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A72F2F"
        d="M87.011 131.879c1.815-4.526 6.936-4.859 9.96-7.851.394 3.301-.787 6.733.835 9.93.195 1.461.496 2.942-.772 4.13l-4.039-1.938-5.984-4.271z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B03535"
        d="M175.167 102.844c-1.652-.944-3.432-.868-5.229-.653-2.002.329-4.012.789-5.936-.325-.942-1.019-2.042-.99-3.213-.483-1.066-1.126-2.799-1.295-3.739-2.603l-2.002-1.889c1.926-3.854 5.385-2.414 8.187-2.011 6.529.941 13.094 1.615 19.607 2.655 11.562 1.848 23.214 3.065 34.766 4.981 2.112.35 4.447.46 4.398 3.523l-4.068.166c-2.317.378-4.632.565-6.933-.107-3.392-2.385-5.82-.758-7.996 1.921-6.03-.838-12.126-1.281-18.005-3.023-.919-.736-1.209-2.521-3.002-1.802-2.057 1.134-4.17 1.032-6.313.285-.176-.21-.349-.423-.522-.635z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AA3231"
        d="M185.003 104.996c6.231-.362 12.37-.17 18.005 3.023.15 1.095-.372 1.896-1.133 2.592l-1.822 1.425c-4.092.539-8.012-.874-12.04-1.06l-3.01-5.98z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A63131"
        d="M188.013 110.977c4.25-2.331 8.133-.498 12.04 1.06-1.114 3.561-4.251 5.655-6.229 8.984-3.372-2.744-3.778-6.884-5.811-10.044z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BEBEBE"
        d="M172.03 104.984l3.135-2.14-.187.08c2.173 1.44 4.795-.183 7.002 1.026-3.128 2.154-6.646.568-9.95 1.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2EDED"
        d="M181.981 103.951c-2.34-.301-4.913.992-7.002-1.026l7.021.27a9.063 9.063 0 00-.019.756z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B73A39"
        d="M150.078 89.977l-.237-2.035.305.113c3.348-2.635 6.904-1.115 10.477-.646 17.731 2.326 35.458 4.692 53.186 7.037 5.431.719 10.868 1.436 16.258 2.394 2.431.433 5.55.385 5.887 4.068-.882 1.601-2.184 2.615-4.023 2.88-9.85-.096-19.45-2.348-29.159-3.578-14.973-1.896-29.892-4.256-44.873-6.131-1.986-.249-3.94-.663-5.892-1.091-1.165-.67-.444-2.547-1.929-3.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BB3C3B"
        d="M235.954 100.907c-.646-1.362-1.808-1.779-3.225-1.974-9.333-1.28-18.66-2.603-27.985-3.938-7.856-1.125-15.681-2.541-23.567-3.368-10.357-1.087-20.56-3.518-31.031-3.573l-.001-3.053c6.283-1.955 12.254-1.149 17.958 2.025 5.296.022 10.597 2.399 15.887-.033 7.449-1.272 14.479 1.62 21.746 2.229 9.127.766 18.206 2.078 27.234 3.628 2.205.379 5.18-.139 6.013 3.122-.77 1.794-.493 4.227-3.029 4.935z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0403E"
        d="M238.982 95.974c-7.331-2.501-15.026-2.967-22.618-3.943-10.839-1.394-21.726-2.438-32.375-5.036 2.082-1.679 3.864-3.614 5.138-5.986 2.722.352 5.435.866 8.167 1.014 3.29.179 1.879 3.881 3.939 4.89 2.846-1.241 1.242-3.992 2.015-5.937 4.805-2.444 2.801 3.032 4.664 4.01l1.103 1.008c1.69.522 3.668.331 4.907 1.977 8.792-.104 17.296 2.256 25.981 3.051l.146 2.093-.34 2.843-.365-.046-.362.062z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B43837"
        d="M152.007 92.987c.988-1.249 2.41-1.116 3.689-.94 14.905 2.047 29.802 4.153 44.701 6.242 8.837 1.238 17.667 2.533 26.519 3.664 1.875.239 3.605.497 5.016 1.834-2.635 3.72-6.478 2.118-9.927 2.253-1.947-3.509-5.725-2.325-8.501-2.765-17.04-2.698-34.154-4.934-51.267-7.144-2.335-.302-4.954-.937-7.188.759l-3.042-3.903z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3F0F0"
        d="M211.004 106.099l6.932.107c-2.328 1.139-4.641 1.24-6.932-.107z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D8D8D8"
        d="M220.3 107.482c2.21-.501 3.432-.646 4.787-.044-1.389.893-2.681.636-4.787.044z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C64644"
        d="M210.057 84.897c-.355-2.068-.478-4.051 1.898-5.103 1.932-.819 3.109.136 3.71 1.814.679 1.896-.107 3.412-1.709 4.537.041.208.075.418.104.629-2.132 1.074-3.048-.442-4.003-1.877z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0DEDE"
        d="M213.956 86.146c1.008-2.646 2.605-5.476-2-6.352l-1.108-.876c4.559-1.331 5.721-.4 6.354 5.089-.57 1.493-1.549 2.361-3.246 2.139z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD7D7"
        d="M210.057 84.897l4.002 1.879-.138 1.192c-1.87-.078-3.794-.02-4.907-1.977l1.043-1.094z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B63938"
        d="M300.852 137.248c7.08-6.941 14.162-13.88 21.234-20.83.862-.849 1.814-1.435 3.06-1.428.876-.12 1.691.137 2.511.388 1.23.45 2.658.483 3.554 1.653-4.288 4.895-9.193 9.166-13.873 13.664-.825.792-1.843 1.356-2.259 2.502-4.441 3.293-8.943 6.489-14.016 8.774l-.211-4.723z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B23736"
        d="M315.078 133.197c3.709-6.925 9.406-11.87 15.928-15.993-.041-.656.205-1.21.597-1.717.708-.776 1.444-1.511 2.611-1.479 1.044-4.92 3.459-2.708 5.757-1.107 1.023 3.496-1.359 5.694-3.102 8.138-5.78 3.211-9.908 8.126-13.746 13.339.001.214-.041.419-.126.615-2.538-1.049-4.412-5.024-7.919-1.796z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F2F2"
        d="M164.002 101.865l5.935.325c-2.043 1.097-4.045 1.409-5.935-.325z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E2C4C4"
        d="M157.05 98.779c1.353.716 3.14.804 3.742 2.601-1.854.005-3.143-.802-3.742-2.601z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C94745"
        d="M151.198 69.963c.901-2.121 2.224-3.356 4.807-2.999 3.172.439 6.199 1.588 9.516 1.473 1.76-.062 2.688 1.63 2.477 3.555a4695.3 4695.3 0 01-1.076 4.012c-5.602 1.815-10.867.964-15.867-1.999l.143-4.042z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C34240"
        d="M151.055 74.004l15.867 1.999c.112 2.456.868 4.749 1.771 7.004-1.286 1.387-2.937 1.252-4.547.98-4.634-.784-9.356-.945-13.947-2.013-.374-2.727.311-5.341.856-7.97z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BC3E3C"
        d="M150.199 81.975c4.617-2.505 9.042.645 13.588.49 1.627-.055 3.271.348 4.906.542.559 1.451.968 2.881-.591 4.021l-17.958-2.025.055-3.028z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262620"
        d="M48.942 379.941l29.946.145c.699 1.375.131 2.505-.686 3.587-6.125 3.301-12.68 1.497-19.034 1.321-2.924-.081-5.75-1.002-8.797-.191-1.825.486-4.328.537-3.428-2.85.11-.812.221-1.623 1.044-2.076.311.131.629.152.955.064z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#282822"
        d="M43.9 387.938c.195-1.038-.156-2.293 1.146-2.894 5.019-1.143 10.093-.712 15.159-.536 7.068.245 14.128-.255 21.194-.255.975.489 1.21 1.336 1.122 2.334-2.336 5.358-7.139 3.443-11.167 3.724-1.859.13-3.522-.692-5.109-1.577-1.668-.465-3.371-.385-5.071-.254-3.655 2.109-7.401-.26-11.091.235-1.392-.062-2.569.682-3.854 1.038-1.176-.093-2.615.146-2.329-1.815z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#272720"
        d="M72.994 392.988c-10.182-.19-20.363-.377-30.543-.6-.237-.006-.465-.434-.697-.664l1.198-1.766c9.877-1.631 19.778-1.304 29.687-.349 1.372.995 1.153 2.157.355 3.379z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#535151"
        d="M72.985 390.084l-30.034-.125.95-2.021c.77 1.08 1.896 1.068 3.043.992.778-1.06 2.141-.278 3.039-.964 2.319-1.739 5.086-.539 6.876.222 2.158.917 2.062-1.045 3.121-1.159 2.01 1.479 4.041 1.352 6.086.08 5.245 2.445 10.478 3.396 15.678-.117.204.005.408.01.612.011 1.089-.428 1.904-1.986 3.388-.831 1.644 2.164 5.369.537 6.525 3.592a2.4 2.4 0 01-1.184 1.163c-6.076.512-12.179 1.77-18.1-.843z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#545454"
        d="M81.94 385.063l-36.894-.02 1.897-3.091c.283 2.043 1.882 2.468 3.281 1.883 2.962-1.24 5.653-.348 8.599-.16 6.277.397 12.789 1.52 19.031-.766 1.018-.151 2.007-.594 3.071-.302a2.467 2.467 0 011.367 1.284c.067.447-.041.84-.352 1.172z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C74543"
        d="M288.015 116.841c2.032-4.549 5.699-7.453 9.886-9.834 3.371-.041 6.157 1.109 8.099 3.979-2.453 3.777-6.802 6.158-7.994 10.863l-.999.049a26051.05 26051.05 0 00-8.992-5.057z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262421"
        d="M339.104 376.867c.444-2.895 2.746-1.801 4.301-1.826 8.223-.133 16.447-.11 24.672-.142 1.753.767 2.322 2.36 2.807 4.014-.654.846-1.531.948-2.498.754-2.059-1.022-4.157-1.116-6.298-.238a3.517 3.517 0 01-1.36-.021c-2.127-.893-4.248-1.753-6.236.304-.91.444-1.886.577-2.882.64-1.069.084-2.135.04-3.206.057-1.953-.017-3.904.043-5.851-.137-2.089-.196-3.211-1.347-3.449-3.405z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#272622"
        d="M372.969 381.07a2.13 2.13 0 00.124.863c.857 1.945-.333 3.039-1.896 3.105-5.801.244-11.707 1.608-17.332-1.102-.982-.962-1.584-2.056-1.172-3.486 6.062-2.865 12.283-1.24 18.469-.651l1.807 1.271z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#565555"
        d="M371.162 379.8c-4.412.064-8.825.081-13.235.217-1.726.053-3.649-.601-5.062 1.05-1.349-.126-1.53-.839-.967-1.925l2.986-.197c2.066-.924 4.131-1.189 6.195.004.27-.02.541-.023.813-.013 2.064-.843 4.126-.859 6.186.02l2.805-.042c.123.285.217.58.279.886z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2A24"
        d="M377.115 389.899c1.205.683 1.881 1.688 1.881 3.102-2.883.447-5.766.045-8.652.01-1.869-.144-3.696.156-5.527.478-5.008-.228-10.035.488-15.021-.428-.733-1.241-.673-2.408.305-3.5 9.024-1.476 18.037-1.974 27.014.338z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#545252"
        d="M377.115 389.899l-27.101.173c-2.058 1.82-4.587 1.301-6.995 1.428-4.697.246-9.443-.616-14.1.593-.935-.792-.865-1.935-1.043-2.99 2.547-2.563 6.096-1.092 8.996-2.249a9.605 9.605 0 011.761-.079c6.403 1.063 12.876.432 19.307.787 3.435.021 6.87.015 10.3.01 2.629-.021 5.254-.145 7.846-.662.293.053.582.119.867.199l.162 2.79z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A3737"
        d="M350.005 392.992l16.154-.02c1.421-1.112 3.313.195 4.733-.921 2.68.503 5.514-.321 8.104.949.274.283.549.566.823.851l-22.668.245-21.241-.042-5.91-.055a4.074 4.074 0 01-.326-.859c1.426-1.815 3.493-1.79 5.422-1.593 4.967.511 10.187-1.518 14.909 1.445z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#282821"
        d="M376.086 386.909c-1.456 3.782-4.662 1.456-7.041 2.019-.756-.744-1.703-.921-2.717-.918-3.2-.124-6.408.213-9.604-.23-1.1-.814-2.886-1.383-1.15-3.208 6.441.262 12.918-.801 19.33.519l1.182 1.818z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#595959"
        d="M374.904 385.09l-19.869-.006c-5.395 2.703-10.93 1.741-16.471.642-.586-.336-.856-.846-.813-1.52.968-1.438 2.5-1.488 3.996-1.627 2.76-.187 5.525-.072 8.287.01 1.322-.051 2.609.231 3.9.465 5.694 1.883 11.547.6 17.322.848 1.238.054 1.631-.929 1.835-1.968.606 1.051 1.21 2.104 1.813 3.156z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#424345"
        d="M132.984 351.093c1.989-.069 3.978-.2 5.967-.201 48.032-.012 96.064-.013 144.096-.003 1.989.001 3.979.131 5.968.201-.761.791-1.746.847-2.758.882-41.712 1.455-83.442 1.203-125.16.755-8.083-.087-16.236-.467-24.355-.749-1.311-.046-2.692.204-3.758-.885z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#111215"
        d="M357.86 350.749c2.764 2.474 6.106.714 9.135 1.247-.727.33-1.452.945-2.181.947-20.226.052-40.452.041-61.266.041 2.607-1.948 5.475.089 7.424-1.867l46.888-.368z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFE"
        d="M220.722 349.958c-45.575.019-91.15.038-136.725.046-1.992.001-3.984-.112-5.977-.173-1.885-1.84-1.729-4.254-1.731-6.56-.047-47.3-.047-94.6-.006-141.899.002-2.16-.019-4.353 1.237-6.281 2.047-1.8 4.246-1.682 6.525-.515 1.689 1.749 1.428 3.976 1.441 6.118.049 7.979-.045 15.96.053 23.926.068 1.823 1.852 2.168 2.825 3.217 1.434 1.493.214 5.403 4.198 4.569 11.639-.087 23.265-.1 34.881-.029 3.1-.443 1.734-4.69 4.562-5.376 1.957-.592 3.965-.434 5.954-.435 53.717-.014 107.434-.014 161.151-.002 1.825 0 3.662-.105 5.459.314 2.086.706 2.613 2.359 1.396 3.877-3.759 4.684-6.527 9.988-9.844 14.943-.561.837-1.534 1.247-2.518 1.533-2.63.642-5.308.486-7.968.487-43.333.014-86.667.149-130-.054-20.312-.096-40.625.003-60.936-.162-8.629-.07-11.024 3.257-8.757 11.863.457 1.732 1.404 2.516 3.079 2.711 2.161.252 4.328.189 6.493.189 62.333.006 124.666-.005 186.999.029 3.122.001 6.368-.547 9.271 1.253.803.821.814 1.725.281 2.686-2.637 1.974-5.73 1.449-8.672 1.44-29.273-.091-58.547.292-87.82-.211-8.138-.141-8.293-.01-8.101 7.87.456 18.628.084 37.256.243 55.883.058 6.719.366 7.03 7.057 7.065 8.816.047 17.633-.015 26.449.029 2.478.013 5.017-.22 7.296 1.121 1.725 1.632.732 3.104-.269 4.578-2.242 2.312-4.357 4.8-7.526 5.95z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3F3F3"
        d="M78.182 194.556c-.062 15.809-.168 31.618-.177 47.427-.02 35.949.007 71.899.016 107.849-4.458-.041-10.131 1.893-13.035-.698-3-2.677-.97-8.473-.977-12.884-.081-49.061-.052-98.12-.044-147.18 0-1.994.087-3.987.134-5.98 4.179-1.209 8.454-.298 12.673-.571.58-.031 1.102.13 1.565.481 1.244 1.686.947 3.656 1.03 5.558a45.593 45.593 0 01-.076 3.157c-.087 1.055-.292 2.068-1.109 2.841z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFE"
        d="M333.947 310.852l9.034 1.314c1.599 1.518 1.646 3.534 1.663 5.505.079 8.723.115 17.446-.021 26.169-.035 2.281-.023 4.716-2.603 5.943l-62.901.202c.967-5.844 5.826-10.835 11.221-11.527 11.635.074 23.264-.118 34.893.024 7.053.086 7.064-.011 7.113-7.289.031-4.654-.041-9.309.033-13.963.035-2.15-.053-4.368 1.702-6.05l-.134-.328z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F4F4"
        d="M342.021 349.783c1.238-1.771.973-3.799.973-5.775.001-10.614-.007-21.228-.012-31.842 2.724-.586 5.653.449 8.261-1.051l4.822-.553c1.463 8.733.418 17.531.604 26.297.086 4.107 1.817 9.465-.715 12.034-2.753 2.791-8.189.632-12.44.956-.494.039-.996-.04-1.493-.066z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#665040"
        d="M220.722 349.958a27.873 27.873 0 016.085-6.032c5.589-2.085 11.458-1.85 17.271-2.094a12.497 12.497 0 013.931.152c2.724.922 5.542.569 8.328.593 4.114-.396 8.193-1.049 12.377-.895 5.072.186 7.995-4.089 6.66-9.323-.578-2.547-3.145-4.398-2.579-7.348a2.068 2.068 0 011.351-.586c3.221.587 4.134 3.593 5.954 5.658 4.519 6.709-.215 16.125-8.672 17.166-2.121.261-4.276.188-6.409-.082-5.668-2.123-11.463-.148-17.196-.349-7.343-.256-14.864-.145-21.804 3.134-1.766.003-3.531.005-5.297.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#52412E"
        d="M289.025 339.082c-4.447 2.595-7.067 6.849-9.906 10.903l-35.092-.037c.182-2.594 2.112-2.637 3.997-2.753 4.214.438 8.451 1.244 12.525-.743a4.427 4.427 0 012.19-.219c6.685.843 13.293 1.508 17.638-5.401.806-1.282 2.187-2.021 3.5-2.749 3.581-.468.568-4.51 3.016-5.591 1.198-.188 2.255.271 3.322.702 1.182.657 2.759.877 2.977 2.629-.584 2.114-2.075 3.071-4.167 3.259z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5D4939"
        d="M247.999 348.002c-1.564.159-2.942.698-3.972 1.946l-18.009.005c2.308-2.693 5.575-3.746 8.788-3.946 9.11-.567 18.249-.705 27.378-.918.931-.021 1.876.592 2.815.911.076 1.82-.851 1.643-2.007 1.006l-1.992-.003c-4.225 1.736-8.663.721-13.001.999z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#92ABB8"
        d="M77.906 183.133l-13.808-.044a3.308 3.308 0 01.02-.889l13.889-.104c.293.377.276.724-.101 1.037z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#585959"
        d="M209.037 175.051c-12.08 1.581-23.644 6.306-36.047 5.913-1.086-3.506 1.889-3.691 3.836-4.459 8.901-3.508 18.262-4.828 27.734-4.92 11.561-.112 23.184-.367 34.434 3.172 2.214.697 4.489 1.256 6.585 2.239 1.561.731 3.618 1.434 2.431 3.968-7.758 1.541-14.611-2.629-21.994-3.53-5.121-.625-10.54-.244-15.133-3.363-.454.628-.785 1.491-1.846.98z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#91AFBD"
        d="M77.906 183.133l.101-1.037c36.411-.08 72.822-.173 109.232-.235 27.267-.046 54.533-.053 81.8-.077 20.915.079 41.83.15 62.744.241 7.137.031 14.274.093 21.41.181 1.28.016 2.69-.382 3.736.802l-1.098.127c-4.521 2.722-9.459 1.158-14.226 1.389-9.466.328-18.935.183-28.399.195-33.599.045-67.201.306-100.797-.04-34.435-.354-68.868-.129-103.302-.183-8.309-.013-16.618.305-24.926-.058-2.134-.094-4.379.272-6.131-1.447l-.144.142z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#555556"
        d="M248.011 180.964c-.25-2.102-1.993-2.412-3.544-2.979-6.249-2.283-12.714-3.95-19.248-4.833-16.382-2.212-32.518-.787-48.203 4.704-1.693.594-3.689.77-4.026 3.108l-5.984-.001c.19-3.07 2.89-3.36 4.899-4.155 7.112-2.815 14.46-4.813 22.074-5.749l33.044-.001c8.275.913 16.303 2.8 23.914 6.233 1.704.769 4 1.024 4.06 3.671-2.33.002-4.658.002-6.986.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#525253"
        d="M254.996 180.963c-6.988-4.131-14.688-6.258-22.533-7.939-1.921-.412-3.862-.656-5.44-1.966l17.986.003c3.659 3.669 9.093 3.75 13.199 6.531 1.618 1.096 3.815 1.354 4.795 3.362l-8.007.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#525353"
        d="M193.979 171.06c-6.819 2.214-13.635 4.44-20.46 6.635-2.346.755-4.698 1.47-6.513 3.27l-8.003-.007c3.473-5.326 9.238-6.879 14.725-8.808 1.356-.477 2.988-.118 4.265-1.09h15.986z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D4E4E"
        d="M177.991 171.06c-4.428 3.093-10.042 3.767-14.376 7.085-1.422 1.089-3.069 1.884-4.613 2.813l-8.002-.014c-.491-2.542 1.525-3.359 3.119-4.356 3.725-2.329 7.705-4.143 11.876-5.529 3.999-.001 7.997 0 11.996.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#484849"
        d="M165.995 171.058c-2.601 3.249-6.883 3.644-10.086 5.914-1.734 1.229-3.888 1.875-4.909 3.972l-9-.001c-.072-3.353 3.041-3.832 4.93-5.361 2.416-1.956 5.335-3.098 8.07-4.531l10.995.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B3C3D"
        d="M126.996 180.926c1.018-3.23 3.716-4.542 6.435-6.046 1.458-.806 2.4-2.546 3.575-3.864l8.994.007c-1.315 5.647-6.758 6.636-10.639 9.376-.362.256-.954.218-1.351.546l-7.014-.019z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#414243"
        d="M134.009 180.944c3.384-4.047 8.884-5.538 11.99-9.922l2.979-.058c2.007.027 4.015.056 6.023.085-2.022 3.485-6.197 4.025-8.927 6.527-1.304 1.194-3.287 1.56-4.074 3.365l-7.991.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#424241"
        d="M209.037 175.051l1.848-.981c-.069.904.557 2.18-.882 2.422-.74.124-.882-.785-.966-1.441z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#30302A"
        d="M295.95 374.854c5.017.01 10.034.02 15.051.027l2.894.124c1.241 1.283 2.521 2.559.964 4.451-1.567 1.089-3.376.885-5.134.963-3.277-.01-6.555.038-9.83-.044-2.215-.056-4.275-.438-5.258-2.815-.221-1.219-.528-2.485 1.313-2.706z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2B25"
        d="M316.936 376.03c3.205-2.088 6.699-.687 10.066-.83.328.416.444.885.358 1.408-.266 1.311-.8 2.449-2.033 3.137-2.38.84-4.748.879-7.105-.102-1.236-.915-1.819-2.067-1.286-3.613z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A2A24"
        d="M327.002 375.901v-.703c3.847-.056 8.09-1.649 10.779 2.781-1.257 3.039-3.954 2.152-6.271 2.311a5.904 5.904 0 01-2.257-.61c-1.38-.88-2.05-2.19-2.251-3.779z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#565555"
        d="M330.932 379.15c2.281-.403 4.778.446 6.852-1.172.438-.37.879-.74 1.32-1.11 2.633 3.834 6.721 1.354 10.018 2.31.176.577.015 1.036-.48 1.38-2.473 1.217-5.229.75-7.814 1.321-3.183-.26-6.431-.075-9.479-1.325-.5-.361-.638-.829-.417-1.404z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="gray"
        d="M316.936 376.03l1.067 2.97c-.966.845-1.929.845-2.892-.005l-1.217-3.989c1.174-.137 2.122.402 3.042 1.024z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2B25"
        d="M82.052 384.075l-1.109-1.117c-.52-1.327-.009-2.263 1.125-2.962.682-.324 1.363-.648 2.045-.974 5.529 2.107 11.272.456 16.892.969.546-.43.98-.336 1.303.282.198 1.557-.401 2.791-1.524 3.821-4.695 2.423-9.709.964-14.588 1.193-1.385-.388-2.987-.043-4.144-1.212z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#838383"
        d="M82.068 379.996l-1.125 2.962c-1.04.635-2.086 1.688-3.089-.048l1.034-2.824c.096-.299.176-.603.241-.909 1.062-.02 2.199-.312 2.939.819z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#565555"
        d="M113.89 377.938c.993 1.644 1.974.655 2.957-.014 2.577-.418 5.163-.893 7.37 1.128.118.649-.094 1.16-.632 1.541-5.68 1.561-11.367 1.473-17.063.078-.602-.362-.794-.88-.581-1.549 2.64-.461 5.506.6 7.949-1.184z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6C6C6C"
        d="M105.94 379.122c.013.248.008.496-.013.743-.188 1.073-.906 1.491-1.914 1.558-.998-.061-1.583-.798-2.264-1.381l-.375.017-.369-.067c0-.296.017-.592.048-.886l4.887.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#575656"
        d="M105.931 376.774c-.532.503-.806.966-1.161 1.039-.333.069-.75-.275-1.131-.438.288-.337.518-.816.883-.967.285-.116.738.174 1.409.366z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B595A"
        d="M144 374.906c0-.292-.003-.585-.008-.877l13.015.043c-.003.283-.003.566-.001.85-4.34 2.607-8.674 2.23-13.006-.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2D27"
        d="M124.049 379.085c-2.374-.553-5.071.898-7.202-1.161.165-1.376.679-2.512 2.085-3.034 5.968.084 11.937.169 17.904.255l-.837 3.855c-2.275 2.171-5.125 1.149-7.748 1.401-1.533-.015-3.02-.182-4.202-1.316z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6C6B6B"
        d="M295.95 374.854c-.825.511-.925 1.295-.814 2.158-.164.08-.328.159-.488.241-.626-.226-1.255-.44-1.858.095a1.677 1.677 0 01-1.089-.245c-.586-.629-.75-1.381-.665-2.206a6.683 6.683 0 01-.001-.788c1.632-1.111 3.312.1 4.962-.104-.008.284-.024.567-.047.849z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E6D6D"
        d="M272.964 373.823l.086 1.251c.703.752.777 1.587.331 2.49-2.072 1.432-2.403-1.11-3.643-1.59a2.686 2.686 0 01-.704-1.063 7.025 7.025 0 01.006-.795c1.308-.096 2.616-.194 3.924-.293z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#363632"
        d="M233.977 374.908h11.031l2.776 1.201c1.141.964 1.056 2.045.307 3.192-2.399 1.687-5.156.897-7.768 1.123-1.448.096-2.896.01-4.345-.007-3.068-.295-6.662.88-8.456-3.004-.239-.912-.125-1.739.603-2.411 1.951-.03 3.901-.063 5.852-.094z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#34342F"
        d="M269.034 374.912c.323.065.65.095.98.087 1.025 1.366 1.189 2.774.211 4.241-2.125 1.634-4.631 1.011-7.003 1.184-1.773-.002-3.548-.006-5.324 0-2.315-.226-4.854.582-6.776-1.46-.496-2.929.579-4.141 3.693-4.018 4.732.188 9.479-.004 14.219-.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#565555"
        d="M251.122 378.964l6.938.131c.226.661.041 1.174-.553 1.543-5.688 1.434-11.376 1.478-17.063-.025-.582-.393-.74-.917-.477-1.567l8.185-.063c.633-.582 1.257-.573 1.873.028l1.097-.047z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#898989"
        d="M250.024 379.011l-1.874-.028-.366-2.874c3.993-1.54 1.562 1.881 2.24 2.902z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#383834"
        d="M211.967 374.902l11.068-.009c2.634.424 1.813 2.494 1.957 4.105-1.948 1.996-4.478 1.202-6.797 1.425-1.771-.002-3.543-.005-5.316 0-2.321-.222-4.86.577-6.801-1.436-.768-5.297 3.234-3.72 5.889-4.085z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#363631"
        d="M185.947 374.884l15.079-.001c2.625.445 1.783 2.499 1.905 4.105-1.939 2.007-4.468 1.211-6.783 1.435-1.775-.001-3.551-.003-5.328.003-2.335-.222-4.885.579-6.847-1.426.205-1.589-.707-3.714 1.974-4.116z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#565454"
        d="M195.959 379.068l6.971-.08h3.145c2.326.031 4.65.063 6.975.096.237.654.061 1.166-.526 1.539-5.354 1.462-10.71 1.48-16.067-.002-.582-.383-.748-.901-.498-1.553z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#34342F"
        d="M180.056 374.867c1.155.789.883 1.963.83 3.077-1.756 3.542-5.09 2.063-7.834 2.471-1.482.005-2.965.007-4.45.009-1.455-.012-2.929.104-4.346-.232-1.625-.385-3.251-.905-2.303-3.201.375-2.402 2.272-1.944 3.832-1.972 4.756-.086 9.513-.106 14.271-.152z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#30302B"
        d="M144 374.906l13.005.017 1.977.077c.631.723.746 1.547.486 2.449-1.826 3.849-5.406 2.677-8.479 2.967-1.748 0-3.495.002-5.245.009-2.321-.218-4.855.574-6.801-1.427.446-1.473-.802-3.762 1.978-4.112l3.079.02z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#565454"
        d="M150.95 379.093c2.743-.444 5.972.958 8.025-2.11a6.241 6.241 0 002.185.04c.265-.009.53-.02.794-.032 1.463 3.774 4.777 1.213 7.092 2.071.248.654.077 1.171-.508 1.555-5.68 1.483-11.364 1.462-17.052.026-.592-.372-.77-.891-.536-1.55z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8C8C8C"
        d="M161.16 377.022c-.279.702-.278 1.806-1.388 1.539-.371-.09-.537-1.028-.797-1.579l.006-1.982c1.376-.026 2.045.71 2.179 2.022z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#31312C"
        d="M272.942 378.022l.108-2.949c5.996-.058 11.991-.116 17.986-.176l1.067 2.049c.289 4.657-3.397 2.87-5.611 3.471-1.723.004-3.449-.011-5.174-.012-2.725-.285-5.708.698-8.026-1.613-.118-.255-.234-.513-.35-.77z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#555353"
        d="M172.931 379.086c2.647-.413 5.503.626 7.956-1.142.732 1.219 1.942 1.042 3.086 1.056l7.06.051c.261.651.097 1.169-.489 1.555-5.683 1.504-11.371 1.473-17.064.035-.59-.374-.772-.894-.549-1.555z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#565454"
        d="M217.969 379.047l7.022-.048 1.08-.048c.767-.602.965-1.789 2.085-2.026 1.938 3.274 5.211 1.649 7.904 2.152.231.659.051 1.175-.539 1.55-5.69 1.455-11.381 1.486-17.072-.015-.585-.39-.744-.913-.48-1.565z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8D8D8D"
        d="M228.157 376.925c-.199 1.187-.621 2.144-2.085 2.027.092-1.625-.778-3.749 2.053-3.949l.032 1.922z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#565454"
        d="M138.943 378.998l7.1.077c.245.655.072 1.171-.516 1.55-5.679 1.465-11.362 1.46-17.047.014-.59-.376-.767-.895-.533-1.554l8.052-.085 2.944-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#42423F"
        d="M161.966 398.967c-.915-2.939-5.059-1.009-5.969-3.957l19.001-.006c1.977 2.778 5.216 2.013 7.848 2.375 1.739.24 3.3.811 4.957 1.588h-25.837z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4F4F4E"
        d="M235.002 394.019c-4.06 1.957-8.221-.05-12.351.218-2.915.188-5.857-.241-8.854.265-5.322.897-10.428.464-14.858-3.323-2.959-2.528-6.72-.63-10.063-1.222-.204-.605-.051-1.1.458-1.485 2.377-1.282 4.955-.892 7.485-.904a45.24 45.24 0 013.315-.005c2.912.019 5.905-.467 8.535 1.306.892 1.482 1.675 1.172 2.401-.191 2.738-1.662 5.743-1.123 8.682-1.128 1.111-.029 2.221-.064 3.329.016 2.708.173 5.462-.313 8.125.523 2.179.921 1.781 3.338 2.836 4.914.312.345.631.685.96 1.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#464644"
        d="M182.996 390.008c.877 2.63.811 4.445-2.847 4.021-5.331-.616-10.816 1.068-16.061-1.032-1.282-1.74-.704-2.989 1.036-3.937 5.989-.331 12.04-1.742 17.872.948z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#555353"
        d="M235.002 394.019c-.322 0-.644-.002-.966-.005-1.25-1.563-1.24-3.24-.459-4.99.823-.953 1.945-1.227 3.12-1.379 1.927-.195 3.862-.117 5.794-.068 1.347.018 2.67-.308 4.017-.317 2.874.461 6.04-.466 8.543 1.772-.055.328-.102.658-.143.988-5.326-.006-10.656.135-15.973-.074-3.127-.124-4.266 1.125-3.933 4.073zM182.996 390.008l-18.228-.128c-.11-.488.019-.911.351-1.278 2.35-1.35 5.021-.636 7.5-1.173.461-.05.922-.039 1.383.003.911.122 1.821.273 2.752.253.486-.028.966-.032 1.452-.045 2.261.104 4.612-.393 6.667 1.024.389.463.381.921-.021 1.371l-1.856-.027z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7A7979"
        d="M184.853 390.035l.142-1.038c1.318-1.135 2.617-1.151 3.893.07.023.297.021.593-.01.889-1.507.887-.209 3.16-1.947 3.933-.863-.79-.028-2.135-.905-3.103.547 1.265.926 2.239-.933 2.243l-.24-2.994z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#929292"
        d="M164.8 389.142c.032.248.022.495-.03.739-.979.874-.772 2.008-.682 3.116-3.086 1.895-1.84-.934-2.197-2.016a1.327 1.327 0 00-.034-.935c-.268-.51-.196-.966.217-1.368 1.021-.506 1.959-.524 2.726.464z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#999"
        d="M185.093 393.029l1.838-2.676v3.536c-.792.097-1.524.066-1.838-.86z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7B7A7A"
        d="M62.005 397.006c-.604-3.317-1.445.692-2.132-.068a18061 18061 0 01.063-1.896c.042-.325.094-.648.159-.97l3.821-.01a2.03 2.03 0 01-.017.85l-1.894 2.094z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#555353"
        d="M162.125 389.08c-.089.322-.177.645-.267.967-5.092-.018-10.183 0-15.273-.074-1.579-.023-3.331.517-4.617-.982 2.936-.279 6.024.789 8.791-.993.208-.034.417-.068.625-.105.733-.437 1.206-1.3 2.188-1.339a4.62 4.62 0 011.349.258c2.237 1.278 5.248.107 7.204 2.268z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#565454"
        d="M138.128 390.019l-19.262-.155c-.158-.474-.067-.892.271-1.257 2.275-1.346 4.878-.623 7.277-1.162.405-.068.82-.103 1.229-.13.789-.077 1.522-.357 2.249-.669.407-.097.761-.003 1.053.302 1.062 4.14 5.454.49 7.183 3.071z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A5959"
        d="M150.93 385.063l-19.009-.163c-.228-.541-.115-.997.335-1.371 2.428-1.4 5.112-.9 7.701-.946 2.207-.039 4.188-.614 6.044-1.741 1.752-.516 2.128 1.539 3.448 1.839.636.266 1.215.615 1.679 1.134.167.451.112.87-.198 1.248z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#777"
        d="M131.932 384.101c.025.268.022.534-.01.8l-.976 2.047a8.33 8.33 0 01-.796.166c-1.062-.656-.839 1.75-2.006.842l-.474.084c-.753-.96-.804-2.032-.513-3.163.189-.543.514-.99.966-1.346 1.39-.629 2.702-.711 3.809.57z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#757575"
        d="M150.93 385.063l.119-.996c.958-1.172 2.164-1.147 3.455-.719.48.237.78.619.904 1.141-.004 1.108-.487 1.927-1.486 2.428l-.803.177c-1.042-.611-.776 1.722-1.931.857l-.429.047.171-2.935z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#565454"
        d="M258.122 390.045l-.193-.999c1.987-2.046 4.57-1.32 6.956-1.513.521.018 1.046.039 1.569.04 1.036.026 2.053-.231 3.087-.257 2.779.39 5.711-.179 8.322 1.299.419.427.462.891.131 1.388l-19.872.042z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#838383"
        d="M277.994 390.003c.021-.312.054-.622.097-.933 1.085-1.218 2.34-1.165 3.678-.492.486.406.547.87.185 1.391-.901 1.061.132 1.999.191 2.999-.708 1.241-1.886 1.067-3.026 1.001-.197-1.373.147-2.899-1.125-3.966z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7B7A7A"
        d="M118.889 389.133c.02.244.013.488-.022.731l-1.001 1.989a12.32 12.32 0 01-.802.217c-1.08-.476-2.14 1.199-3.236.022-.409-.993-.1-1.88.38-2.75.294-.44.68-.769 1.153-1 1.326-.404 2.577-.469 3.528.791z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#555353"
        d="M281.953 389.969c-.04-.279-.075-.559-.105-.839 1.677-2.03 4.406-1.206 6.398-2.374a4.014 4.014 0 011.315-.232c1.064.293 2.157.103 3.244.139 2.55 1.195 5.536.57 8.047 1.931.25.248.373.523.371.825-.002.314-.033.472-.096.472-6.391.025-12.783.051-19.174.078z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7B7A7A"
        d="M301.127 389.89a3.276 3.276 0 01-.02-.779c.957-1.23 2.183-1.182 3.493-.734.478.256.785.647.925 1.171a1.86 1.86 0 01-.422 1.43l-.127 1.033c-.666.529-1.381-.554-2.044.063a11.87 11.87 0 01-.815-.21c-.329-.66-.66-1.317-.99-1.974z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D2D27"
        d="M72.985 390.084l18.907-.002c.447.963.621 1.932.067 2.918l-1.93.023-17.035-.035-.009-2.904z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#33332E"
        d="M114.871 390.099l-.619 1.979c.163.361.098.676-.196.942l-1.038-.009c-6.349.538-12.697.736-19.046.008-.324-.003-.647-.01-.971-.019-.363-2.299 1.077-3.311 2.891-4.062 4.953-.712 9.934-.26 14.903-.321 1.53-.019 2.976.278 4.076 1.482z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#393636"
        d="M93.971 393.019c6.349-.062 12.697-.737 19.046-.008l-2.113 1.06-2.87-.047c-4.674-.522-9.5 1.08-14.063-1.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#989898"
        d="M114.056 393.02c.085-.311.15-.625.196-.942.94.817 1.866-3.11 2.812-.007-.43 2.132-1.429 2.458-3.008.949z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#797878"
        d="M95.072 390.063l-2.071 2.938H91.96c-.638-.959-.688-1.932-.067-2.919l.184-.993c.826-.946 1.791-.943 2.833-.414.43.417.484.88.162 1.388z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#373733"
        d="M305.104 390.977a1.921 1.921 0 01.021-.892c6.625-2.229 13.264-2.064 19.912-.109 1.182.975 1.163 2.466 1.616 3.754-5.53.104-11.061.207-16.591.312-2.527.395-3.701-1.402-4.958-3.065z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#989898"
        d="M302.933 392.072c.583-3.222 1.368.161 2.044-.063.066.664.104 1.489-.64 1.638-1.124.226-1.226-.781-1.404-1.575z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#33332E"
        d="M336.68 387.976c-2.74 1.895-5.887.609-8.803 1.126-.901.016-1.803.03-2.705.045-3.63.047-7.595 1.91-10.514-1.932-.328-.884-.289-1.727.289-2.506 6.107-2.094 12.381-.549 18.576-.834 1.776.807 3.769 1.455 3.157 4.101z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#30302B"
        d="M350.005 392.992l-20.33.148-.755-1.048c.477-2.654 2.579-2.064 4.29-2.072 5.602-.023 11.203.028 16.805.051l-.01 2.921z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#555454"
        d="M315.36 386.953c2.687 3.343 6.527 1.52 9.812 2.193a8.04 8.04 0 00-.135.829l-19.913.109-.184-1.028c1.75-1.918 4.079-1.306 6.231-1.446 1.039.015 2.086.038 3.025-.542a2.364 2.364 0 011.164-.115z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#444441"
        d="M266.121 388.977l-8.192.069-2.878-.015c-2.977-.351-6.127.748-8.928-1.072-1.035-1.137-.986-2.271.008-3.403 6.229-1.818 12.525-1.049 18.822-.487 2.158 1.214 2.452 2.874 1.168 4.908z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8BCBB"
        d="M78.995 104.03c-2.135-.603-.166-3.103-1.816-3.929l-.292-2.097c.391-.946-.116-2.266 1.178-2.837.071 1.403-.503 2.985 1.101 3.963.902 1.668.968 3.305-.171 4.9z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD0D0"
        d="M99.013 83.953c.204 4.56-2.972.706-4.206 1.688l-.186-.252c.73-2.721 2.823-1.279 4.392-1.436z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD4D3"
        d="M97.027 90.006c1.425-3.975 3.771-1.755 5.918-.881.038.322 0 .635-.113.938l-.914 1.068c-1.911.716-3.527.168-4.961-1.158l.07.033z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CC5452"
        d="M78.995 104.03l.17-4.899c1.256.993 2.681 1.906 1.838 3.891-.67.335-1.339.672-2.008 1.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C64846"
        d="M96.957 89.974c1.79-.198 3.543-.24 4.961 1.158l.138 3.886c-1.813.254-3.537.135-4.968-1.198l-.131-3.846z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1F2021"
        d="M293.004 180.953l-10.009-.004c-3.023-1.694-7.126-2.107-7.815-6.578.096-1.231.737-2.151 1.676-2.897.726-.461 1.553-.768 2.196-1.369 2.991.016 5.981.031 8.971.048-1.448 1.537-3.57.287-5.372 1.348 2.776 3.95 7.983 5.196 10.353 9.452z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#282827"
        d="M279.053 170.104c-.101.785-.318 1.502-1.113 1.875-4.346.842-8.752.302-13.124.586-3.058.171-6.043-.085-8.823-1.521l.056-.09c7.603-2.021 15.338-.501 23.004-.85z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFE"
        d="M342.998 226.99c0 15.974.018 31.948-.027 47.922-.005 1.752.623 3.713-1.07 5.146-.801.823-1.74.806-2.735.459-2.364-1.78-2.462-5.14-4.829-6.922a6.672 6.672 0 01-1.1-1.771c-.233-2.968-1.654-4.822-4.787-5.076-.9-.489-1.652-1.09-1.703-2.223.074-.146.138-.301.227-.438 1.227-1.884 4.466-.94 5.121-3.401.9-3.382.414-6.88.314-10.329-.052-1.763-1.098-2.639-2.832-2.806-1.631-.158-3.311-.024-4.867-.713-2.9-2.436-.442-4.157.964-5.734 4.417-4.953 9.981-8.695 14.546-13.511.843-.577 1.698-1.123 2.778-.603z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DCD0C1"
        d="M349.049 220.146c-1.065 1.598-2.357 2.964-4.035 3.936-.96-.793-1.48-1.885-1.398-3.055.472-6.666-1.615-13.496 1.25-20.01 3.81-1.175 4.967 1.288 5.788 4.218-.72 4.947 1.008 10.163-1.605 14.911z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFC99F"
        d="M339.107 279.97l2.793.087c1.895 1.94 4.592 3.639 2.074 6.904-1.929.383-2.803 2.198-4.299 3.165-2.199 1.42-4.396.959-6.551-.099-1.843-.904-2.061-2.385-1.342-4.146 1.455-2.599 3.404-4.729 5.99-6.252.499-.102.947.003 1.335.341z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E0D7C9"
        d="M346.026 200.982c-2.129 4.409-.642 9.092-.98 13.637-.233 3.137-.036 6.307-.032 9.462l-.982.948c-3.645-.602-3.287-3.572-3.374-6.05-.224-6.362-.011-12.73.085-19.095a2.784 2.784 0 01-.084-1.626 2.146 2.146 0 011.271-.967c2.486-.017 4.275.745 4.096 3.691z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4BD92"
        d="M332.97 285.967c-.417 1.193-1.401 2.441.753 3.106 2.068.638 3.953 1.517 6.029-.252 1.13-.962 1.793-3.647 4.223-1.86l-2.984 3.871c-2.222 1.752-4.442 3.506-6.662 5.259-.654.285-1.322.498-2.051.402-2.017-1.306-3.336-3.224-4.578-5.214-.273-.992.094-1.852.557-2.692.752-1.185 1.441-2.43 2.789-3.078.721-.191 1.382-.114 1.924.458z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4DACF"
        d="M340.912 198.973c2.2.301 1.869 1.575 1.568 3.271-1.08 6.095-.279 12.267-.447 18.404-.047 1.726.62 3.244 1.998 4.38-.344.654-.688 1.309-1.033 1.962l-1.843 1.037c-2.003-.434-2.739-1.81-2.772-3.714.221-7.556.205-15.114.01-22.674.111-1.575.615-2.785 2.519-2.666z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D8C9B7"
        d="M349.049 220.146c.485-5.042-1.256-10.224.962-15.155 2.235-.225 3.265.74 2.97 3.012-1.941 2.875-.578 6.096-.954 9.136l-2.978 3.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#484849"
        d="M255.992 171.045l9.013-.011c3.18 1.431 7.55 1.15 8.445 5.874-.493 1.757-1.063 3.436-3.441 3.106-3.858-4.262-10.172-4.686-14.017-8.969z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262728"
        d="M270.01 180.015l2.948-3.078c.681-1.324.516-3.533 3.051-2.916.546 4.107 5.474 3.797 6.986 6.93-4.322-.39-8.784 1.149-12.985-.936z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBEBEB"
        d="M289.025 339.082l3.982-3.398.691-.036c2.252.391 4.533.479 6.925.684-2.16-.648-4.753.514-6.234-1.93-.258-.686-.297-1.388-.165-2.104.646-2.776 3.379-4.481 3.784-7.386.67-1.855 2.035-3.2 3.354-4.581 1.232-1.168 2.377-2.45 3.984-3.146 7.353-.501 13.488-3.633 18.743-8.681 1.015-.069 2.046-.222 2.899.55 2.172 1.349 4.713 1.463 7.091 2.126-.024 8.289-.067 16.578-.064 24.867.001 2.133-.041 3.987-3.009 3.973-13.429-.064-26.857-.033-40.286-.091-.565-.002-1.129-.552-1.695-.847z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#619CCF"
        d="M326.99 309.055l-2.89-.159c-.237.023-.474.048-.712.074-5.704-.673-9.938-4.129-14.119-7.6-1.106-.919-2.098-2.231-1.037-3.902 2.438-2.112 4.193-5.077 7.528-6.084 1.661-.049 2.872 1.072 4.291 1.647 1.486.876 2.789-.238 4.183-.397 2.072.568 2.569 2.367 3.193 4.072.063.477-.061.901-.362 1.275-7.422 5.77-7.422 5.77-.075 11.074z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AE9D79"
        d="M327.065 297.981a10.917 10.917 0 01-.203-.943c.272-.39.631-.674 1.06-.874 1.361-.493 2.736-.43 4.116-.088l2.287.015c-1.88 2.701-4.209 3.68-7.26 1.89z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3F3F3"
        d="M352.98 208.003c-.647-1.342-1.676-2.307-2.97-3.012-.975-1.688-2.331-2.996-3.984-4.009-.911-1.586-2.063-2.857-4.017-3.09-.736-1.316-.26-2.878-.867-4.225a10.886 10.886 0 01-.354-1.988c-.092-.95-.11-1.9-.131-2.855a26.017 26.017 0 01-.026-1.504c-.014-1.581.213-3.089 1.323-4.323l13.877.137c.084 7.941.109 15.884.275 23.823.087 4.087-1.752 1.706-3.126 1.046z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFE0E0"
        d="M327.004 115.967c-.865.143-1.415-.315-1.858-.977-.423-3.412.472-6.441 2.651-9.095 1.068-.346 1.362.146 1.211 1.12.518 1.443 2.068.54 2.898 1.275.134.784-.34 1.244-.883 1.673-2.006 1.053-2.704 2.938-3.164 4.972a2.565 2.565 0 01-.855 1.032z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD9D9"
        d="M329.008 107.016l-1.211-1.12c1.67-2.083 3.449-3.817 6.338-1.963-.104.635-.691.718-1.121.979-1.727-.043-2.82 1.12-4.006 2.104z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDDBDB"
        d="M333.014 104.912l1.121-.979c.297-.021.594-.033.891-.035.827 1.316 2.193 2.507 1.123 4.433-2.077-.353-1.375-3.02-3.135-3.419z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F5F5"
        d="M306 110.985l-8.099-3.979c-.154-2.286-3.878-3.593-1.809-6.475 2.09-2.911 5.021-4.049 8.524-3.863 1.141.061 2.279.193 3.418.294 4.281 2.921 5.847 6.992 5.096 12.043-1.736 2.965-4.685 1.569-7.13 1.98z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEE0DF"
        d="M336.869 121.038c.089-3.072 2.645-5.205 3.102-8.138.411-.553 1.428-1.4.067-1.65-4.225-.777-1.022-1.463-.039-2.2 1.187-.168 2.911-.909 3.457-.396 1.515 1.423-.86 2.724-.724 4.258-2.535 2.289-1.738 6.983-5.863 8.126z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F0F0"
        d="M313.004 88.982L315.043 92c-.356 4.475-2.917 5.865-7.058 5.044-1.765-1.891-2.989-3.983-1.432-6.511 1.572-2.55 3.984-2.342 6.451-1.551z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDDADA"
        d="M330.604 109.233l1.303-.942c2.809 1.082 2.41 3.459 2.307 5.717l-2.026 2.104c-.844.498-1.299.019-1.676-.662-.254-2.075-.104-4.146.092-6.217z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7C8C8"
        d="M330.993 114.98l1.194 1.132-1.182 1.092c-1.393-.221-3.041.384-4.002-1.237l.063-1.091c1.335-.964 2.649-1.098 3.927.104z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#403D3E"
        d="M66.066 387.108c-2.066 2.849-4.097 2.981-6.086-.08 2.028.028 4.057.054 6.086.08z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#757474"
        d="M82.052 384.075l3.893.025c.254.218.362.456.322.714-.041.269-.098.402-.169.402a1.69 1.69 0 01-1.219.323c-1.242-.227-1.291 1.815-2.638 1.39l-.496.062.196-1.928.111-.988z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3D3B3B"
        d="M49.982 387.966c-.721 1.241-1.917.982-3.038.965.339-2.446 1.743-1.535 3.038-.965z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#302F2A"
        d="M85.11 385.018c.287.008.57-.019.851-.08 6.194-.672 12.412-.535 18.627-.571.917.584 1.085 1.458.949 2.449-2.759 4.362-6.846 2.469-10.581 2.237l-2.881.034c-2.4-1.085-6.78 2.282-7.22-3.211-.333-.41-.229-.69.255-.858z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8E8E8E"
        d="M85.11 385.018c-.061.293-.145.58-.254.859-1.24.521-.436 2.819-2.218 2.701-.663-.044-.555-1.009-.398-1.647.852-.796 1.343-2.131 2.87-1.913z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#838282"
        d="M348.965 380.032c.057-.284.107-.57.155-.855l2.778-.035.967 1.925 1.07 1.987c-.715 1.138-1.867.915-2.938.946-.98-1.167-2.758-1.926-2.032-3.968z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4C4B4B"
        d="M361.08 378.948l-6.193-.004c1.213-2.191 3.329-2.19 6.193.004zM368.078 378.955l-6.185-.019c1.82-1.791 4.443-1.784 6.185.019z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#626162"
        d="M370.893 392.052c-1.322 1.626-3.137.722-4.734.921 1.304-1.715 3.137-.713 4.734-.921z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C2C26"
        d="M338.073 385.082l16.962.001 2.09 1.973c.361.401.928.55 1.24 1.013.082.388-.053.675-.401.862-6.585-.247-13.242 1.004-19.745-.951-1.131-.912-1.014-1.886-.146-2.898z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#393737"
        d="M357.964 388.931c.011-.292.014-.584.007-.877 3.193-1.411 6.691.259 9.902-.975.873.312 1.094 1.035 1.172 1.849l-11.081.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#747474"
        d="M338.073 385.082c.048.966.096 1.932.146 2.897l-1.537-.004c-.872-1.028-1.742-2.058-2.611-3.086-.348-.527-.267-.978.243-1.353 1.337-.623 2.585-.682 3.628.569.035.328.079.653.131.977z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#515050"
        d="M367.873 387.079c-3.146 1.9-6.624.418-9.902.975l-.848-.998 10.75.023z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E2E28"
        d="M337.941 384.106l-3.879.005c-1.256.782-2.253.076-3.266-.563-.686-.712-1.07-1.566-1.191-2.543.104-.768.391-1.33 1.323-1.151 3.351.217 6.753-.076 10.019 1 1.105.729 1.541 1.686 1.016 2.972l-4.022.28z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2B25"
        d="M341.963 383.826l-1.015-2.97c2.523-1.724 5.351-.499 8.017-.824.793 1.264 2.141 2.243 2.033 3.968l-9.035-.174z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBEBEB"
        d="M131.16 340.011c-14.147 0-28.296-.118-42.44.078-3.76.053-4.821-1.14-4.794-4.841.153-21.469.148-42.94.004-64.41-.024-3.614.877-4.928 4.722-4.907 28.293.147 56.588.133 84.882.013 3.52-.016 4.555 1.112 4.535 4.577-.13 21.636-.157 43.273.018 64.909.032 3.941-1.459 4.689-4.984 4.648-13.981-.164-27.963-.067-41.943-.067z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D9D9D9"
        d="M84.042 226.963l-.087-31.793c1.448-1.869 3.564-1.548 5.515-1.602 6.486-.179 12.974-.016 19.461-.012 65.043.035 130.086-.087 195.129-.062 9.303.003 18.606-.157 27.894.153 4.203 2.643 4.739 6.273 1.473 10.185-2.613 3.13-6.357 5.347-7.678 9.524-2.616 1.047-4.66 3.21-7.484 3.865-4.723.428-9.461.013-14.169.282-2.273.913-2.131 2.199-.547 3.701 2.548 1.242 6.305-.95 7.947 2.82-.84 2.728-1.854 5.189-5.514 3.651-1.819-.374-3.656-.179-5.481-.179-54.102-.013-108.203-.01-162.305-.011-7.582 0-7.591-.002-7.632-7.85-.026-4.993-.013-9.987-.003-14.981.003-1.849.026-3.684-1.397-5.119-1.095-.888-2.362-1.1-3.728-1.1-10.76-.001-21.52-.006-32.28.003-1.192.001-2.296.229-3.271.92-1.732 1.524-1.433 3.574-1.446 5.531-.04 6.094.135 12.191-.095 18.28-.097 2.57-.473 5.26-4.302 3.794z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBEBEB"
        d="M229.036 341.086c-1.441-1.685-3.403-1.039-5.154-1.048-10.988-.054-21.98-.208-32.961.066-4.097.103-5.021-1.341-4.993-5.162.157-21.142.198-42.287-.025-63.428-.046-4.393 1.144-5.629 5.577-5.605 33.462.176 66.925.083 100.388.074.992.671 1.141 1.668 1.077 2.75-.109.651-.219 1.37-.683 1.824-4.859 4.757-8.365 10.477-11.71 16.316-3.031 2.137-6.388.386-9.186.897 2.621.792 5.912-.676 8.824 1.007.429.624.52 1.306.355 2.032-1.116 2.224-3.02 2.097-5.113 1.909-1.748-.156-3.54-.434-5.243-.093 3.3.621 6.848-.529 10.087 1.199.626.88.691 1.843.443 2.856-.566 1.501-1.699 2.432-3.105 3.083-1.274.511-2.69.621-3.89 1.355-2.386 1.273-3.931 3.59-6.192 5.02-2.723 1.794-4.478 4.814-7.644 6.049-3.516 1.192-7.163.632-10.752.808-.612-.006-1.228.018-1.844-.021.733.057 1.468.014 2.208.027 2.163.29 4.5-.711 6.474.899-.089 4.891-4.909 6.255-7.116 9.568-3.17 2.989-6.214 6.11-9.263 9.228-3.688 2.587-5.464 7.581-10.559 8.39zM291.852 264.017l-201.383-.029c-6.463-.001-6.463-.007-6.47-6.515C83.988 246 83.988 246.001 95.502 246l199.384-.018c.904 6.334-.78 12.232-3.034 18.035z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9C9C9B"
        d="M131.103 228.028c-1.162 1.773 1.986 5.191-2.214 5.807-2.892-2.015-6.169-3.237-9.353-4.681-5.492-2.49-6.585-5.115-4.852-10.744 1.108-3.6 2.063-7.28-1.463-10.072-1.915-1.517-4.514-2.077-6.531-.444-3.412 2.761-3.373 6.524-2.257 10.484 1.745 6.192.047 9.354-6.209 11.371-2.759.89-5.316 1.922-7.203 4.21-5.153.139-2.01-3.979-3.051-5.949-.797-10.032-.664-20.067-.067-30.104 14.366-.701 28.734-.546 43.103-.089.849 10.068.667 20.139.097 30.211z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#27759B"
        d="M334.034 195.165c-1.161-.055-2.323-.158-3.485-.158-81.037-.007-162.073-.007-243.111.001-1.161 0-2.323.105-3.484.162l-5.773-.614-.082-2.543c.521-.554 1.179-.735 1.915-.712 1.376.15 2.744.413 4.141.377a81.825 81.825 0 003.536-.078c1.02-.049 1.953-.463 2.94-.683a11.21 11.21 0 011.631-.297c3.816-.127 7.626-.296 11.423.293 9.923 1.258 19.883.631 29.818.531 20.905-.209 41.808-.286 62.71.05 3.337.054 6.625-.017 9.885-.742 19.296-.552 38.597-.134 57.895-.237a2849.39 2849.39 0 0130.942.01c1.718.096 3.441-.136 5.16-.039 4.685 1.19 9.279-1.505 13.968-.386 2.03.604 4.105.263 6.164.259 2.693.22 5.41.861 8.012-.474 1.135-.818 2.197-1.875 3.797-1.18 1.094 1.816 2.877 1.914 4.73 1.962 1.792.046 3.693-.191 5.104 1.35l.18 2.002c-1.535 2.855-4.086 2.35-6.594 2.001a6.33 6.33 0 01-1.422-.855z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6F6E6E"
        d="M91.021 233.959c-.425-3.712 2.294-4.262 4.93-4.943 8.282-2.143 8.761-3.453 6.459-11.628-.977-3.469-.169-7.39 2.299-10.278 2.081-2.435 5.134-1.848 7.87-1.028 4.187 1.254 6.091 7.298 3.962 12.241-2.5 5.807-1.78 7.473 4.196 10.056 3.042 1.314 7.11 1.14 8.151 5.457l-37.867.123z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EE676E"
        d="M291.852 264.017c-.071-6.193 1.371-12.133 3.034-18.034 2.634-6.68 7.364-12.048 11.245-17.947.173-.425.44-.496.803-.216 1.874-.765 2.95-2.374 4.117-3.887.391-1.236 1.107-2.26 2.042-3.14.407-.445.835-.874 1.242-1.319.64-.743 1.206-1.56 2.029-2.13.831-.477 1.854-.575 2.563-1.297 2.095-1.653 3.948-3.838 7.076-3.222.098.216.195.431.295.646-1.234 4.091-4.846 6.233-7.593 9.026-6.907 7.025-13.818 14-17.611 23.354-1.194 3.156-2.517 6.271-2.846 9.682-.791 2.963-.732 6.03-1.122 9.044-.879 2.277-1.771 4.549-4.903 4.185l-.355-2.779-.016-1.966z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBEBEB"
        d="M306.934 227.819c-.25.138-.518.209-.803.216l-175.028-.007-.183-29.872c-.517-.426-.486-.808.092-1.145 2.107 4.779.492 9.808.977 14.698.486 4.907-2.137 11.212 1.184 14.384 3.06 2.922 9.231.855 14.022.86 51.321.062 102.643.03 153.965.069 1.929.003 4.02-.667 5.774.797zM152.25 233.994c-3.639 0-7.278.022-10.916-.012-1.475-.014-3.219.132-3.146-2.108.062-1.871 1.563-1.857 2.9-1.86 7.608-.015 15.216-.015 22.824 0 1.338.003 2.839-.007 2.898 1.863.071 2.237-1.674 2.093-3.149 2.105-3.803.034-7.607.012-11.411.012zM185.995 230.004c3.648.003 7.296-.011 10.944.01 1.348.008 2.804.017 2.882 1.896.078 1.886-1.313 2.068-2.704 2.07-7.628.014-15.256.013-22.883-.016-1.413-.006-2.832-.439-2.914-2.065-.12-2.385 1.879-1.847 3.233-1.873 3.813-.075 7.628-.026 11.442-.022zM218.99 233.994c-3.65.003-7.3.026-10.95-.009-1.472-.014-3.37.133-3.524-1.834-.162-2.065 1.709-2.125 3.208-2.131 7.466-.029 14.932-.021 22.397-.004 1.391.004 2.784.187 2.704 2.072-.08 1.882-1.538 1.888-2.886 1.896-3.648.021-7.298.007-10.949.01zM284.897 233.99c-3.65-.001-7.3.014-10.95-.008-1.374-.009-2.792-.115-2.777-2.001.015-1.885 1.446-1.964 2.812-1.967 7.466-.015 14.933-.014 22.398.001 1.358.003 2.975.119 3.11 1.76.171 2.084-1.63 2.185-3.145 2.201-3.816.042-7.632.014-11.448.014zM251.508 230.009c3.816-.002 7.632-.016 11.447.006 1.35.007 2.804.021 2.875 1.904.071 1.888-1.326 2.059-2.713 2.062-7.466.019-14.931.025-22.397-.003-1.501-.006-3.31-.061-3.208-2.144.082-1.683 1.696-1.803 3.048-1.813 3.648-.03 7.299-.01 10.948-.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#665042"
        d="M229.036 341.086l9.945-9.098c2.784.334 1.561 2.211.794 3.025-2.923 3.103-1.167 4.419 1.741 5.622 1.068.441 2.814.374 2.485 2.363-5.755-.129-11.398 1.816-17.194.927l2.229-2.839z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9E9E9"
        d="M88.113 198.226l-.143 29.784c-1.356-.176-2.925.447-3.929-1.047 3.049.269 2.978-1.788 2.969-3.895-.028-7.13-.038-14.26.011-21.39.011-1.596-.52-3.362.972-4.673.571.355.611.763.12 1.221z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D8BBB"
        d="M91.003 191.994l-.388.016-.388-.001c-2.232-1.328-1.01-3.995-2.229-5.708-4.001-2.639-6.056-.11-7.907 2.97-.72.316-1.395.308-1.993-.265l-.048-6.016 263.904.007-.082 5.004c-2.303 1.954-4.771 1.417-7.266.506-1.34-.669-2.656-1.53-4.23-.588-1.158.606-2.219 1.411-3.523 1.716-1.188.22-2.234-.191-3.256-.719-1.592-.717-3.164-1.579-4.952-.561-1.119.718-2.175 1.571-3.579 1.668-2.24.305-4.251-1.12-6.49-.847a30.09 30.09 0 01-2.779.155c-1.198.007-2.392-.018-3.558-.324-2.78-1.968-4.748.651-7.084 1.271-27.092.487-54.173.097-81.252.204-2.659.01-5.296.079-7.9.648-2.017-5.261-6.033-5.65-11.127-5.605-28.404.249-56.812.272-85.216-.066-3.542-.043-5.297 1.099-5.654 4.513-.784 1.653-2.022.792-3.279.765-3.278-.071-6.794-1.465-9.724 1.257z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B83B0"
        d="M78.1 189.006l1.753.003c.991.964.966 1.966.111 2.998l-1.864.006v-3.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E5647"
        d="M244.001 342.999c-.795-1.133-2.167-.658-3.136-1.118-1.756-.832-3.923-1.684-4.843-3.187-1.333-2.176 1.869-2.409 2.667-3.832.557-.993 1.741-1.741.292-2.874a60.94 60.94 0 019.045-8.922c.984-.067 1.828.185 2.397 1.061.484 1.201.12 2.309-.369 3.405a7.48 7.48 0 01-.718 1.217c-1.33 1.707-2.996 3.102-4.412 4.733-1.866 2.15-1.327 3.746 1.273 4.354 7.214 1.69 14.533 2.778 21.965 2.405 4.783-.239 5.829-4.288 7.29-7.801.182-.15.366-.298.551-.445 2.847 1.427 1.91 3.456.785 5.413-1.52 2.641-2.673 6.034-6.514 5.736-4.498-.35-8.887-.046-13.271.853-2.888-1.352-6.11.312-9.003-.998h-3.999z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E4C42"
        d="M259.988 311.007c2.483-1.809 3.954-4.798 6.973-5.981 3.514 5.496 5.668 11.652 8.49 17.488-.01 1.102-.622 1.854-1.445 2.481l-1.008.007c-.396.317-.834.416-1.325.265-1.379-.689-2.175-1.847-2.632-3.275-.385-1.242-.418-2.56-.919-3.794-1.49-3.674-2.972-7.289-8.118-5.958-.329-.408-.318-.819-.016-1.233z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B4737"
        d="M262.993 347.006c.822-.03 1.564-.22 2.007-1.006 6.061 1.029 10.624-1.133 14.559-5.87 2.423-2.917 3.353-5.077.313-7.906-.525-.489-.595-1.468-.875-2.221 4.886 1.212 6.942 4.293 6.003 8.994-1.007.561-2.55.875-2.938 1.72-3.867 8.422-11.821 5.73-18.338 6.898-.201.035-.485-.396-.731-.609z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#54443B"
        d="M284.999 338.997c-.349-4.101-2.878-6.746-6.003-8.994-2.272-1.063-2.496-4.166-4.99-5.008.021-.832.22-1.574 1.024-2.007 5.23 1.896 9.065 5.545 12.375 9.854-.874 2.023 1.368 5.265-2.406 6.155z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6E5647"
        d="M272.001 324.998l.997.004c.737 2.445 3.371 4.075 3.006 6.994l-.006.006c-3.096.335-3.455-2.368-4.636-4.167-.267-1.053-.235-2.041.639-2.837z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#665042"
        d="M248 343c2.991.427 6.184-.975 9.003.998-2.991-.424-6.185.981-9.003-.998z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CECED2"
        d="M287.406 332.842c-4.451-2.875-8.735-5.96-12.375-9.854-3.753-5.51-6.623-11.417-8.069-17.963l6.055-4.988c.768.675 1.127 1.562 1.32 2.532 1.751 7.887 4.833 14.966 11.908 19.619 3.769 3.132 7.846 4.843 12.751 2.79.272 3.268-2.385 4.861-4.022 7.037-1.042 2.127-2.576 3.111-4.956 2.135-1.063-.052-1.944-.467-2.612-1.308z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B4737"
        d="M247.999 348.002c4.229-1.698 8.63-1.154 13.002-.999-4.081 3.631-8.554 2.156-13.002.999z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#54443B"
        d="M290.018 334.15c2.145.432 3.326-1.371 4.956-2.135l-.038 1.884c-.623.76.06 2.687-1.963 2.194l.035-.41c-.997-.51-1.993-1.022-2.99-1.533z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#565454"
        d="M285.936 379.107c2.019-.825 5.142 1.504 6.167-2.16.265.045.53.083.796.115.631.29 1.257.461 1.855-.074l.382.024c1.592 2.637 4.198 1.938 6.567 1.98 2.765.05 5.53.061 8.296.089.229.24.332.498.309.775-.024.287-.067.431-.126.434-.687.933-1.409 1.82-2.65 2.037-1.412-.248-2.7-1.117-4.227-.805-5.629-.338-11.339.947-16.88-.914-.553-.373-.715-.875-.489-1.501z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#555454"
        d="M309.999 379.937v-.855l5.111-.086 2.893.005 7.982-.136.253.87a2.765 2.765 0 01-1.314 1.2c-5.034.575-10.124 1.934-14.925-.998z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#403E3E"
        d="M305.994 377.129c-.75.214-1.229.516-1.5.385-.327-.158-.479-.682-.705-1.047.289-.115.631-.387.854-.311.386.133.699.482 1.351.973z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E3B3B"
        d="M327.002 375.901c1.219.63 1.975 1.575 2.043 2.991-.93.988-1.945.971-3.02.26l-.04-.287c.035-1.093-.094-2.241 1.017-2.964z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6C6C6C"
        d="M326.025 379.152l3.019-.259 1.888.256c.025.236.024.472-.003.706l-.892 1.133c-.73.415-1.561.234-2.338.393-.865-.143-1.498-.545-1.639-1.486a6.843 6.843 0 01-.035-.743z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A5959"
        d="M104.977 385.018l-19.016-.08a3.67 3.67 0 00-.015-.838c4.946-.695 10.089 1.063 14.911-1.195 1.006-.143 1.983-.581 3.036-.306.624.231 1.077.653 1.378 1.242.083.437-.007.832-.294 1.177z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#848383"
        d="M103.834 382.899c-.991.709-1.981 1.703-2.978.005l.894-2.862c.979-.029 1.874.124 2.384 1.106.421.673.362 1.264-.3 1.751z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#545252"
        d="M92.752 382.234c-.747.345-1.159.711-1.445.631-.567-.16-1.354-.45-1.533-.895-.437-1.082.613-.89 1.087-.79.55.115 1.033.553 1.891 1.054z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#34342F"
        d="M103.834 382.899l.299-1.752 1.794-1.281 18.017.191c.728.647.884 1.475.757 2.394a3.36 3.36 0 01-.854 1.518c-4.929 2.776-10.28.91-15.421 1.402-1.204-.043-2.342-.272-3.245-1.158l-1.347-1.314z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#706F6F"
        d="M124.15 382.03l-.205-1.974c.03-.324.065-.648.104-.972h3.898c.022.277.019.553-.008.829a2.892 2.892 0 01-.825 1.003c-.931.519-1.718 1.434-2.964 1.114z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#595858"
        d="M128.008 376.806c-.515.474-.788.926-1.123.978-.35.054-.759-.278-1.143-.441.277-.339.495-.834.85-.969.292-.111.746.207 1.416.432z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8B8B8B"
        d="M294.754 376.988c-.162.547-.237 1.511-.502 1.566-1.074.226-1.116-.778-1.353-1.493l.46-1.381 1.395 1.308z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8D8D8D"
        d="M270.021 378.998l-.007-3.999c2.165-.144 1.709 2.251 2.928 3.022l.107-.041c-.371 2.239-1.634 1.824-3.028 1.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#717070"
        d="M236.077 379.925a5.349 5.349 0 01-.017-.849l3.907-.032.098 1.007c1.011 1.262 1.136 2.587.293 3.984-.954.854-2.019.925-3.162.444-1.57-1.222-1.49-2.852-1.119-4.554z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#555353"
        d="M270.021 378.998c1.116-.023 2.304.172 3.028-1.018 2.492 1.644 5.331.751 8 1.096.24.657.063 1.172-.527 1.548-5.687 1.463-11.375 1.478-17.066-.001-.585-.387-.75-.91-.496-1.564l7.061-.061z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6C6C6C"
        d="M262.96 379.059c.027.31.038.62.029.931a2.378 2.378 0 01-.881.806c-.748.341-1.522.585-2.352.63-.881-.151-1.53-.563-1.685-1.52a6.669 6.669 0 01-.013-.812l4.902-.035z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#595858"
        d="M262.818 376.816c-1.627.697-2.03 1.02-2.419 1.004-.719-.029-1.17-.539-.806-1.23.14-.266.814-.348 1.241-.337.441.01.877.233 1.984.563z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E3E3B"
        d="M258.072 379.905l1.7 1.264c1.119.997 1.078 2.04.125 3.119-4.416.46-8.848.061-13.27.217-1.413.354-2.773 1.03-4.299.711-.901-.137-1.701-.466-2.272-1.219l.008-3.946 18.008-.146z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#696868"
        d="M217.969 379.047c.017.302.014.604-.009.905a3.598 3.598 0 01-.72 1.078c-1.069.846-1.119 2.408-2.248 3.218a1.64 1.64 0 01-1.315-.248c-.996-1.238-.936-2.638-.624-4.075a7.63 7.63 0 01-.004-.842c1.641-.012 3.281-.023 4.92-.036zM191.041 379.948a7.258 7.258 0 01-.008-.897l4.927.018c.01.287.006.573-.012.86.295 1.39.332 2.745-.537 3.973a1.57 1.57 0 01-1.181.415c-1.412-.688-1.314-2.528-2.552-3.355-.29-.29-.499-.63-.637-1.014z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5D5C5C"
        d="M194.63 377.275c-.559.266-.94.61-1.244.551-.364-.071-.661-.485-.987-.751.314-.267.651-.767.938-.739.376.035.711.488 1.293.939z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F3F3C"
        d="M195.006 384c.102-1.406-.466-2.968.943-4.071l17.105-.003c1.415 1.104.819 2.67.931 4.073-3.846 2.694-8.212.882-12.305 1.427-1.471-.058-2.954.155-4.418-.163-.891-.171-1.691-.509-2.256-1.263z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#737373"
        d="M172.931 379.086c.018.275.011.551-.021.826.315 1.402.382 2.772-.523 4.011a1.576 1.576 0 01-1.203.372c-.735-.117-.481-2.024-1.865-1.026a1.371 1.371 0 01-.898-.755c-.294-.916-.144-1.731.497-2.445l.129-1.007 3.884.024z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6A6969"
        d="M146.043 379.93a6.578 6.578 0 01-.001-.854l4.909.017c.011.271.008.541-.011.811-.166.955-.811 1.367-1.701 1.506-.854-.021-1.529-.515-2.258-.865a1.106 1.106 0 01-.938-.615z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#515050"
        d="M149.493 375.61c.622.903 1.087 1.318 1.008 1.523-.126.328-.584.644-.957.732-.479.113-.937-.153-.789-.755.104-.422.385-.8.738-1.5z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A3A36"
        d="M149.118 381.096l1.823-1.192c5.992.054 11.984.108 17.976.164l-.074 2.955c-4.349 4.117-9.131 2.65-13.922 1.081l-3.871-.037-2.192-.083c-.639-1.029-.739-2.007.26-2.888z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6D6C6C"
        d="M281.061 379.921a5.43 5.43 0 01-.012-.846l4.887.031c.018.266.018.53.001.795-.042.688-.411 1.139-1.022 1.413-1.085-.668-1.705-.38-1.842.902-.406.155-.81.145-1.214-.008-.71-.607-.91-1.393-.798-2.287z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#555353"
        d="M283.887 377.092c-.607.337-.962.688-1.337.709-.685.041-1.285-.328-1.047-1.102.081-.264.794-.483 1.196-.451.343.027.656.444 1.188.844z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F3F3C"
        d="M171.965 383.999c.162-1.397-.397-2.962.945-4.087l18.13.037 1.063.057c.761 1.099.883 2.234.198 3.417-4.152 3.619-9.163 1.331-13.747 1.997-1.454-.02-2.911.017-4.36-.178-.885-.157-1.672-.496-2.229-1.243z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41413E"
        d="M216.918 380.005c.348-.017.695-.034 1.043-.053l18.115-.027c1.354 1.119.774 2.683.936 4.075-4.174 2.771-8.85.849-13.257 1.427-1.475.042-2.951.074-4.4-.291-1.167-.304-2.131-.904-2.8-1.931-.544-1.14-.377-2.202.363-3.2z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#363531"
        d="M146.043 379.93c.315.041.632.064.95.071.255.227.332.443.231.649-.099.201-.194.302-.286.302-1.067 2.203-2.538 3.37-5.271 3.122-3.218-.291-6.488-.009-9.735.026l-3.877.012c-2.032.063-1.908-1.362-1.879-2.722.17-.508.422-.973.753-1.395l1.01-.081 18.104.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#494847"
        d="M209.006 390.003c-2.86-1.675-6.008-.777-9.029-1.009-1.131-1.882-1.511-3.566 1.166-4.45 5.895.141 11.79-.333 17.687-.021 2.703.884 2.324 2.579 1.18 4.476-3.004.457-6.25-1.066-9.043 1.108-.682.493-1.337.487-1.961-.104z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#464644"
        d="M188.888 389.067l-3.893-.07-8.088-.016c-1.117-1.928-1.428-3.622 1.284-4.441 6.235.311 12.485-.737 18.717.179 1.379 1.411 1.127 2.844.06 4.287l-8.08.061z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B4A49"
        d="M237 388.995l-3.107.06c-.584.539-1.17.542-1.758.006l-9.129-.06c-.645-.76-.583-1.528-.034-2.307 3.54-1.698 7.28-.575 10.917-.644 1.492-.028 3.241.736 3.111 2.945z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#767575"
        d="M196.968 389.006l-.074-3.939c-.304-.271-.388-.518-.251-.739.129-.209.252-.313.371-.313l3.904.078c.396.189.525.375.39.556-.132.178-.267.268-.404.268-1.354 1.123-.771 2.685-.926 4.079-1.004.002-2.007.006-3.01.01zM223.079 386.992l-.074 2.009-2.996-.003c-.149-1.396.437-2.956-.909-4.086-.406-.169-.544-.344-.416-.527.13-.185.261-.278.396-.278l3.905-.092c.336.313.575.687.718 1.122.086.717-.156 1.324-.624 1.855z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9C9C9C"
        d="M232.134 389.061l1.759-.007.143 4.96c-3.041-.727-1.544-3.196-1.902-4.953z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#979797"
        d="M209.006 390.003c.653.034 1.307.068 1.959.104-.22 1.177.575 3.32-.83 3.32-2.1-.001-.908-2.177-1.129-3.424z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#474746"
        d="M223.079 386.992l.021-1.933c6.193-1.239 12.449-.235 18.67-.521 2.761.795 2.42 2.507 1.313 4.444l-6.083.012c-4.184-3.843-9.393-.554-13.921-2.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#767575"
        d="M243.083 388.983c-.219-1.383.36-2.961-.993-4.067-.397-.176-.531-.357-.405-.545.127-.188.256-.284.389-.284l3.903-.061c.366.193.504.411.416.653-.093.254-.195.381-.305.381.012.967.023 1.933.036 2.898-.727 1.193-1.929.975-3.041 1.025z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#434340"
        d="M153.922 386.916l.98-2.022c6.299-.47 12.6-.867 18.913-.217 1.079 1.126 1.099 2.234-.054 3.323-2.8 1.849-5.998.568-8.961 1.141l-2.677-.062c-2.663-.986-6.367 1.973-8.201-2.163z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#767575"
        d="M173.762 388l.117-2.918c-.298-.279-.376-.529-.235-.75.132-.206.257-.31.377-.31l3.896.074c.396.186.526.367.392.547-.132.177-.265.267-.401.267-1.36 1.105-.779 2.687-1 4.071a29.026 29.026 0 01-.981-.08c-.831-1.006-.181-2.239-.503-3.279-.191.885.832 2.472-1.303 2.336l-.359.042z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#939393"
        d="M174.121 387.958l1.807-2.793v3.737c-.803.067-1.542.016-1.807-.944z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#959595"
        d="M151.188 387.95l1.416-2.11.514 1.252c-.342.963-.334 2.714-1.93.858z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#353531"
        d="M118.889 389.133l-3.831-.071c-2.801-.029-6.179 2.321-7.96-1.931.003-.999.244-1.891 1.134-2.484 5.505-.526 11.067.442 16.557-.641 1.196-.235 2.208.388 3.159 1.048l-.277 2.985c-2.752 1.779-5.878.546-8.782 1.094z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#969696"
        d="M128.143 387.955l1.478-2.106.527 1.264c-.346 1.046-.437 2.704-2.005.842z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#878787"
        d="M146.938 380.952c.067-.314.085-.632.055-.951.886.02 1.685.207 2.124 1.095l-.259 2.888c-2.143-.06-1.844-1.665-1.92-3.032z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A5959"
        d="M127.949 385.054l-19.71.057c-.447-.209-.549-.543-.354-.983 5.271-.771 10.744 1.106 15.896-1.219 1.673.316 1.415-2.298 3.063-2.019.228 1.14-.009 2.455 1.212 3.223a71.18 71.18 0 00-.107.941z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#595959"
        d="M174.021 384.022l-.141 1.06c-6.326-.062-12.651-.124-18.977-.188.045-.264.052-.527.018-.791 4.615-.681 9.413.967 13.922-1.082l.425-.058c.529.353 1.176.502 1.651.951.349.027.698.056 1.046.084.685.009 1.371.017 2.056.024z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E3E3B"
        d="M289.1 386.899c-1.453 3.881-4.893 1.294-7.252 2.229l-3.758-.059c-2.96-.438-6.125.755-8.906-1.118a2.229 2.229 0 01-.853-1.523c.002-.983.354-1.768 1.268-2.236 6.029-1.051 12.074-.801 18.126-.192 1.241.595 2.095 1.375 1.375 2.899z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#757575"
        d="M269.102 385.084l-.261 1.948c-1.11.118-1.112 1.283-1.748 1.85-.324.033-.649.064-.972.095-.241-1.38.316-2.965-1.041-4.059-.375-.493-.325-.939.147-1.342 1.263-.725 2.509-.713 3.737.085.404.439.45.914.138 1.423z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#949494"
        d="M267.092 388.882c.17-.998-.661-2.161.426-2.945.117-.085.867.709 1.323 1.096.081.318.195.625.342.92-.462.837-1.201 1.053-2.091.929z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#555454"
        d="M107.815 386.85c1.452 3.887 4.84 1.436 7.243 2.212l-.187 1.037-19.8-.037-.115-1.009c3.397-.33 7.133.94 9.955-2.106.976.202 1.926-.363 2.904-.097z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#393935"
        d="M313.162 388.971l-8.222.086-3.834.053c-2.975-.714-6.638 1.366-8.917-2.188-.46-.428-.643-.952-.549-1.574a2.507 2.507 0 011.208-1.229c5.792-.994 11.61-.548 17.429-.294 1.512.371 2.578 1.271 3.191 2.705.292.859.198 1.676-.306 2.441z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#787878"
        d="M292.104 385.096c-.085.307-.18.61-.284.911-.589.466-1.138 1.001-1.93 1.115-.265-.07-.529-.145-.792-.222l-1.004-2.011c-.376-.494-.322-.937.161-1.329 1.266-.708 2.51-.694 3.73.112.398.445.437.92.119 1.424z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8A8A8A"
        d="M289.891 387.122c.074-1.359.578-1.974 1.931-1.115.107.311.229.615.368.914-.204.675-.058 1.642-1.058 1.733-1.041.097-1.047-.838-1.241-1.532z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#595858"
        d="M331.064 382.953l2.998 1.158c-.033.261-.031.521.008.779l-18.969.204c-.376-.493-.359-.974.047-1.44 3.702-2.021 7.773-.678 11.631-1.278 1.481-.224 2.885.161 4.285.577z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#767575"
        d="M314.956 384.066l.145 1.027c.086.62.171 1.24.259 1.859l-.431.019c-.627.679-1.382-.904-1.989.112l-1.857-2.205c-.354-.523-.275-.972.235-1.346 1.33-.627 2.577-.674 3.638.534z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#909090"
        d="M312.939 387.084c.486-3.193 1.333.029 1.99-.112.289 1.444-.481 1.95-1.768 1.999l-.222-1.887z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A5959"
        d="M265.059 384.079c-.019.28-.013.561.02.84l-18.993.142-.109-1.035 14.023-.025c.849-.757 1.818-1.176 2.978-1.076.841.116 1.573.434 2.081 1.154z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#424243"
        d="M276.009 174.021a8215.34 8215.34 0 01-3.05 2.917c-1.561-3.438-5.677-3.433-7.954-5.904 4.301.463 8.755-1.156 12.935.946-.644.679-1.287 1.36-1.931 2.041z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBEBEB"
        d="M323.561 245.894c10.447.351 9.899.392 10.65 10.478.455 6.112-1.962 8.07-7.187 8.537-.466.698-1.159 1.02-1.947 1.192a6.28 6.28 0 01-3.051-.222c-1.271-.481-1.865-1.517-2.228-2.737-.275-1.36-.998-2.482-1.925-3.496a4.773 4.773 0 01-.683-1.216c-.3-.927-.355-1.874-.264-2.837 1.418-3.775 1.901-8.194 6.635-9.699z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DB4950"
        d="M323.561 245.894c-2.953 2.771-4.608 6.267-5.66 10.103-.56 1.662-1.153 3.281-3.46 2.73-1.624-.489-2.634-1.859-3.972-2.764-.925-.654-2.062-1.029-2.732-2.029-.191-1.087.256-2.011.963-2.717 9.286-9.257 18.031-19.067 28.096-27.536 1.102-.189 1.882.253 2.39 1.225.657 1.041 1.313 2.082 1.971 3.122-5.824 5.996-12.298 11.352-17.596 17.866z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DDC89F"
        d="M334.053 271.861l1.008.891c2.768 3.433 1.66 5.843-1.786 8.048-3.622 2.317-7.159 4.707-11.417 5.706-1.625.152-3.268.483-4.847-.278-.792-1.513.204-2.553 1.095-3.454 3.805-3.851 7.293-8.056 11.952-10.983a5.345 5.345 0 011.307-.561c.998-.233 1.883.029 2.688.631z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DAC49B"
        d="M325.004 264.998c.674-.029 1.347-.06 2.02-.09l1.973 1.099c2.213 1.434 3.751 3.106 2.098 5.912l-.23.125c-5.514.75-8.279 5.723-12.645 8.237-2.904-.453-5.797-3.368-8.73-.048-2.049-1.329-1.228-2.891-.373-4.461 2.051-1.993 3.531-4.75 6.791-5.158 6.398.962 8.167-.129 9.096-5.616z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CEBA93"
        d="M320.99 285.994c3.311-2.566 7.598-3.165 10.99-5.816 2.725-2.13 4.797-3.779 3.08-7.424 2.636 1.683 3.287 4.479 4.046 7.216l-1.052.058c-1.429-.014-2.134 1.234-3.203 1.852-4.08 1.901-7.409 4.901-11.011 7.51-1.887-.347-3.268-1.119-2.85-3.396z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECECEB"
        d="M331.094 271.919c-.051-2.2-1.057-4.063-2.098-5.912 5.057-.96 5.357 2.188 5.056 5.854l-2.958.058z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8AD7E"
        d="M334.99 280.99c.771-1.119 1.372-2.775 3.064-.963l-5.085 5.94-1.97.055c-.605-3.212 2.612-3.393 3.991-5.032z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F4F4"
        d="M334.034 195.165c.324-.142.647-.141.972.004 1.229 2.587 5.125-.467 6.012 2.844-.021.322-.056.642-.105.961l-1.961 2.008c-.084 1.322-.817 2.362-1.486 3.434-.9 1.207-1.986 2.244-3.012 3.339-2.288 2.071-4.125 4.715-7.252 5.723a1.771 1.771 0 01-1.275-.308s.08-.343.079-.344c-.615-.774-2.188-1.25-.687-2.639 1.447-1.339 2.68-2.933 4.219-4.146 3.571-2.818 5.802-6.088 4.496-10.876z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9FBFB"
        d="M341.018 198.013c-1.164-.487-2.301-1.441-3.628-.614-3.669 2.284-1.955-1.102-2.384-2.229 2.311-.611 4.925.634 7.045-1.15 1.673 1.311.538 2.591-.041 3.875-.329.05-.66.09-.992.118z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C1AE89"
        d="M334.99 280.99l-3.99 5.032-1.988 2.99c-2.382-.341-2.451 4.039-5.361 2.622-.487-.944-.455-1.822.316-2.61 2.478-4.319 6.492-6.531 11.023-8.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CEC1AC"
        d="M332.038 296.076c-1.095 1.373-2.606.886-4.007.902-3.059-3.551-3.064-4.108-.064-5.999 1.918 1.25 3.797 2.533 4.071 5.097z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B4A27F"
        d="M327.967 290.979c-2.621 2.028-1.019 4.011.064 5.999l-1.168.06-2.797-3.856c-.355-.163-.48-.432-.374-.809l.313-.37c.984-1.269 1.935-2.567 2.963-3.8 1.426-1.708 1.746-.438 2.043.809-.348.656-.697 1.311-1.044 1.967z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7E0D7"
        d="M336.992 203.99c.019-1.416.695-2.403 1.959-3.009 1.832 7.957 1.473 15.937.233 23.924l-2.013-1.282c-1.463-.248-1.76-1.279-1.718-2.544.666-5.682-1.299-11.602 1.539-17.089z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3CEA8"
        d="M285.991 323.04c-5.888-2.386-8.315-7.72-10.771-12.923-1.044-2.213-1.483-4.711-2.197-7.08.842-1.813 2.122-3.188 3.985-3.977l2.962-2.065c1.157-1.391 1.558-3.803 4.237-3.141 1.106.846 1.592 2.091 2.05 3.329 1.951 5.276 6.552 7.604 11.089 10.009 2.525 2.653 4.554 5.742 7.225 8.275.513.8 1.071 1.596.446 2.59a6.67 6.67 0 01-2.961 3.001c-9.384.547-15.627-5.155-22.393-11.892-.197 4.124 1.969 6.176 3.494 8.496 1.115 1.697 3.516 2.733 2.834 5.378z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DEC396"
        d="M285.991 323.04c-2.147-2.712-4.341-5.388-6.422-8.15-1.116-1.48-1.739-3.199-1.566-5.116.072-.796-.14-1.74.755-2.191.943-.477 1.639.235 2.112.842 5.432 6.962 12.861 10.541 21.186 12.635l-3.061 3.92c-4.831 3.802-7.13 3.459-13.004-1.94z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DDC292"
        d="M305.018 318.058l-1.003-2.05c7.034-1.308 12.703-6.495 20.005-7.043l.08-.069c-4.389 7.158-11.314 9.038-19.082 9.162z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CFD1D5"
        d="M292.973 336.094l1.963-2.194c2.673 2.646 6.186.616 9.198 1.85-3.676 1.531-7.366 1.993-11.161.344z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CCCFD3"
        d="M330.748 335.792c-1.701.878-1.979 1.142-2.257 1.145-2.387.025-4.774.003-7.161-.005.045-.451.011-1.27.145-1.298 2.721-.574 5.416-.305 9.273.158z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBBFC6"
        d="M319.031 336.43c-2.242.38-2.791.537-3.343.545-.388.005-1.138-.055-.735-.68.279-.432 1-.691 1.565-.787.386-.066.843.282 2.513.922z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5CFA5"
        d="M324.02 308.965c-3.641 1.765-7.286 3.464-10.785 5.573-2.574 1.553-6.004 1.825-9.22 1.47-3.238-1.881-5.045-5.015-7.015-8.008-.038-.161-.146-.439-.102-.467 5.201-3.193 8.877-7.496 10.024-13.667 2.531.229 2.371 2.046 2.262 3.832-1.672 2.546 1.076 2.98 2.115 3.875 3.757 3.236 8.457 4.958 12.721 7.392z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BF4145"
        d="M309.184 297.698l-2.072-3.942c-1.722-1.138-2.026-2.914-2.159-4.772.483-3.184 2.187-5.206 5.467-5.724.755.005 1.493.146 2.224.32 4.486.117 3.445 3.791 4.108 6.379.03.758-.126 1.456-.671 2.022-2.635 1.502-3.89 4.667-6.897 5.717z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5C4B0"
        d="M316.08 291.981l-.249-1.782c-.528-1.667-.621-3.206 1.225-4.176 1.312-.1 2.616-.961 3.935-.029.659 1.338 1.664 2.335 2.977 3.03l.039 2.979-.002.001c-1.074 1.354-1.932 3.135-4.199 2.107-1.66.019-2.476-1.435-3.726-2.13z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C1AE89"
        d="M319.805 294.111c1.753.002 2.795-1.414 4.199-2.107l.063 1.176c-1.12 1.695-2.444 2.443-4.262.931z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A82AE"
        d="M329.973 186.854c1.396-1.151 2.754-1.27 4.055.152 1.955 3.247 5.492.305 7.842 2.004l.002 3.007c-2.664-.007-5.33-.065-7.993-.004-2.426.056-3.019-.904-1.876-3.01-.592-.797-1.812-1.002-2.03-2.149z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D8AB9"
        d="M341.869 189.01l-6.865-.015c-1.668-.004-1.279-1.019-.977-1.989 2.465 1.519 5.207.848 7.846.995l-.004 1.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B93F3E"
        d="M330.993 114.98l-3.927-.104c-.268-2.788.023-5.227 3.539-5.643 2.249 1.773 2.023 3.712.388 5.747z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#908F8F"
        d="M107.815 386.85c-.618.611-1.158 1.592-1.874 1.744-1.006.215-.844-.97-1.03-1.647l.065-1.929c.084-.265.152-.533.204-.805l2.704-.086.352.983c-.138.58-.279 1.16-.421 1.74z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="gray"
        d="M331.064 382.953c-.992 1.653-1.965.602-2.941-.02-.604-.465-.67-1.039-.348-1.694.623-1.262 1.471-.498 2.262-.251.343.656.686 1.31 1.027 1.965z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2B7BF"
        d="M90.177 276.995c-2.491.297-3.12-.836-3.234-2.877-.137-2.432 1.221-3.564 3.188-3.437 2.121.139 3.601 1.744 3.73 3.957.176 3.04-2.703 1.498-3.684 2.357z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BEBEC0"
        d="M117.415 277.139c-1.278-.174-2.457-.167-3.51-.527-.87-.298-.95-1.275-.74-2.117.207-.828.868-.727 1.549-.683 2.433.158 4.84.796 7.316.234.846-.191 1.711.257 1.781 1.242.088 1.253-.903.937-1.695 1.031-1.613.193-3.206.549-4.701.82z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C3C7CC"
        d="M92.952 308.099c1.623 1.722 1.543 3.743.202 5.339-.99 1.178-2.859.687-4.295.476-2.477-.362-1.688-2.4-1.745-3.963 1.627-1.621 4.304.067 5.838-1.852z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2B7BF"
        d="M90.502 284.426c1.458-.248 3.302-.496 3.059 1.715-.171 1.555-1.556 3.264-3.27 3.071-1.561-.175-3.041-1.7-3.084-3.409-.065-2.527 1.899-1.47 3.295-1.377z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2B2B5"
        d="M111.527 286.904c-3.836.549-7.78 2.348-11.422-.337 3.825-.234 7.662-1.271 11.422.337z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7B7B9"
        d="M144.255 276.659c-1.283-.494-3.912 1.069-3.452-1.292.466-2.389 3.307-1.198 5.13-1.314 1.003-.064 2.956-.414 2.667 1.133-.465 2.509-2.731 1.608-4.345 1.473z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ACACAF"
        d="M123.639 311.209c-2.73 1.876-5.57 1.783-8.388 1.826-1.042.017-2.085-.182-1.971-1.516.108-1.259 1.128-.758 1.875-.72 2.828.142 5.656.274 8.484.41z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B9BDC4"
        d="M90.177 302.752c-1.549-.768-2.594-2.131-2.712-3.728-.12-1.623 1.372-1.999 2.783-2.042 1.748-.053 2.953.558 2.669 2.542-.221 1.549-1.134 2.654-2.74 3.228z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AFB0B2"
        d="M144.925 310.7c1.11 1.129 4.141-1.369 3.652 1.108-.47 2.38-3.693.837-5.676 1.112-.958.133-2.95.397-2.319-1.346.702-1.944 2.821-.778 4.343-.874z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AAABAD"
        d="M111.575 300.737c-3.38 1.438-6.878 1.307-10.405.771 3.351-1.821 6.881-1.25 10.405-.771z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B0B1B3"
        d="M102.805 274.939c3.082-1.532 6.085-1.341 9.056.463-2.606.413-5.09 1.595-7.798.854-.644-.224-1.09-.638-1.258-1.317z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A7A8AB"
        d="M140.892 301.904c1.98-2.731 4.711-1.557 7.084-2.131.202-.049.762.527.809.862.106.763-.491 1.225-1.16 1.244-2.242.064-4.488.025-6.733.025z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5A6A9"
        d="M140.867 287.357c2.472-2.071 5.225-1.345 8.922-1.406-3.263 3.168-6.23 1.441-8.922 1.406z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BCBCBE"
        d="M127.993 311.102c.083-.14.137-.364.255-.406 1.883-.669 3.732-.29 5.546.297.071.022.044 1.096-.218 1.282-2.049 1.456-4.383.496-6.594.655-.45-1.045.219-1.471 1.011-1.828z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ABACAF"
        d="M134.629 274.904c-3.22 1.328-5.954-.033-8.021 1.709-.446.375-1.303-.074-1.414-.867-.097-.694.144-1.134 1.021-1.256 2.484-.349 4.951-.86 8.414.414z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BCBCBE"
        d="M127.921 286.102c1.971-1.244 3.668.113 6.334.177-2.637 2.701-5.118 1.357-7.275 1.661-.473-1.016.153-1.469.941-1.838z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2B2B5"
        d="M127.031 299.936c2.178-.252 4.412-.795 6.631 1.533-2.412.927-4.584.415-6.686.451-.567-.678-.582-1.34.055-1.984z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2B6BF"
        d="M92.952 308.099c-.872 4.004-3.804 1.518-5.839 1.853.972-3.69 3.887-1.255 5.839-1.853z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7B7BA"
        d="M109.115 312.146c-2.568 1.73-5.368.472-8.156.538.977-.667 1.163-2.759 3.1-1.468 1.294.557 2.659.18 3.986.305.485-.011.835.208 1.07.625z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A8A8AB"
        d="M117.991 287.951c-.663.038-1.366-.055-1.979.14-1.493.472-2.945.433-2.796-1.445.154-1.937 1.83-.508 2.795-.697.631-.124 1.319.046 1.982.085.596.639.597 1.279-.002 1.917z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A1A2A5"
        d="M117.975 301.866c-1.501-.487-4.232 2.005-4.37-.707-.112-2.206 2.805-.799 4.37-1.031.612.579.612 1.159 0 1.738z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ACADAF"
        d="M117.975 301.866v-1.739c1.853.163 3.83-.813 6.142.89-2.332.647-4.16 1.124-6.142.849z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B0B1B3"
        d="M117.991 287.951l.002-1.918c1.841.236 3.834-.756 6.419 1.213l-6.421.705z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B0B0B3"
        d="M138.875 300.777c-.342 1.243-1.327 1.22-2.311 1.153-.746-.051-1.352-.583-1.109-1.214.376-.979 1.456-1.199 2.417-1.271.878-.064.927.684 1.003 1.332z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A9AAAD"
        d="M138.678 274.891c-.262 1.3-1.267 1.536-2.177 1.713-.668.13-1.258-.271-1.243-1.078.025-1.348 1.043-1.45 2.023-1.449.607-.001 1.303.058 1.397.814z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2B3B5"
        d="M136.292 286.854c.2-.896.735-1.423 1.626-1.443.883-.021.964.691.941 1.322-.027.757-.597 1.111-1.27 1.132-.651.02-1.24-.219-1.297-1.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B3B4B6"
        d="M137.838 310.338c.875.005 1.037.643 1.018 1.288-.021.714-.481 1.195-1.206 1.21-.635.014-1.356-.091-1.335-.973.021-.943.672-1.356 1.523-1.525z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBBBBD"
        d="M102.805 274.939l1.258 1.314c-.941.828-2.448 1.231-3.01.414-.539-.781 1.12-1.126 1.752-1.728z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7B7BA"
        d="M109.006 311.099c.914-1.093 1.699-.266 2.405.255.18.133-.023.784-.051 1.197l-2.246-.406c0 .002-.237-.269-.237-.269-.277-.223-.35-.412-.22-.568.116-.139.232-.209.349-.209z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A2A3A6"
        d="M127.921 286.102l-.941 1.838c-1.086-.013-2.195-.191-1.564-1.63.574-1.308 1.618-.664 2.505-.208z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5A6A9"
        d="M127.993 311.102l-1.011 1.828c-.984-.026-2.096-.105-1.622-1.493.561-1.642 1.669-.846 2.633-.335z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A3A3A6"
        d="M127.031 299.936l-.055 1.984c-.773.025-1.751.083-1.724-.941.026-.927.524-1.831 1.779-1.043z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9C9CA0"
        d="M109.006 311.099a8.817 8.817 0 01-.127.778c-1.651.093-3.353.56-4.821-.662 1.65-.037 3.299-.077 4.948-.116z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDBDBD"
        d="M209.797 219.004c-.665.006-1.33.021-1.994.004-9.754-.238-8.688 1.983-8.847-9.125-.038-2.631.618-4.203 3.583-3.917 1.655.159 2.662-1.051 3.932-1.82 2.715-1.645 5.551-1.956 8.218.302.61.517 1.226 1.186 1.948 1.379 1.81.486 4.556-.486 5.001 2.14.491 2.899.331 5.957.084 8.915-.15 1.801-1.856 2.116-3.451 2.117-2.824-.001-5.649-.001-8.474.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E0E0E0"
        d="M88.113 198.226l-.119-1.22 43.019.006-.092 1.144-42.808.07z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6BBC0"
        d="M313.936 221.004c-.664 1.27-1.591 2.281-2.885 2.929-2.643-2.387-6.42.494-9.05-1.95-.421-.429-.429-.865-.028-1.31 1.725-1.224 3.722-.925 5.646-1.015 1.348.136 2.488-.528 3.685-.989.442-.051.859.034 1.258.226.751.51 1.311 1.148 1.374 2.109z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9EABB4"
        d="M318.928 216.047c-.381.897-.979 1.55-1.975 1.756-1.311-.406-2.178.569-3.207 1.043-.54.289-1.09.489-1.684.147l-.162.037c-1.628-.835-1.652 1.948-3.154 1.399-1.584-2.479-4.576-1.898-6.755-3.101-.325-.405-.313-.813-.017-1.224l16.954-.057z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#848587"
        d="M145.942 222.256c-1.301-.117-3.55 2.092-3.668-.842-.112-2.761 2.711-.065 3.72-1.305.552.73.621 1.448-.052 2.147z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#36B2E6"
        d="M169.254 221.025c.2-1.264.87-2.041 2.216-1.985 1.278.053 1.492.941 1.429 1.994-1.22 2.001-2.433 1.162-3.645-.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8E8F91"
        d="M156.786 221.476c-.036 1.372-.818 1.521-1.635 1.422-.507-.062-1.575.208-1.258-.798.199-.633.96-1.233 1.612-1.512.277-.118.921.623 1.281.888z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7F7F81"
        d="M163.081 221.493c-1.777.786-3.35.165-5.343-.571 2.354-1.746 3.896-.965 5.324.586l.019-.015z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#87888A"
        d="M145.942 222.256l.051-2.147 4.203 1.146c-1.842.736-2.617 2.394-4.254 1.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2AAEE5"
        d="M169.254 221.025c1.215.089 2.428.899 3.645.009.237 1.071.05 1.963-1.238 1.99-1.301.028-2.667-.061-2.407-1.999z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#90A3AD"
        d="M301.975 216.105c.022.32.043.641.062.962 1.032 1.283 1.059 2.574.034 3.875-.023.347-.047.693-.069 1.04-1.521-1.952-1.562-3.911-.027-5.877z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#77777A"
        d="M163.081 221.493s-.02.011-.019.013c.674-.549 1.189-1.727 2.254-1.063.693.432-.044 1.138-.354 1.551-.941 1.255-1.478.524-1.881-.501z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5CFA6"
        d="M283.999 294l-4.029 2.995-.031-2.963c-.799-1.008-.658-2.014.004-3.019l.015-2.003c-.803-.912-.704-1.837-.042-2.771 2.476-6.971 7.314-12.277 12.306-17.478 1.591-.903 2.903-2.091 3.788-3.714 1.122-1.388 1.402-3.93 4.179-3.053 1.102 1.212-.571 2.881 1.137 4.636 2.409-3.308 7.205-4.121 7.994-8.97.246-1.193.612-2.313 1.832-2.883 1.389.639 2.071 1.932 2.879 3.108 1.105 1.281 2.764.42 4.038 1.044l-.022-.002c1.679 2.14.859 4.064-.624 5.818-1.186 1.402-2.263 2.846-2.968 4.545-.908 2.963-3.543 4.365-5.644 6.249-2.79 2.841-6.122 5.196-7.972 8.889-.827.546-1.742.661-2.701.57a6.06 6.06 0 01-1.344-.351c-3.173-1.821-6.207-2.161-8.922.846-.944.951-1.662 2.044-2.089 3.321-.772 1.671-.083 3.844-1.784 5.186z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#949494"
        d="M194.518 278.847c-4.594 1.002-6.454-.158-6.659-5.367-.245-6.204 3.142-5.315 7.035-5.598 4.625-.335 6.169.872 6.254 5.859.098 5.734-2.665 5.911-6.63 5.106z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6B564A"
        d="M259.836 311.958c6.044-2.176 9.538 1.279 10.158 10.044-1.108.523-1.813-.115-2.486-.854a6.178 6.178 0 01-.617-1.282c-2.265-5.838-2.409-5.774-6.974-1.817-2.918 2.529-5.939 5.094-9.917 5.952-.795-.02-1.523-.183-1.973-.934 2.503-2.838 4.822-5.854 7.915-8.118.822-1.617 1.803-3.028 3.894-2.991z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B0B0B3"
        d="M208.529 316.467h17.879l.008 1.037h-17.847l-.04-1.037z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6B6B8"
        d="M279.943 291.014l-.004 3.018c-3.823-.007-7.645-.011-11.467-.024-.823-.003-1.917.063-2.055-.903-.177-1.244.906-1.274 1.911-1.63 3.865-1.366 7.833 1.463 11.615-.461z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADADB0"
        d="M279.917 286.24l.042 2.771h-13.452c4.093-4.345 9.147-.771 13.41-2.771z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AEAFB1"
        d="M253.037 292.1c3.406-1.215 6.945.627 10.378-.443.481-.15 1.451-.235 1.447.785-.004.989-.693 1.457-1.6 1.458-3.11.003-6.221-.049-9.331-.079-.644-.394-1.463-.698-.894-1.721z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A1A2A5"
        d="M259.836 311.958l-3.895 2.99c-2.03-2.067-4.64-.514-6.906-1.105-.629-.6-.62-1.211-.033-1.833l10.986-1.004a3.24 3.24 0 01-.152.952z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BCBDBF"
        d="M207.021 303.067c2.993.577 6.157-.45 9.062.965.529-.188 1.009-.005.98.526-.029.535-.534.653-1.039.432-3.015.269-5.919 1.532-9.023 1.006-1.466-.985-1.691-1.964.02-2.929z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADADB0"
        d="M214.903 291.555c-1.738 2.42-3.428 2.677-4.991 2.404-1.928-.336-5.506 1.363-5.47-1.285.043-3.124 2.967.719 4.757-.49 1.169-.788 3.128-.404 5.704-.629z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2B2B5"
        d="M216.024 304.99c.138-.224.294-.44.395-.681.016-.039-.219-.183-.337-.278 2.389-1.768 4.805-1.436 7.166.009.238.146.224 1.274.137 1.3-2.483.73-4.991 1.413-7.361-.35z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADAEB0"
        d="M204.462 312.98c3.319-.248 6.676-1.907 10.759-.157-4.007 1.573-7.355 1.441-10.759.157z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B1B2B4"
        d="M236.541 317.034c-2.706.645-5.395 3.003-8.617-.162 3.175-1.519 5.899-.398 8.617.162z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A9A9AC"
        d="M225.042 287.359c-3.345 2.388-5.904 1.69-8.42 1.224-.128-.023-.292-1.149-.13-1.246 2.583-1.544 5.108-.456 8.55.022z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2B2B5"
        d="M218.06 297.186c-3.212.933-6.403 1.047-9.59-.27 3.101-1.363 6.341-.814 9.536-.801.354.221.48.452.379.696-.104.25-.212.375-.325.375z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ABACAE"
        d="M224.204 292.847c-3.072 1.573-5.487 1.66-7.851.308-.173-.099-.067-1.23.091-1.278 2.486-.752 4.89-.549 7.76.97z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CDCECF"
        d="M207.021 303.067c-.688.972-.666 1.948-.02 2.929-2.681.862-5.349-.32-8.026-.051.01-2.23 1.512-2.124 3.057-1.951 1.55-.92 3.216-1.21 4.989-.927z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A9A9AC"
        d="M224.013 313.019c-.7.425-1.097.876-1.466.854-2.044-.117-4.225.86-6.083-.641-.159-.129.086-1.201.271-1.241 2.417-.517 4.858-.925 7.278 1.028z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#96979B"
        d="M256.962 288.827l-7.902-.017c-.649-.561-.642-1.132-.026-1.712 2.646.229 5.297-.792 7.942.029.601.572.611 1.139-.014 1.7z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B0B1B3"
        d="M218.06 297.186l-.054-1.071c2.831.073 5.751-.686 9.761.833-4.108 1.486-6.899 1.347-9.707.238z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A0A0A4"
        d="M200.966 317.861c-2.828-.806-6.049 1.215-9.438-1.608h9.415c.629.527.62 1.063.023 1.608z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C1C2C3"
        d="M237.076 305.818c-1.895-.765-4.107.482-5.861-.924-.153-.123.098-1.219.339-1.295 2.521-.79 5.066-1.261 7.484.364-.426.86-1.418 1.121-1.962 1.855z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B1B1B4"
        d="M249.026 293.848c-2.277-.508-5.127 1.805-6.857-1.394 2.218-.918 4.499-.988 6.82-.5.596.619.612 1.25.037 1.894z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A8A9AB"
        d="M231.899 288.467c2.299-3.016 5.387.112 7.386-1.842.319.495.867.973.907 1.49.066.857-.75.905-1.383.865-2.172-.135-4.342-.318-6.91-.513z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ACACAF"
        d="M232.056 314.011c.443-1.347.471-1.626.549-1.641 2.472-.463 5.681-1.69 7.223.137 1.529 1.813-1.311 1.508-2.212 1.391-1.695-.221-3.352-.744-5.56.113z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5A5A9"
        d="M256.962 288.827l.014-1.699c2.643-1.213 4.999 1.127 7.647.305-2.365 2.289-5.084 1.345-7.661 1.394z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AEAFB1"
        d="M200.001 297.829c-2.601-.262-5.522 1.2-8.549-1.858 3.498.017 6.136-.485 8.552 1.208l-.003.65z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8B9BB"
        d="M233.02 297.945c-.992.495-1.93 1.227-3.131.459-.779-.499-2.025-.702-1.691-1.967.397-1.503 1.576-.493 2.4-.488 1.124.006 2.247.164 3.371.258.488 1.018-.434 1.268-.949 1.738z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AEAEB1"
        d="M249.002 312.01l.033 1.834c-2.188-.073-4.455.76-7.021-.728 2.345-1.861 4.757-1.024 6.988-1.106z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2B2B4"
        d="M252.013 295.962c2.169.309 4.486-.615 7.016.957-2.394 1.798-4.829.768-7.041.995-.577-.658-.592-1.31.025-1.952z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AAABAE"
        d="M249.034 287.099l.026 1.713c-2.204.009-4.469.771-7.086-.709 2.423-1.775 4.805-1.034 7.06-1.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8F8F8F"
        d="M209.829 276.322c-1.411 1.25-2.643.395-3.885-.332-.37.419-.716.4-1.039-.057.514-5.118 3.187-1.299 4.961-1.198.421.539.408 1.069-.037 1.587z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2B2B5"
        d="M196.059 304.09c-.572 2.702-2.572 1.869-4.23 1.614-.715-.11-.782-.914-.715-1.59 1.638.543 3.169-1.823 4.848-.179l.097.155z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B3B4B6"
        d="M202.032 303.994l-3.057 1.952c-1.566.312-1.961-1.215-2.917-1.858 0 .002-.095-.15-.096-.151 2.036-1.274 4.061-1.486 6.07.057z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADADB0"
        d="M245.019 317.906c-1.806 1.269-3.354.823-4.958-.833 1.487-1.726 3.328-.834 4.974-.872.548.574.534 1.142-.016 1.705z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B4B4B6"
        d="M227.944 303.112c.805-.001 1.68-.05 1.846 1.018.196 1.259-.571 1.71-1.685 1.743-.817.023-1.685-.014-1.877-1.03-.249-1.324.666-1.621 1.716-1.731z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AFB0B2"
        d="M196.977 293.032c-1.82.896-3.681 1.596-5.602.376-.264-.167-.161-.914-.227-1.393 1.958.41 3.929-1.002 5.883.037.224.23.29.453.2.666-.089.21-.173.314-.254.314z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A8A9AC"
        d="M207.031 287.807c2-.689 4.007-1.28 6.811-.302-2.261 2.262-4.668 1.311-6.824 1.368-.233-.24-.308-.479-.227-.714s.161-.352.24-.352z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B3B3B6"
        d="M245.033 297.897c-1.718 1.191-3.222 1.101-4.498-.696 1.225-1.767 2.947-1.064 4.502-1.081.556.594.553 1.187-.004 1.777z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADADB0"
        d="M196.948 313.109c-2.016.736-4.063 1.858-6.749-1.078h6.81c.235.253.304.498.208.732-.094.231-.184.346-.269.346z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AEAEB1"
        d="M200.001 297.829c0-.218.001-.435.003-.651 1.741-1.025 3.508-1.801 5.798-.449-1.73 2.164-3.905 1.002-5.801 1.1z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADAEB0"
        d="M200.966 317.861l-.022-1.609c1.562-.237 3.125-.489 5.016.383-1.585 1.959-3.369 1.277-4.994 1.226z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AAABAE"
        d="M236.044 291.912c.621.129 1.248.384 1.862.356.745-.034 1.598-1.797 2.173.148.645 2.185-1.106 1.428-2.045 1.543-.644.079-1.314-.057-1.973-.097-.721-.319-1.4-.722-1.123-1.652.155-.517.662-.463 1.106-.298z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A7A8AA"
        d="M249.026 293.848l-.038-1.894c1.355-.112 2.728-.716 4.048.145l.895 1.722-4.905.027z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9E9FA2"
        d="M196.948 313.109l.061-1.078c1.425-.061 2.881-.455 4.495.498-1.436 1.761-2.888 1.837-4.556.58z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADADB0"
        d="M226.108 314.08c1.234-1.975 1.92-2.947 3.287-2.607.252.063.553.887.452 1.254-.546 1.982-2.021.922-3.739 1.353z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C4C4C4"
        d="M277.008 299.061a11.323 11.323 0 01-3.986 3.977l-.007-3c1.226-.758 2.527-1.205 3.993-.977z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AEAEB1"
        d="M226.606 293.627c.318-1.554 1.21-2.354 2.747-2.196.218.022.596.875.495 1.227-.545 1.886-1.906 1.331-3.242.969z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9FA0A3"
        d="M197.008 287.03c1.441-.046 2.917-.44 4.552.531-1.455 1.787-2.956 1.819-4.666.652-.474-.442-.436-.837.114-1.183z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADADB0"
        d="M197.008 287.03l-.113 1.183c-1.649.687-3.307 1.251-5.127.37 1.402-1.842 3.334-1.653 5.24-1.553z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A0A1A4"
        d="M226.563 288.748c.541-1.458 1.264-2.309 2.524-2.266.82.027.925.863.702 1.457-.546 1.457-1.758.97-3.226.809z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B4B4B6"
        d="M233.02 297.945l.949-1.74c1.043-.524 2.639-1.184 2.558.55-.1 2.134-2.24.961-3.507 1.19z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8F8F93"
        d="M196.977 293.032c.044-.325.063-.651.054-.979 1.22-.011 2.546-.539 3.77.924-1.368 1.048-2.548 1.222-3.824.055z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6B6B6B"
        d="M227.478 274.855c1.064-1.257 1.726-.157 2.234.519.467.621.008 1.477-.679 1.38-1.172-.165-3.152.732-3.057-1.744.465-.399.966-.45 1.502-.155z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#868686"
        d="M222.873 274.938c-.908 1.19-1.818 2.504-3.578 1.748-.295-.127-.475-1.291-.245-1.736 1.063-2.06 2.169-.066 3.271.078l.552-.09z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7E7E7E"
        d="M209.829 276.322l.038-1.586c1.496-1.88 2.714.453 4.098.27l-.057-.072c-1.186.973-2.045 2.908-4.079 1.388z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6D6D6D"
        d="M222.873 274.938l-.287-.013-.267.103c1.659-1.854 3.406-1.048 5.157-.172l-1.5.154c-1.072 1.628-2.087.743-3.103-.072z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A0A0A4"
        d="M237.076 305.818c-1.28-2.665 1.073-1.484 1.962-1.854 1.395 2.787-.995 1.567-1.962 1.854z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#737373"
        d="M204.905 275.934c.346.02.692.038 1.039.057-2.573.789-2.573.789-2.825-2.338 1.498.063.392 2.159 1.786 2.281z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A2A3A6"
        d="M245.033 297.897l.004-1.777c.931-.035 2.441-.459 2.537.577.162 1.76-1.537 1.058-2.541 1.2z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A2A3A5"
        d="M245.019 317.906l.016-1.706c.933-.075 2.444-.523 2.538.524.158 1.76-1.534 1.075-2.554 1.182z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A8A9AC"
        d="M233.896 293.853c-.916.043-2.342.481-2.432-.688-.131-1.696 1.567-1.063 2.552-1.286.534.692.597 1.356-.12 1.974z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AFB0B2"
        d="M207.031 287.807l-.014 1.066c-.93.063-1.946.45-2.628-.533-.123-.176-.033-.703.141-.848.91-.755 1.753-.487 2.501.315z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C7C7C9"
        d="M233.896 293.853l.12-1.973c.693-.966 1.366-.8 2.028.033-1.037.659-.229 1.303.017 1.951-.722-.005-1.443-.009-2.165-.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#787878"
        d="M213.965 275.006c.495-1.104 1.413-1.271 2.273-.689.205.138-.068 1.682-.481 1.901-1.093.58-.754-1.474-1.847-1.283l.055.071z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AAABAE"
        d="M252.013 295.962l-.025 1.953c-.905-.025-2.038.083-1.688-1.333.178-.725.821-1.3 1.713-.62z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8A8A8A"
        d="M104.17 256.965c-3.192.646-4.003-.874-4.137-4.06-.179-4.273 2.413-3.616 5.073-3.855 3.599-.323 3.846 1.532 3.979 4.41.183 3.978-2.227 3.673-4.915 3.505zM125.689 256.903c-3.285.595-4.635-.373-4.661-3.825-.026-3.472 1.398-4.026 4.409-4.054 3.195-.029 4.735.538 4.681 4.268-.053 3.682-1.757 4.147-4.429 3.611zM146.894 249.171c3.14-.631 4.134.694 4.216 3.975.091 3.629-1.632 3.853-4.485 3.949-3.322.113-4.616-.771-4.603-4.368.015-3.866 2.13-3.81 4.872-3.556z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#868686"
        d="M114.907 256.933c-3.344.697-3.978-.985-4.072-4.089-.116-3.794 1.959-3.652 4.638-3.772 3.222-.144 4.322 1.02 4.316 4.24-.008 3.682-2.053 3.962-4.882 3.621zM135.887 249.247c3.299-.508 4.907.317 4.908 3.8.001 3.447-1.577 4.04-4.548 4.023-2.901-.017-4.544-.37-4.419-3.963.115-3.283 1.041-4.704 4.059-3.86zM94.047 249.201c2.929-.397 4.772.161 4.743 3.749-.027 3.295-1.313 4.242-4.442 4.118-2.75-.11-4.658-.135-4.521-3.866.116-3.215 1-4.649 4.22-4.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F4F4"
        d="M102.811 190.957c.331-6.636.331-6.641 7.012-6.641 29.789-.002 59.578-.002 89.367 0 6.668 0 6.668.005 7 6.64.247.25.319.49.219.72-.098.225-.192.336-.282.336-1.463 1.649-3.421 1.001-5.169 1.003-30.968.039-61.935.038-92.903.001-1.752-.002-3.707.628-5.176-1.004-.279-.217-.382-.446-.309-.686.075-.246.155-.369.241-.369z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A82AE"
        d="M206.128 192.012l.063-1.055c1.518-2.465 3.969-1.953 6.252-1.954 28.125-.015 56.251-.025 84.376-.037 1.026 1.294-.022 2.107-.696 3.008l-89.995.038z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DBE4E9"
        d="M79.963 192.007l-.111-2.998c.649-5.296 2.127-5.945 9.151-4.021.761.997.448 1.766-.502 2.4-3.797-.082-2.549 4.223-4.775 5.507-1.383.247-2.74.388-3.763-.888z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A82AE"
        d="M102.811 190.957l.069 1.055-11.876-.018c1.37-3.777 7.722-4.335 11.807-1.037zM308.836 188.083c2.263-1.066 3.938 1.802 6.172.921.572 1.082-.148 1.531-.951 1.939-4.395.208-8.702 1.504-13.149 1.038-.557-1.234-.031-2.191.782-3.075 1.269-.482 2.51.313 3.772.094 1.212.022 2.399-.058 3.374-.917z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#376F8D"
        d="M83.726 192.895c.011-1.123.097-2.251.021-3.368-.269-3.957 1.396-4.45 4.456-2.555 1.708 2.069.948 4.052-.21 6.021l-4.267-.098z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1A5370"
        d="M302.057 189.009l-1.148 2.973-4.786-.008c.234-1.003.467-2.005.699-3.008 1.115-3.397 2.742-3.866 4.974-.867.71.124.798.426.261.91z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A82AE"
        d="M324.096 187.979l2.796.998c.741.635 2.484.227 2.108 2.024-2.983 1.608-5.975 1.555-8.973.045-.245-.235-.35-.488-.315-.761.036-.281.088-.423.154-.424 1.327-.808 2.795-1.308 4.23-1.882z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B5472"
        d="M320.076 190.155c.006.298-.01.594-.049.89-2.01 1.131-4.004 1.301-5.971-.101.316-.647.635-1.294.951-1.94 1.484.137 1.902-1.441 3.027-1.883 1.34.568 2.755 1.085 2.042 3.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1A526F"
        d="M329 191.001c-.549-.834-2.399-.314-2.107-2.024l3.08-2.122c1.211.21 2.063.761 2.029 2.148-1.551-.159-1.953 1.404-3.002 1.998z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECEFF0"
        d="M87.992 192.992l.21-6.021.801-1.984c2.295 2.012.602 4.719 1.224 7.021-.497.89-1.312 1.059-2.235.984z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E14A52"
        d="M299.953 261.899l-3.942 3.149c-.078-3.393-.172-6.786 1.008-10.053 11.741-11.968 23.182-24.24 35.799-35.326 1.737-.157 2.765.678 3.22 2.309l1.134 1.645c-6.44 8.015-14.337 14.619-21.362 22.068l-7.81 8.281c-.724 2.899-3.345 4.264-5.103 6.328-.86.755-1.698 1.558-2.944 1.599z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E64C54"
        d="M333.178 219.619c-8.795 10.409-19.074 19.37-28.495 29.169-2.286 2.377-4.399 5.019-7.664 6.208.229-3.563 1.747-6.738 2.996-9.995 10.364-8.808 19.157-19.256 29.416-28.178 1.624-.562 2.661.313 3.584 1.468.227.42.28.864.163 1.328z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EB4D56"
        d="M330.137 216.605c-9.509 10.03-18.104 21.028-30.122 28.396 4.358-10.403 12.374-17.931 20.144-25.66 1.994-1.984 3.849-4.111 5.768-6.173.364-.074.729-.148 1.094-.224 1.866.516 3.036 1.624 3.116 3.661z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8E9AA5"
        d="M312.063 218.993l.938-.973c2.048-.862 2.727-.24 2.031 1.873l-1.096 1.11c-.913-.401-1.6-1.013-1.873-2.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5D0D1"
        d="M315.031 219.894c-.031-1.325-.711-1.946-2.031-1.874 1.242-1.446 2.569-1.351 3.953-.216l-1.922 2.09z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B5371"
        d="M320.076 190.155l-2.041-3.034c2.26-1.414 4.178-.403 6.06.857-.423 2.418-1.929 2.835-4.019 2.177z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C87B5"
        d="M302.057 189.009a20.55 20.55 0 01-.26-.911l4.362-.015c.452.662.431 1.297-.11 1.902-1.448.155-2.756-.266-3.992-.976z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B5574"
        d="M306.049 189.985l.109-1.903 2.68.001c-.418 1.386-1.412 1.925-2.789 1.902z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#755C4B"
        d="M272.005 327.995l3.993 4.007c-.563 8.016-5.152 11.681-15.013 9.616-4.748-.993-9.602-.418-14.261-2.112-5.524-2.008-6.145-3.27-2.149-7.533 1.351-1.44 2.942-2.655 4.423-3.974 1.045.882 1.235 2.14.685 3.173-2.414 4.533.662 4.895 3.872 5.531 3.487.692 6.96-.165 10.425.231a8.24 8.24 0 011.331.365c5.266 1.148 7.619-1.154 6.125-6.018-.332-.934-.391-1.86.061-2.774.168-.171.338-.342.508-.512z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7B6050"
        d="M265 337.999c-4.037-.064-8.044.725-12.121.069-2.198-.353-4.174-.875-5.7-2.474-2.38-2.493 1.037-3.117 1.558-4.683.3-.9.188-1.938.262-2.913l.003-.995c3.747-2.432 6.344-6.125 10.017-8.748 5.501-3.93 5.252-4.279 8.98 1.745l.003.997c.534.596.63 1.249.256 1.962-6.654-2.534-10.095 1.598-13.426 6.294-1.479 2.083-1.142 3.131 1.081 4.141 1.956.889 3.709 2.152 5.964 2.401 1.312.145 3.208-.104 3.123 2.204z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#71594A"
        d="M267.999 320.001c-5.037-4.261-8.127-3.65-12.829 2.743-1.603 2.179-2.97 4.486-6.168 4.26l.999-3.004c3.393-3.562 8.089-5.4 11.495-9.082 2.847-3.079 5.207-1.174 6.503 5.083z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#755C4B"
        d="M268 323l.002-2.002 1.992 1.004 2.007 2.996.004 2.997-.009.008c-3.265-.123-4.139-2.157-3.996-5.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#31312C"
        d="M327.775 381.239c.116.565.231 1.13.348 1.694-4.229 2.24-8.803.459-13.167 1.133l-3.889.052c-1.288.739-2.276.163-3.192-.73-.221-.461-.195-.908.075-1.343.109-1.26.737-2.015 2.049-2.107l16.061-.042 1.715 1.343z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#363632"
        d="M291.958 384.06l-3.879.052c-1.845.894-2.713-.214-3.418-1.664-.119-.5-.032-.969.229-1.408.35-.378.7-.757 1.049-1.137 6.259.028 12.518.059 18.777.088.516.391.862.897 1.043 1.519.203 2.146-.848 3.084-2.919 2.97-3.626-.201-7.285.482-10.882-.42z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8E8E8E"
        d="M305.029 380.975c-.104-.328-.207-.656-.313-.984 1.762-.395 2.29 1.157 3.233 2.055.042.307.124.602.245.886.092.972-.407 1.562-1.322 1.433-2.038-.29-.857-2.452-1.843-3.39z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#909090"
        d="M126.843 380.89c-1.372.14-.006 4.432-3.063 2.019.136-.287.259-.58.369-.878.881-.741 1.28-2.141 2.78-2.034a5.708 5.708 0 01-.086.893z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A5959"
        d="M242.074 384.087c-.03.278-.025.555.015.83l-18.99.142-.113-1.044 14.026-.015 3.043-.003 2.019.09z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B3B37"
        d="M265.059 384.079l-2.178-.089c-.909-1.202-1.763-2.414-.707-3.967.273.017.545.005.816-.034l18.07-.067 1.077 2.012c.716 1.775-.125 2.573-1.794 2.517-3.791-.128-7.613.541-11.372-.414l-3.912.042z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#848484"
        d="M262.174 380.023l.708 3.967L260 384c-.075-.944-.15-1.888-.227-2.831.54-.927 1.401-1.183 2.401-1.146z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#595858"
        d="M219.08 384.106c-.029.271-.022.539.019.807l-18.195.003c.04-.275.045-.55.014-.825l13.066-.092 1.099-.056c.522-.59 1.111-1.044 1.963-.96l2.034 1.123z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#949494"
        d="M217.046 382.983c-.43.779-1.135.997-1.963.961.114-1.546-.8-3.569 1.835-3.939l.128 2.978z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A5959"
        d="M177.908 384.91c.043-.271.047-.543.01-.814 4.64-.676 9.473 1.027 13.994-1.128.861-.078 1.466.37 1.997.971l1.098.062 2.007.014-.118 1.053-18.988-.158z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#949494"
        d="M193.908 383.938c-.843.042-1.556-.184-1.997-.971l.191-2.962c2.623.385 1.692 2.398 1.806 3.933zM170.919 383.915c-.746.021-1.454-.021-1.652-.95l1.177-1.988c1.21.809.281 1.964.475 2.938z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A5959"
        d="M268.971 384.036c3.118-.012 6.236-.022 9.354-.035 1.64-.006 3.411.229 3.81-2.066.268.039.535.072.803.099.764.218 1.504.045 2.245-.131.896.826 1.361 2.216 2.893 2.208-.031.262-.026.521.018.78l-18.994.192-.129-1.047z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8F8F8F"
        d="M285.184 381.902c-.264.705-.132 1.859-1.295 1.648-.395-.071-.637-.987-.949-1.518.026-1.556.724-1.792 1.95-.994.08.295.179.583.294.864z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B5A5A"
        d="M305.029 380.975c1.42.063.224 4.356 3.165 1.956.958.396 1.915.79 2.872 1.187-.027.256-.023.51.016.763-6.326.071-12.653.143-18.979.216l-.146-1.036c3.267-.019 6.537-.135 9.799-.022 2.265.076 3.402-.737 3.273-3.064z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3CDA4"
        d="M325.004 264.998c2.348 2.532 1.303 4.944-1.193 5.915-2.344.911-5.249 3.962-7.832.061-.007-4.012 2.926-5.07 6.008-5.98l3.017.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CBB082"
        d="M321.986 264.993c-2.037 1.959-4.584 3.405-6.008 5.981l-6.024 5.022c-.896-.008-1.673-.217-2.017-1.173 1.355-2.229 5.013-2.443 5.078-5.802 3.152-1.714 4.154-5.86 7.862-6.945.176 1.047-.029 2.237 1.109 2.917z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D6C099"
        d="M320.878 262.077c-2.49 2.462-3.604 6.482-7.862 6.945.919-3.741 5.886-5.466 5.03-10.093 1.86.225 2.392 1.645 2.832 3.148z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D6C099"
        d="M318.069 258.932c-1.678.938-3.021.579-4.038-1.043 1.791.393 2.949-.509 3.87-1.894l.168 2.937z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5E6D3"
        d="M301.915 259.864c1.7-2.302 3.83-4.16 6.084-5.892 1.072.186 2.283-.171 3.153.807l-1.175 3.224c-3.303 4.562-5.548 5.081-8.062 1.861z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C7AE83"
        d="M317.056 286.023a4651.19 4651.19 0 01-1.224 4.175c-1.606-1.639.869-6.025-3.781-5.614 1.194-2.521 4.515-2.313 5.896-4.594 2.237-4.186 6.842-5.814 9.897-9.146 1.478-1.61 2.073.603 3.021 1.2-4.676 4.589-9.852 8.682-13.809 13.979z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C94549"
        d="M307.938 274.824l2.017 1.173c-.56 1.346-1.446 2.694.036 4.021 1.257 1.097 1.756 2.382.99 3.981-2.805.578-4.457 2.292-5.016 5.084-2.877-.498-4.01-2.719-5.007-5.073-1.664-2.258.52-3.137 1.638-4.272 1.694-1.722 3.552-3.284 5.342-4.914z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5C4B0"
        d="M310.98 284l-.99-3.981c2.187-4.707 2.187-4.707 7.957-.028.342 4.492-3.672 3.399-5.897 4.596-.357-.197-.713-.393-1.07-.587z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECE6E0"
        d="M333.178 219.619a2.384 2.384 0 00-.151-.634c-.741-4.081-1.287-8.146.972-11.984a6.457 6.457 0 012.994-3.011c-.534 5.984 1.176 12.089-.955 17.988l-2.86-2.359z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1E6E4"
        d="M333.998 207.001c-.489 3.981 1.053 8.127-.972 11.984l-2.891-2.379-3.116-3.662 6.979-5.943z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7D2AA"
        d="M300.958 284.011c2.352 1.018 3.299 3.421 5.007 5.073l1.146 4.673c.928 8.259-4.346 12.135-10.111 14.243-6.855-2.325-11.617-6.595-13.001-14 .31-2.004-.784-4.242 1-6.001 1.889.796 1.377 2.563 1.645 4.019-.019 1.79.765 3.284 1.745 4.708 1.185 1.602 2.261 3.313 3.736 4.643 3.156 2.843 8 1.343 8.928-2.794.857-3.828.932-7.567-2.103-10.715-.988-1.025-2.238-2.182-.953-3.857l2.961.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7E7E8"
        d="M91.8 298.913c-.475.404-.768.854-1.105.89-.392.042-1.08-.182-1.187-.463-.284-.745.266-1.189.963-1.169.376.011.74.396 1.329.742z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4D4D4"
        d="M210.127 206.943c3.59.262 6.037 2.396 6.152 5.479.125 3.361-2.878 5.3-6.028 5.392-3.113.091-5.988-1.379-6.173-5.069-.206-4.1 2.991-5.007 6.049-5.802z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D6D7D8"
        d="M302.07 220.942l-.034-3.876c2.743.063 6.18-1.407 6.902 3.123.392.157.526.325.408.508-.121.187-.244.281-.37.281l-6.906-.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C3C9CC"
        d="M308.977 220.979a5.214 5.214 0 00-.037-.791c2.018-2.988 2.018-2.988 2.963-1.158-.965.667-1.381 2.157-2.926 1.949z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9D6B2"
        d="M297.997 284.002c-.025 1.762 1.47 2.4 2.439 3.492 4.438 4.999 2.898 13.694-2.658 16.347-3.179 1.517-5.353.192-7.276-2.061-1.278-1.498-2.338-3.183-3.496-4.784 1.842-1.723 3.73-.383 5.581-.047 2.036.369 3.675-.104 4.416-2.138.772-2.119.968-4.259-1.395-5.633-2.13-1.238-4.425-2.187-6.438-3.645-.351-.384-.465-.832-.38-1.339 2.693-1.918 5.424-2.271 8.211-.195l.996.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEE0C6"
        d="M301.915 259.864c3.565 3.185 5.313-1.507 8.063-1.861 1.12.782.896 1.86.171 2.56-2.547 2.452-5.123 4.897-7.903 7.072-.967.756-2.708.796-3.7-.313-.975-1.092.048-2.105.636-3.11.401-.686.524-1.535.771-2.312l1.962-2.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9D6B2"
        d="M285.999 292c-1.636-1.008.204-2.885-1-4.001.017-1.434.685-2.433 2.001-2.999.666-.568 1.332-.618 1.999-.002l.002.003c1.726 3.503.109 5.571-3.002 6.999z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7D2AA"
        d="M288.999 284.998L287 285c3.328-3.857 6.281-4.152 10-1-2.814-.843-5.51-.746-8.001.998z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7A7A7A"
        d="M194.737 278.102c-2.806-.352-8.43 1.127-2.543-4.183.462-.418-.256-1.942.01-2.82.604-1.992 2.525-2.929 3.673-1.277 1.427 2.051 2.185 4.767 2.994 7.104.622 1.801-2.827.454-4.134 1.176z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBBFC6"
        d="M201.851 189.133c.066 1.59-1.055 2.196-2.159 2.256-1.278.068-2.816-.343-2.973-1.914-.144-1.439.754-2.441 2.376-2.448 1.5-.006 2.459.688 2.756 2.106z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BFC3CA"
        d="M118.984 190.926l-4.261-.289c-.342-5.244 3.886-.818 5.2-2.49.708 1.271-.128 2.021-.939 2.779z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8CBD1"
        d="M118.984 190.926l.939-2.78 3.073-.128c1.035.753 2.177 1.47.996 2.967l-5.008-.059z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BCC0C7"
        d="M130.204 186.576c1.174 1.184 2.914 1.52 2.66 3.141-.242 1.549-1.204-.036-1.806 0-1.813.11-1.029-1.425-.854-3.141z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0C4CA"
        d="M109.02 187.012l2.521 4.832-5.54-2.845c.775-1.012 2.071-1.235 3.019-1.987z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5D8DC"
        d="M123.992 190.984l-.996-2.967c1.346.018 2.684.925 4.039.04.551.679.538 1.339-.065 1.979-.993.318-1.986.633-2.978.948z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFEFF0"
        d="M109.02 187.012c-.132 1.991-1.545 2.037-3.02 1.987.148-1.967.86-3.077 3.02-1.987z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2C6CC"
        d="M126.97 190.037l.065-1.98c2.258-.159 1.459 1.629 1.252 2.459-.158.639-.986.098-1.317-.479z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7F6453"
        d="M268 323c1.354 1.65 1.955 3.901 3.997 5.002l.007 2.996c-.417 4.827-2.028 6.438-7.002 7.001H265c-4.038-.918-7.903-2.301-11.657-4.062-1.56-.731-3.015-1.711-1.393-3.147 2.801-2.479 4.341-5.873 7.354-8.358 3.792-3.126 5.969-2.281 8.696.568z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7B6050"
        d="M265.001 337.999c3.342-1.325 5.672-3.663 7.002-7.001 2.595 1.58 2.797 3.839.686 5.59-2.093 1.736-4.382 5.193-7.688 1.411z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBD9B8"
        d="M285.999 292c1.346-2.185 3.281-4.117 3.002-6.999 3.529-.039 6.194 2.324 8.877 3.927 2.568 1.533 1.043 4.989.12 7.264-.76 1.87-2.562 3.407-5.274 2.26-1.791-.757-3.804-.988-5.718-1.455-.623-1.608-2.2-3.023-1.007-4.997z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDBDBD"
        d="M209.965 215.995c-2.624.104-4.053-1.005-3.941-3.774.105-2.62 1.741-3.258 3.99-3.232 2.589.029 4.866.899 4.687 3.77-.157 2.487-2.346 3.328-4.736 3.236z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#846756"
        d="M270.023 330.78c-.388 2.81-2.042 4.203-4.299 4.564-1.912.307-8.036-5.232-7.616-6.729.852-3.039 2.872-4.754 6.197-4.608 4.598.201 4.411 4.198 5.718 6.773z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4A71A"
        d="M457.721 207.896l-3.648-10.023c-.356.592-.682 1.131-1.006 1.672-2.876 4.798-5.75 9.599-8.626 14.396-.121.201-.193.432-.372.596-.11.207-.225.41-.329.619-.075.15-.156.127-.221.006-.061-.113-.095-.242-.14-.363l-2.412-6.631-.139-.381-9.51 19.182-2.387-6.559-.074-.006-6.484 22.172.103.041c.477-.68.953-1.359 1.429-2.041 2.062-2.953 4.121-5.906 6.184-8.857.099-.141.184-.381.349-.359.168.023.161.285.22.443.475 1.285.941 2.574 1.41 3.863l.14.383c.472-.738.909-1.42 1.343-2.104 2.922-4.607 5.842-9.215 8.766-13.82.054-.084.064-.24.23-.215.17.053.16.221.205.342.765 2.086 1.521 4.174 2.281 6.26l.143.391c.383-.576.733-1.102 1.08-1.627l11.379-17.27c.023-.039.056-.072.086-.11zM404.953 140.811a91189.01 91189.01 0 00-8.05-6.998c-.024.69-.048 1.319-.069 1.95-.189 5.591-.375 11.183-.565 16.773-.008.235.041.471-.036.702.004.234.002.467.013.701.007.168-.075.187-.19.112-.108-.07-.2-.166-.299-.25l-5.324-4.63-.306-.266.981 21.387-5.267-4.579-.067.031c1.692 7.512 3.386 15.023 5.077 22.536l.109-.014c.088-.826.175-1.651.261-2.478.371-3.583.74-7.164 1.114-10.745.018-.171-.024-.422.13-.483.158-.061.279.171.407.281 1.038.894 2.071 1.795 3.106 2.695l.308.267c.055-.875.107-1.683.155-2.491.321-5.446.642-10.892.966-16.337.007-.1-.06-.241.098-.299.174-.037.247.115.345.199 1.681 1.454 3.354 2.913 5.03 4.369.087.074.174.149.314.272.055-.689.107-1.319.155-1.947l1.58-20.621c.004-.045.017-.091.024-.137zM435.491 179.037c-1.379-3.252-2.756-6.5-4.167-9.818l-.918 1.722c-2.621 4.942-5.238 9.886-7.858 14.827-.112.209-.172.442-.342.615-.1.211-.203.421-.296.635-.066.154-.149.135-.221.018-.066-.111-.107-.236-.158-.355a11442.163 11442.163 0 00-2.914-6.869l-8.493 19.655c-.925-2.179-1.824-4.303-2.728-6.425-.023-.003-.05-.003-.072-.004-1.773 7.494-3.544 14.989-5.315 22.481.035.012.07.023.103.037.442-.705.881-1.41 1.32-2.115 1.905-3.057 3.807-6.111 5.713-9.166.09-.146.163-.391.328-.379.169.014.177.275.243.432.541 1.26 1.075 2.521 1.61 3.783l.16.375c.433-.76.832-1.465 1.23-2.17 2.677-4.754 5.351-9.508 8.03-14.261.051-.085.053-.242.218-.226.173.044.172.213.223.33.874 2.044 1.74 4.09 2.606 6.133.047.104.09.21.164.383.35-.596.675-1.14.993-1.683 3.484-5.945 6.973-11.894 10.459-17.841.025-.041.056-.076.082-.114z"
      />
      <g fillRule="evenodd" clipRule="evenodd">
        <path
        className="imanSvg2"
          fill="#0449F9"
          d="M484.509 80.299c3.84 9.106-.314 19.278-9.438 23.107-9.165 3.846-19.382-.418-23.264-9.708-3.709-8.878.499-19.162 9.411-22.994 9.11-3.918 19.377.312 23.291 9.595z"
        />
        <path
        className="imanSvg2"
          fill="#FEFDFD"
          d="M466.445 83.332c3.243-3.183 7.152-.542 11.037.193.283.053.639.392.724.671.167.544-.319.792-.731.965-.839.351-1.686.893-2.547.931-2.646.116-2.358 1.39-1.492 3.134.564 1.136.943 2.364 1.425 3.541.422 1.03.337 1.888-.545 2.697-.85.778-1.679 1.507-2.872.882-1.587-.832-3.127-1.208-4.945-.627-1.266.404-1.939-.643-2.393-1.722-.881-2.097-1.681-4.234-2.696-6.263-.761-1.523-.475-2.294 1.149-2.779 1.125-.336 2.183-.899 3.886-1.623z"
        />
        <path
        className="imanSvg2"
          fill="#FDF7FA"
          d="M464.898 82.456c-.836.354-1.704.646-2.498 1.076-1.5.812-2.423.888-3.288-1.051-.941-2.112.428-2.255 1.638-2.771 1.836-.782 3.708-1.49 5.499-2.362 1.318-.641 2.056-.546 2.635.965.526 1.372.827 2.359-.974 2.89-1.037.306-2.01.828-3.012 1.253z"
        />
      </g>
      <g fillRule="evenodd" clipRule="evenodd">
        <path
        className="imanSvg3"
          fill="#FDBE42"
          d="M497.004 145.766c-1.119-6.043-6.952-10.717-12.867-10.311.965 1.527 3.256 2.621 1.727 4.98-.884 1.365-6.881 2.807-8.238 2.048-.845-.473-1.017-1.302-1.194-2.153-.267-1.279-.059-2.739-1.33-3.655-6.963 4.75-9.705 11.296-7.621 18.196 2.009 6.654 8.037 11.204 15.072 11.372 6.655.16 12.465-4.188 15.118-11.313-.766-.843-1.778-.675-2.749-.666-1.54.014-3.512.646-3.9-1.609-.456-2.654-.745-5.509 1.356-7.661 1.681-1.721 3.093.374 4.626.772z"
        />
        <path
        className="imanSvg3"
          fill="#E30113"
          d="M497.004 145.766c-1.032-1.577-2.136-3.272-4.353-2.521-1.982.673-2.467 2.541-2.698 4.439-.929 7.628-.425 8.105 7.717 7.247.982-.478 2.046-.835 2.929-1.455 2.322-1.631 2.203-4.23-.334-5.516-1.205-.612-2.375-1.159-3.261-2.194zM475.101 136.675c.034.118.091.233.1.353.593 7.281 1.656 7.98 8.64 5.654 1.798-.599 3.5-1.396 3.71-3.56.232-2.392-1.653-3.002-3.404-3.665-1.268.102-1.655-.88-2.044-1.738-.716-1.583-1.763-2.668-3.608-2.423-2.044.272-2.638 1.883-3.014 3.613-.128.59-.254 1.177-.38 1.766z"
        />
        <path
        className="imanSvg3"

          fill="#F5F9F9"
          d="M480.101 152.495c-1.986-1.609-3.994-3.191-5.951-4.835-1.206-1.014-2.063-1.33-2.454.674-.835 4.292.085 8.146 3.41 10.99 3.335 2.852 7.297 3.056 11.393 1.592 2.078-.743 1.624-1.728.346-2.788-2.252-1.872-4.544-3.694-6.82-5.537.025-.032.049-.065.076-.096z"
        />
      </g>
      <path
        className="imanSvg3"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7433EF"
        d="M570.839 138.98l-15.989-12.948c-.807 5.412-.409 10.529-.552 15.611-.041 1.534.937 1.215 1.903.972 4.628-1.167 9.265-2.304 14.638-3.635zM552.187 145.485l.289-21.179-.948-.468c-3.531 3.453-6.466 7.458-9.403 11.433-.691.936-.04 2.036.876 2.777 2.855 2.307 5.708 4.62 9.186 7.437zM572.425 140.673l-19.998 4.953c3.43 2.778 6.238 5.081 9.082 7.339 1.086.863 1.978.356 2.736-.581 2.915-3.604 5.834-7.207 8.751-10.809l-.571-.902z"
      />
      <path
        className="imanSvg2"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E63946"
        d="M551.18 29.948l-24.229-19.62c-1.223 8.2-.62 15.955-.836 23.655-.063 2.324 1.419 1.842 2.884 1.474 7.013-1.77 14.039-3.493 22.181-5.509zM522.916 39.805c.158-11.481.299-21.787.438-32.092l-1.437-.709c-5.351 5.231-9.798 11.302-14.249 17.324-1.048 1.418-.061 3.084 1.327 4.208 4.329 3.497 8.651 7.001 13.921 11.269zM553.583 32.515c-9.577 2.37-19.156 4.744-30.304 7.504 5.197 4.21 9.453 7.699 13.763 11.12 1.646 1.309 2.996.539 4.146-.881 4.418-5.461 8.841-10.919 13.261-16.379l-.866-1.364z"
      />
      <g fillRule="evenodd" clipRule="evenodd">
        <path
        className="imanSvg"
          fill="#E30113"
          d="M540.376 76.022c8.429 5.296 10.877 16.087 5.563 24.518-5.34 8.469-16.233 10.853-24.803 5.431-8.191-5.182-10.659-16.099-5.52-24.409 5.252-8.496 16.167-10.937 24.76-5.54z"
        />
        <path
         className="imanSvg"
          fill="#FFF"
          d="M522.208 81.981c-1.539 2.765-1.16 6.353-.541 9.954 2.006 11.676.397 10.34 11.739 7.783 3.024-.681 5.812-1.914 8.256-3.97 2.03-1.708 2.565-3.738 1.906-6.108-.634-2.277-2.225-3.771-4.657-3.755-3.33.022-5.263-1.589-6.982-4.344-2.283-3.657-7.094-3.568-9.721.44z"
        />
      </g>
    </Svg>
  )
}

export default SvgComponent
